(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireda16"];
var parcelRegister = parcelRequire.register;
parcelRegister("9JLuv", function(module, exports) {

$parcel$export(module.exports, "Else", function () { return $716d27c269421560$export$ffddce5cd29a79b2; });
$parcel$export(module.exports, "Then", function () { return $716d27c269421560$export$6a811f52dd5148fc; });
$parcel$export(module.exports, "If", function () { return $716d27c269421560$export$1f9ff5f4a6c9361a; });

var $gfRPo = parcelRequire("gfRPo");

var $g85JO = parcelRequire("g85JO");
/**
 * Renders a React component while also checking whether the children are a function or not
 * @param props Props of the component to render
 */ var $716d27c269421560$var$render = function render(props) {
    if (typeof props.children === "function") return (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $g85JO.Fragment), null, props.children());
    return (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $g85JO.Fragment), null, props.children || null);
};
/**
 * If the `<Case />` is the first one to have its condition evaluates to true
 * inside the parent `<Switch />` it will be the only rendered.
 * @param props The props to pass down to the `<Case />` component
 */ var $716d27c269421560$export$aab690d4858ddaa = function Case(props) {
    return $716d27c269421560$var$render(props);
};
$716d27c269421560$export$aab690d4858ddaa.defaultProps = {
    children: null
};
/**
 * If no `<Case />` have its condition evaluates to true inside the parent `<Switch />`,
 * the first `<Default />` will be the only one rendered.
 * @param props The props to pass down to the `<Default />` component
 */ var $716d27c269421560$export$39bcc3f08a9b5fa4 = function Default(props) {
    return $716d27c269421560$var$render(props);
};
$716d27c269421560$export$39bcc3f08a9b5fa4.defaultProps = {
    children: null
};
/**
 * Must only contain a single child, which it renders as-is.
 * Should not be used outside of an `<If />` block.
 * @param props The props to pass down to the `<Else />` component
 */ var $716d27c269421560$export$ffddce5cd29a79b2 = function Else(props) {
    return $716d27c269421560$var$render(props);
};
/**
 * Must contain only a single child, which it renders as-is.
 * Should not be used outside of an `<If />` block whose condition prop is a promise.
 * @param props The props to pass down to the `<Fallback />` component
 */ var $716d27c269421560$export$fb8d7f40caaeea67 = function Fallback(props) {
    return $716d27c269421560$var$render(props);
};
/**
 * Resolves a condition that is {@link BooleanLike} or returns {@link BooleanLike} from a function
 * @param condition The condition to resolve
 */ var $716d27c269421560$var$getConditionResult = function getConditionResult(condition) {
    var conditionResult = Boolean(typeof condition === "function" ? condition() : condition);
    return conditionResult;
};
function $716d27c269421560$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $716d27c269421560$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $716d27c269421560$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $716d27c269421560$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function $716d27c269421560$var$_extends() {
    $716d27c269421560$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $716d27c269421560$var$_extends.apply(this, arguments);
}
function $716d27c269421560$var$createCommonjsModule(fn, module) {
    return module = {
        exports: {}
    }, fn(module, module.exports), module.exports;
}
var $716d27c269421560$var$runtime_1 = $716d27c269421560$var$createCommonjsModule(function(module) {
    /**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var runtime = function(exports) {
        var Op = Object.prototype;
        var hasOwn = Op.hasOwnProperty;
        var undefined$1; // More compressible than void 0.
        var $Symbol = typeof Symbol === "function" ? Symbol : {};
        var iteratorSymbol = $Symbol.iterator || "@@iterator";
        var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
        var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
        function define(obj, key, value) {
            Object.defineProperty(obj, key, {
                value: value,
                enumerable: true,
                configurable: true,
                writable: true
            });
            return obj[key];
        }
        try {
            // IE 8 has a broken Object.defineProperty that only works on DOM objects.
            define({}, "");
        } catch (err) {
            define = function define(obj, key, value) {
                return obj[key] = value;
            };
        }
        function wrap(innerFn, outerFn, self, tryLocsList) {
            // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
            var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
            var generator = Object.create(protoGenerator.prototype);
            var context = new Context(tryLocsList || []);
            // The ._invoke method unifies the implementations of the .next,
            // .throw, and .return methods.
            generator._invoke = makeInvokeMethod(innerFn, self, context);
            return generator;
        }
        exports.wrap = wrap;
        // Try/catch helper to minimize deoptimizations. Returns a completion
        // record like context.tryEntries[i].completion. This interface could
        // have been (and was previously) designed to take a closure to be
        // invoked without arguments, but in all the cases we care about we
        // already have an existing method we want to call, so there's no need
        // to create a new function object. We can even get away with assuming
        // the method takes exactly one argument, since that happens to be true
        // in every case, so we don't have to touch the arguments object. The
        // only additional allocation required is the completion record, which
        // has a stable shape and so hopefully should be cheap to allocate.
        function tryCatch(fn, obj, arg) {
            try {
                return {
                    type: "normal",
                    arg: fn.call(obj, arg)
                };
            } catch (err) {
                return {
                    type: "throw",
                    arg: err
                };
            }
        }
        var GenStateSuspendedStart = "suspendedStart";
        var GenStateSuspendedYield = "suspendedYield";
        var GenStateExecuting = "executing";
        var GenStateCompleted = "completed";
        // Returning this object from the innerFn has the same effect as
        // breaking out of the dispatch switch statement.
        var ContinueSentinel = {};
        // Dummy constructor functions that we use as the .constructor and
        // .constructor.prototype properties for functions that return Generator
        // objects. For full spec compliance, you may wish to configure your
        // minifier not to mangle the names of these two functions.
        function Generator() {}
        function GeneratorFunction() {}
        function GeneratorFunctionPrototype() {}
        // This is a polyfill for %IteratorPrototype% for environments that
        // don't natively support it.
        var IteratorPrototype = {};
        define(IteratorPrototype, iteratorSymbol, function() {
            return this;
        });
        var getProto = Object.getPrototypeOf;
        var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
        if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
        // of the polyfill.
        IteratorPrototype = NativeIteratorPrototype;
        var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
        GeneratorFunction.prototype = GeneratorFunctionPrototype;
        define(Gp, "constructor", GeneratorFunctionPrototype);
        define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
        GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
        // Helper for defining the .next, .throw, and .return methods of the
        // Iterator interface in terms of a single ._invoke method.
        function defineIteratorMethods(prototype) {
            [
                "next",
                "throw",
                "return"
            ].forEach(function(method) {
                define(prototype, method, function(arg) {
                    return this._invoke(method, arg);
                });
            });
        }
        exports.isGeneratorFunction = function(genFun) {
            var ctor = typeof genFun === "function" && genFun.constructor;
            return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
            // do is to check its .name property.
            (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
        };
        exports.mark = function(genFun) {
            if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
            else {
                genFun.__proto__ = GeneratorFunctionPrototype;
                define(genFun, toStringTagSymbol, "GeneratorFunction");
            }
            genFun.prototype = Object.create(Gp);
            return genFun;
        };
        // Within the body of any async function, `await x` is transformed to
        // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
        // `hasOwn.call(value, "__await")` to determine if the yielded value is
        // meant to be awaited.
        exports.awrap = function(arg) {
            return {
                __await: arg
            };
        };
        function AsyncIterator(generator, PromiseImpl) {
            function invoke(method, arg, resolve, reject) {
                var record = tryCatch(generator[method], generator, arg);
                if (record.type === "throw") reject(record.arg);
                else {
                    var result = record.arg;
                    var value = result.value;
                    if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                        invoke("next", value, resolve, reject);
                    }, function(err) {
                        invoke("throw", err, resolve, reject);
                    });
                    return PromiseImpl.resolve(value).then(function(unwrapped) {
                        // When a yielded Promise is resolved, its final value becomes
                        // the .value of the Promise<{value,done}> result for the
                        // current iteration.
                        result.value = unwrapped;
                        resolve(result);
                    }, function(error) {
                        // If a rejected Promise was yielded, throw the rejection back
                        // into the async generator function so it can be handled there.
                        return invoke("throw", error, resolve, reject);
                    });
                }
            }
            var previousPromise;
            function enqueue(method, arg) {
                function callInvokeWithMethodAndArg() {
                    return new PromiseImpl(function(resolve, reject) {
                        invoke(method, arg, resolve, reject);
                    });
                }
                return previousPromise = // If enqueue has been called before, then we want to wait until
                // all previous Promises have been resolved before calling invoke,
                // so that results are always delivered in the correct order. If
                // enqueue has not been called before, then it is important to
                // call invoke immediately, without waiting on a callback to fire,
                // so that the async generator function has the opportunity to do
                // any necessary setup in a predictable way. This predictability
                // is why the Promise constructor synchronously invokes its
                // executor callback, and why async functions synchronously
                // execute code before the first await. Since we implement simple
                // async functions in terms of async generators, it is especially
                // important to get this right, even though it requires care.
                previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
                // invocations of the iterator.
                callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
            // Define the unified helper method that is used to implement .next,
            // .throw, and .return (see defineIteratorMethods).
            this._invoke = enqueue;
        }
        defineIteratorMethods(AsyncIterator.prototype);
        define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
            return this;
        });
        exports.AsyncIterator = AsyncIterator;
        // Note that simple async functions are implemented on top of
        // AsyncIterator objects; they just return a Promise for the value of
        // the final result produced by the iterator.
        exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
            if (PromiseImpl === void 0) PromiseImpl = Promise;
            var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
            return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
             : iter.next().then(function(result) {
                return result.done ? result.value : iter.next();
            });
        };
        function makeInvokeMethod(innerFn, self, context) {
            var state = GenStateSuspendedStart;
            return function invoke(method, arg) {
                if (state === GenStateExecuting) throw new Error("Generator is already running");
                if (state === GenStateCompleted) {
                    if (method === "throw") throw arg;
                    // Be forgiving, per 25.3.3.3.3 of the spec:
                    // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                    return doneResult();
                }
                context.method = method;
                context.arg = arg;
                while(true){
                    var delegate = context.delegate;
                    if (delegate) {
                        var delegateResult = maybeInvokeDelegate(delegate, context);
                        if (delegateResult) {
                            if (delegateResult === ContinueSentinel) continue;
                            return delegateResult;
                        }
                    }
                    if (context.method === "next") // Setting context._sent for legacy support of Babel's
                    // function.sent implementation.
                    context.sent = context._sent = context.arg;
                    else if (context.method === "throw") {
                        if (state === GenStateSuspendedStart) {
                            state = GenStateCompleted;
                            throw context.arg;
                        }
                        context.dispatchException(context.arg);
                    } else if (context.method === "return") context.abrupt("return", context.arg);
                    state = GenStateExecuting;
                    var record = tryCatch(innerFn, self, context);
                    if (record.type === "normal") {
                        // If an exception is thrown from innerFn, we leave state ===
                        // GenStateExecuting and loop back for another invocation.
                        state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                        if (record.arg === ContinueSentinel) continue;
                        return {
                            value: record.arg,
                            done: context.done
                        };
                    } else if (record.type === "throw") {
                        state = GenStateCompleted;
                        // Dispatch the exception by looping back around to the
                        // context.dispatchException(context.arg) call above.
                        context.method = "throw";
                        context.arg = record.arg;
                    }
                }
            };
        }
        // Call delegate.iterator[context.method](context.arg) and handle the
        // result, either by returning a { value, done } result from the
        // delegate iterator, or by modifying context.method and context.arg,
        // setting context.delegate to null, and returning the ContinueSentinel.
        function maybeInvokeDelegate(delegate, context) {
            var method = delegate.iterator[context.method];
            if (method === undefined$1) {
                // A .throw or .return when the delegate iterator has no .throw
                // method always terminates the yield* loop.
                context.delegate = null;
                if (context.method === "throw") {
                    // Note: ["return"] must be used for ES3 parsing compatibility.
                    if (delegate.iterator["return"]) {
                        // If the delegate iterator has a return method, give it a
                        // chance to clean up.
                        context.method = "return";
                        context.arg = undefined$1;
                        maybeInvokeDelegate(delegate, context);
                        if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                        // "return" to "throw", let that override the TypeError below.
                        return ContinueSentinel;
                    }
                    context.method = "throw";
                    context.arg = new TypeError("The iterator does not provide a 'throw' method");
                }
                return ContinueSentinel;
            }
            var record = tryCatch(method, delegate.iterator, context.arg);
            if (record.type === "throw") {
                context.method = "throw";
                context.arg = record.arg;
                context.delegate = null;
                return ContinueSentinel;
            }
            var info = record.arg;
            if (!info) {
                context.method = "throw";
                context.arg = new TypeError("iterator result is not an object");
                context.delegate = null;
                return ContinueSentinel;
            }
            if (info.done) {
                // Assign the result of the finished delegate to the temporary
                // variable specified by delegate.resultName (see delegateYield).
                context[delegate.resultName] = info.value;
                // Resume execution at the desired location (see delegateYield).
                context.next = delegate.nextLoc;
                // If context.method was "throw" but the delegate handled the
                // exception, let the outer generator proceed normally. If
                // context.method was "next", forget context.arg since it has been
                // "consumed" by the delegate iterator. If context.method was
                // "return", allow the original .return call to continue in the
                // outer generator.
                if (context.method !== "return") {
                    context.method = "next";
                    context.arg = undefined$1;
                }
            } else // Re-yield the result returned by the delegate method.
            return info;
            // The delegate iterator is finished, so forget it and continue with
            // the outer generator.
            context.delegate = null;
            return ContinueSentinel;
        }
        // Define Generator.prototype.{next,throw,return} in terms of the
        // unified ._invoke helper method.
        defineIteratorMethods(Gp);
        define(Gp, toStringTagSymbol, "Generator");
        // A Generator should always return itself as the iterator object when the
        // @@iterator function is called on it. Some browsers' implementations of the
        // iterator prototype chain incorrectly implement this, causing the Generator
        // object to not be returned from this call. This ensures that doesn't happen.
        // See https://github.com/facebook/regenerator/issues/274 for more details.
        define(Gp, iteratorSymbol, function() {
            return this;
        });
        define(Gp, "toString", function() {
            return "[object Generator]";
        });
        function pushTryEntry(locs) {
            var entry = {
                tryLoc: locs[0]
            };
            if (1 in locs) entry.catchLoc = locs[1];
            if (2 in locs) {
                entry.finallyLoc = locs[2];
                entry.afterLoc = locs[3];
            }
            this.tryEntries.push(entry);
        }
        function resetTryEntry(entry) {
            var record = entry.completion || {};
            record.type = "normal";
            delete record.arg;
            entry.completion = record;
        }
        function Context(tryLocsList) {
            // The root entry object (effectively a try statement without a catch
            // or a finally block) gives us a place to store values thrown from
            // locations where there is no enclosing try statement.
            this.tryEntries = [
                {
                    tryLoc: "root"
                }
            ];
            tryLocsList.forEach(pushTryEntry, this);
            this.reset(true);
        }
        exports.keys = function(object) {
            var keys = [];
            for(var key in object)keys.push(key);
            keys.reverse();
            // Rather than returning an object with a next method, we keep
            // things simple and return the next function itself.
            return function next() {
                while(keys.length){
                    var key = keys.pop();
                    if (key in object) {
                        next.value = key;
                        next.done = false;
                        return next;
                    }
                }
                // To avoid creating an additional object, we just hang the .value
                // and .done properties off the next function object itself. This
                // also ensures that the minifier will not anonymize the function.
                next.done = true;
                return next;
            };
        };
        function values(iterable) {
            if (iterable) {
                var iteratorMethod = iterable[iteratorSymbol];
                if (iteratorMethod) return iteratorMethod.call(iterable);
                if (typeof iterable.next === "function") return iterable;
                if (!isNaN(iterable.length)) {
                    var i = -1, next = function next() {
                        while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                            next.value = iterable[i];
                            next.done = false;
                            return next;
                        }
                        next.value = undefined$1;
                        next.done = true;
                        return next;
                    };
                    return next.next = next;
                }
            }
            // Return an iterator with no values.
            return {
                next: doneResult
            };
        }
        exports.values = values;
        function doneResult() {
            return {
                value: undefined$1,
                done: true
            };
        }
        Context.prototype = {
            constructor: Context,
            reset: function reset(skipTempReset) {
                this.prev = 0;
                this.next = 0;
                // Resetting context._sent for legacy support of Babel's
                // function.sent implementation.
                this.sent = this._sent = undefined$1;
                this.done = false;
                this.delegate = null;
                this.method = "next";
                this.arg = undefined$1;
                this.tryEntries.forEach(resetTryEntry);
                if (!skipTempReset) {
                    for(var name in this)// Not sure about the optimal order of these conditions:
                    if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined$1;
                }
            },
            stop: function stop() {
                this.done = true;
                var rootEntry = this.tryEntries[0];
                var rootRecord = rootEntry.completion;
                if (rootRecord.type === "throw") throw rootRecord.arg;
                return this.rval;
            },
            dispatchException: function dispatchException(exception) {
                if (this.done) throw exception;
                var context = this;
                function handle(loc, caught) {
                    record.type = "throw";
                    record.arg = exception;
                    context.next = loc;
                    if (caught) {
                        // If the dispatched exception was caught by a catch block,
                        // then let that catch block handle the exception normally.
                        context.method = "next";
                        context.arg = undefined$1;
                    }
                    return !!caught;
                }
                for(var i = this.tryEntries.length - 1; i >= 0; --i){
                    var entry = this.tryEntries[i];
                    var record = entry.completion;
                    if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                    // it, so set the completion value of the entire function to
                    // throw the exception.
                    return handle("end");
                    if (entry.tryLoc <= this.prev) {
                        var hasCatch = hasOwn.call(entry, "catchLoc");
                        var hasFinally = hasOwn.call(entry, "finallyLoc");
                        if (hasCatch && hasFinally) {
                            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                            else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                        } else if (hasCatch) {
                            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        } else if (hasFinally) {
                            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                        } else throw new Error("try statement without catch or finally");
                    }
                }
            },
            abrupt: function abrupt(type, arg) {
                for(var i = this.tryEntries.length - 1; i >= 0; --i){
                    var entry = this.tryEntries[i];
                    if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                        var finallyEntry = entry;
                        break;
                    }
                }
                if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
                // location outside the try/catch block.
                finallyEntry = null;
                var record = finallyEntry ? finallyEntry.completion : {};
                record.type = type;
                record.arg = arg;
                if (finallyEntry) {
                    this.method = "next";
                    this.next = finallyEntry.finallyLoc;
                    return ContinueSentinel;
                }
                return this.complete(record);
            },
            complete: function complete(record, afterLoc) {
                if (record.type === "throw") throw record.arg;
                if (record.type === "break" || record.type === "continue") this.next = record.arg;
                else if (record.type === "return") {
                    this.rval = this.arg = record.arg;
                    this.method = "return";
                    this.next = "end";
                } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
                return ContinueSentinel;
            },
            finish: function finish(finallyLoc) {
                for(var i = this.tryEntries.length - 1; i >= 0; --i){
                    var entry = this.tryEntries[i];
                    if (entry.finallyLoc === finallyLoc) {
                        this.complete(entry.completion, entry.afterLoc);
                        resetTryEntry(entry);
                        return ContinueSentinel;
                    }
                }
            },
            "catch": function(tryLoc) {
                for(var i = this.tryEntries.length - 1; i >= 0; --i){
                    var entry = this.tryEntries[i];
                    if (entry.tryLoc === tryLoc) {
                        var record = entry.completion;
                        if (record.type === "throw") {
                            var thrown = record.arg;
                            resetTryEntry(entry);
                        }
                        return thrown;
                    }
                }
                // The context.catch method must only be called with a location
                // argument that corresponds to a known catch block.
                throw new Error("illegal catch attempt");
            },
            delegateYield: function delegateYield(iterable, resultName, nextLoc) {
                this.delegate = {
                    iterator: values(iterable),
                    resultName: resultName,
                    nextLoc: nextLoc
                };
                if (this.method === "next") // Deliberately forget the last sent value so that we don't
                // accidentally pass it on to the delegate.
                this.arg = undefined$1;
                return ContinueSentinel;
            }
        };
        // Regardless of whether this script is executing as a CommonJS module
        // or not, return the runtime object so that we can declare the variable
        // regeneratorRuntime in the outer scope, which allows this module to be
        // injected easily by `bin/regenerator --include-runtime script.js`.
        return exports;
    }(// If this script is executing as a CommonJS module, use module.exports
    // as the regeneratorRuntime namespace. Otherwise create a new empty
    // object. Either way, the resulting object will be used to initialize
    // the regeneratorRuntime variable at the top of this file.
    module.exports);
    try {
        regeneratorRuntime = runtime;
    } catch (accidentalStrictMode) {
        // This module should not be running in strict mode, so the above
        // assignment should always work unless something is misconfigured. Just
        // in case runtime.js accidentally runs in strict mode, in modern engines
        // we can explicitly access globalThis. In older engines we can escape
        // strict mode using a global Function call. This could conceivably fail
        // if a Content Security Policy forbids using Function, but in that case
        // the proper solution is to fix the accidental strict mode problem. If
        // you've misconfigured your bundler to force strict mode and applied a
        // CSP to forbid Function, and you're not willing to fix either of those
        // problems, please detail your unique predicament in a GitHub issue.
        if (typeof globalThis === "object") globalThis.regeneratorRuntime = runtime;
        else Function("r", "regeneratorRuntime = r")(runtime);
    }
});
/**
 * The MIT License (MIT)
 *
 * Copyright © `2020` `The Sapphire Community and its contributors`
 *
 * Source: https://github.com/sapphiredev/utilities/blob/main/packages/utilities/src/lib/isThenable.ts
 * Full license: https://github.com/sapphiredev/utilities/blob/main/LICENSE.md
 */ /**
 * Verify if the input is a function.
 * @param input The function to verify
 */ function $716d27c269421560$var$isFunction(input) {
    return typeof input === "function";
}
function $716d27c269421560$var$hasThen(input) {
    return Reflect.has(input, "then") && $716d27c269421560$var$isFunction(input.then);
}
function $716d27c269421560$var$hasCatch(input) {
    return Reflect.has(input, "catch") && $716d27c269421560$var$isFunction(input["catch"]);
}
/**
 * Verify if an object is a promise.
 * @param input The promise to verify
 */ function $716d27c269421560$var$isThenable(input) {
    if (typeof input !== "object" || input === null) return false;
    return input instanceof Promise || input !== Promise.prototype && $716d27c269421560$var$hasThen(input) && $716d27c269421560$var$hasCatch(input);
}
/**
 * Compare two arrays without checking for possible nested properties
 * @param a Array to compare with b
 * @param b Array to compare with a
 * @returns True if arrays are identical, false if they are different
 */ var $716d27c269421560$var$shallowArraysEqual = function shallowArraysEqual(a, b) {
    if (!Array.isArray(a) || !Array.isArray(b)) throw new Error("shallowArraysEqual only accepts arrays as parameters");
    if (a.length !== b.length) return false;
    for(var i = 0; i < a.length; ++i){
        if (a[i] !== b[i]) return false;
    }
    return true;
};
/**
 * Create a CancellablePromise from a native Promise
 * @param promise The promise object to wrap
 * @returns Return value is an object of type CancellablePromise, with 2 properties:
 * - promise: a promise that can be left pending
 * - cancel: the function to use for cancelling the returned promise
 */ var $716d27c269421560$var$createCancellablePromise = function createCancellablePromise(promise) {
    if (!$716d27c269421560$var$isThenable(promise)) throw new Error("Argument of createCancellablePromise should be a Promise");
    var isCancelled = {
        value: false
    };
    var wrappedPromise = new Promise(/*#__PURE__*/ function() {
        var _ref = $716d27c269421560$var$_asyncToGenerator(/*#__PURE__*/ $716d27c269421560$var$runtime_1.mark(function _callee(res, rej) {
            var d;
            return $716d27c269421560$var$runtime_1.wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return promise;
                    case 3:
                        d = _context.sent;
                        return _context.abrupt("return", !isCancelled.value && res(d));
                    case 7:
                        _context.prev = 7;
                        _context.t0 = _context["catch"](0);
                        !isCancelled.value && rej(_context.t0);
                    case 10:
                    case "end":
                        return _context.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function(_x, _x2) {
            return _ref.apply(this, arguments);
        };
    }()); // Forward potential additional properties
    Object.keys(promise).forEach(function(key) {
        wrappedPromise[key] = promise[key];
    });
    return {
        promise: wrappedPromise,
        cancel: function cancel() {
            isCancelled.value = true;
        }
    };
};
/**
 * Calls a function only once during component lifecycle;
 * When dependency array is provided, will call the function again if at least one of the dependencies changed
 * @param callback The function to execute only once
 * @param dependencies A list of dependencies whose value, if changed since last call,
 * will trigger the execution of the callback
 */ var $716d27c269421560$var$useSingleton = function useSingleton(callback, dependencies) {
    if (dependencies === void 0) dependencies = [];
    var hasRan = (0, $g85JO.useRef)(false);
    var lastDependencies = (0, $g85JO.useRef)([]); // Parameters type check
    if (typeof callback !== "function") throw new Error("Incorrect callback parameter for useSingleton hook; expected a function, but got: '" + (typeof callback === "undefined" ? "undefined" : (0, $gfRPo._)(callback)) + "'.");
    if (!Array.isArray(dependencies)) throw new Error("Incorrect dependencies parameter for useSingleton; expected an array, but got: '" + (typeof dependencies === "undefined" ? "undefined" : (0, $gfRPo._)(dependencies)) + "'.");
    var hasDependencies = Array.isArray(dependencies) && dependencies.length > 0;
    if (hasDependencies) {
        // Has dependencies
        var hasAnyDependencyChanged = !$716d27c269421560$var$shallowArraysEqual(lastDependencies.current, dependencies);
        if (hasAnyDependencyChanged) // Any dep has changed => overwrite last dependencies and execute callback
        lastDependencies.current = dependencies;
        else if (hasRan.current) // No dep has changed => same behaviour as if no dependencies
        return;
    } else if (hasRan.current) // No dependencies
    return;
    callback();
    hasRan.current = true;
};
/**
 * Must contain only a single child, which it renders as-is.
 * Should not be used outside of an `<If />` block.
 * @param props The props to pass down to the `<Then />` component
 */ var $716d27c269421560$export$6a811f52dd5148fc = function Then(props) {
    return $716d27c269421560$var$render(props);
};
/**
 * Is included in the `<If />` component, rendered when the condition prop of `<If />` is a Promise;
 * Renders the Fallback component, if contains any, until provided promise is fulfilled;
 * Renders `<Then />` when promise is fulfilled, `<Else />` when rejected
 */ function $716d27c269421560$var$IfAsync(_ref) {
    var promise = _ref.promise, _ref$keepAlive = _ref.keepAlive, keepAlive = _ref$keepAlive === void 0 ? false : _ref$keepAlive, children = _ref.children;
    var _useState = (0, $g85JO.useState)(null), isResolved = _useState[0], setIsResolved = _useState[1];
    var _useState2 = (0, $g85JO.useState)(null), returnValue = _useState2[0], setReturnValue = _useState2[1]; // Make promise cancellable
    var cancellablePromise = (0, $g85JO.useMemo)(function() {
        return $716d27c269421560$var$createCancellablePromise(promise);
    }, [
        promise
    ]);
    var history = (0, $g85JO.useRef)([]); // Keep history of promises
    // Handle unmount
    (0, $g85JO.useEffect)(function() {
        return function() {
            if (!keepAlive) cancellablePromise.cancel();
        };
    }, [
        cancellablePromise,
        cancellablePromise.promise,
        keepAlive
    ]); // Await promise
    $716d27c269421560$var$useSingleton(/*#__PURE__*/ $716d27c269421560$var$_asyncToGenerator(/*#__PURE__*/ $716d27c269421560$var$runtime_1.mark(function _callee() {
        var data;
        return $716d27c269421560$var$runtime_1.wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    setIsResolved(null);
                    setReturnValue(null);
                    _context.prev = 2;
                    _context.next = 5;
                    return cancellablePromise.promise;
                case 5:
                    data = _context.sent;
                    setReturnValue(data);
                    setIsResolved(true);
                    history.current.push(cancellablePromise);
                    _context.next = 16;
                    break;
                case 11:
                    _context.prev = 11;
                    _context.t0 = _context["catch"](2);
                    setReturnValue(_context.t0);
                    setIsResolved(false);
                    history.current.push(cancellablePromise);
                case 16:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                2,
                11
            ]
        ]);
    })), [
        cancellablePromise.promise
    ]);
    if (!children || !$716d27c269421560$var$isThenable(promise)) return null;
    if (isResolved === null) {
        // Promise is pending
        var hasFallback = (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Children.toArray(children).find(function(c) {
            return c.type === $716d27c269421560$export$fb8d7f40caaeea67;
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $g85JO.Fragment), null, hasFallback || null);
    }
    if (!isResolved) {
        // Promise is fulfilled and rejected
        var hasElse = (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Children.toArray(children).find(function(c) {
            return c.type === $716d27c269421560$export$ffddce5cd29a79b2;
        });
        if (!hasElse) return (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $g85JO.Fragment), null, null); // Inject caught error
        var elseElement = hasElse;
        if (typeof hasElse.props.children === "function") elseElement = $716d27c269421560$var$_extends({}, hasElse, {
            props: $716d27c269421560$var$_extends({}, hasElse.props, {
                children: function children() {
                    return hasElse.props.children(returnValue, history.current, cancellablePromise.promise);
                }
            })
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $g85JO.Fragment), null, elseElement);
    } // Promise is fulfilled and resolved
    var hasThen = (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Children.toArray(children).find(function(c) {
        return c.type === $716d27c269421560$export$6a811f52dd5148fc;
    });
    if (!hasThen) return (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $g85JO.Fragment), null, null); // Inject promise return value
    var thenElement = hasThen;
    if (typeof hasThen.props.children === "function") thenElement = $716d27c269421560$var$_extends({}, hasThen, {
        props: $716d27c269421560$var$_extends({}, hasThen.props, {
            children: function children() {
                return hasThen.props.children(returnValue, history.current, cancellablePromise.promise);
            }
        })
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $g85JO.Fragment), null, thenElement);
}
/**
 * Handles errors by throwing them to the console.
 * `__DEV__` is replaced by tsdx using {@link https://www.npmjs.com/package/babel-plugin-dev-expression babel-plugin-dev-expressions}
 * which will ensure this entire throw is not present in production
 * @param condition The condition to check
 * @param message The message to throw if `condition` resolves to `true`
 */ function $716d27c269421560$var$tinyWarning(condition, message) {
    var x;
}
/**
 * If condition evaluates to true, renders the `<Then />` block will be rendered,
 * otherwise renders the `<Else />` block. Either block may be omitted.
 *
 * This component can contain any number of `<Then />` or `<Else />` blocks,
 * but only the first block of the right type (either Then or Else, depending on the condition) will be rendered.
 * @param __namedParameters The props to pass down to the `<IF />` component, see {@link ComponentWithConditionProps}
 */ var $716d27c269421560$export$1f9ff5f4a6c9361a = function If(_ref) {
    var condition = _ref.condition, _ref$keepAlive = _ref.keepAlive, keepAlive = _ref$keepAlive === void 0 ? false : _ref$keepAlive, children = _ref.children;
    if (!children) return null;
    $716d27c269421560$var$tinyWarning(!Array.isArray(children) && !(children.type === $716d27c269421560$export$ffddce5cd29a79b2 || children.type === $716d27c269421560$export$6a811f52dd5148fc) || !(0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Children.toArray(children).every(function(child) {
        return child.type === $716d27c269421560$export$ffddce5cd29a79b2 || child.type === $716d27c269421560$export$6a811f52dd5148fc || child.type === $716d27c269421560$export$fb8d7f40caaeea67;
    }), "The <If> component should contain <Then /> <Else /> or <Fallback /> components as its children");
    if ($716d27c269421560$var$isThenable(condition)) return (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement($716d27c269421560$var$IfAsync, {
        promise: condition,
        keepAlive: keepAlive
    }, children);
    var conditionResult = $716d27c269421560$var$getConditionResult(condition);
    return (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement((0, $g85JO.Fragment), null, (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Children.toArray(children).find(function(c) {
        return c.type !== $716d27c269421560$export$ffddce5cd29a79b2 !== !conditionResult;
    }) || null);
};
/**
 * It will render the first matching `<Case />`, or the first encountered `<Default />` (or `null`).
 *
 * This component can contain any number of `<Case />` and one `<Default />` blocks
 * @param __namedParameters Children to pass into the `<Switch />` component
 */ var $716d27c269421560$export$b5d5cf8927ab7262 = function Switch(_ref) {
    var _ref2, _matchingCase;
    var children = _ref.children;
    // -- Inspired by react-router --
    // We use React.Children.forEach instead of React.Children.toArray().find()
    // here because toArray adds keys to all child elements and we do not want
    // to trigger an unmount/remount for two children <Case>s or <Default>s
    var matchingCase = undefined;
    var defaultCase = undefined; // If the children are a function then resolve it first
    if ($716d27c269421560$var$isFunction(children)) children = children();
    (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).Children.forEach(children, function(child) {
        // not a valid react child, don't add it
        /* istanbul ignore next - This is only a safe fail for people writing bad code */ if (!(0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).isValidElement(child)) return;
        if (!matchingCase && child.type === $716d27c269421560$export$aab690d4858ddaa) {
            var condition = child.props.condition;
            var conditionResult = $716d27c269421560$var$getConditionResult(condition);
            if (conditionResult) matchingCase = child;
             // else not matching condition, don't add it
        } else if (!defaultCase && child.type === $716d27c269421560$export$39bcc3f08a9b5fa4) defaultCase = child;
         // else unknown type, don't add it
    });
    return (_ref2 = (_matchingCase = matchingCase) != null ? _matchingCase : defaultCase) != null ? _ref2 : null;
};
/** A shorthand for
 *
 * ```jsx
 * <If condition={...}>
 *     <Else>
 *         { ... }
 *     </Else>
 * </If>
 * ```
 *
 * The same rules apply to the child elements as with using the `<Else />` block.
 *
 * @param __namedParameters The props to pass down to the `<IF />` component, see {@link ComponentWithConditionProps}
 */ var $716d27c269421560$export$ac37d744f3e48198 = function Unless(_ref) {
    var condition = _ref.condition, children = _ref.children;
    var conditionResult = Boolean($716d27c269421560$var$getConditionResult(condition));
    return !conditionResult && children ? $716d27c269421560$var$render({
        children: children
    }) : null;
};
$716d27c269421560$export$ac37d744f3e48198.defaultProps = {
    children: null
};
/** A shorthand for
 *
 * ```jsx
 * <If condition={...}>
 *     <Then>
 *         { ... }
 *     </Then>
 * </If>
 * ```
 *
 * The same rules apply to the child elements as with using the `<Then /`> block.
 *
 * @param __namedParameters The props to pass down to the `<IF />` component, see {@link ComponentWithConditionProps}
 */ var $716d27c269421560$export$26a4295b0cbd3d5e = function When(_ref) {
    var condition = _ref.condition, children = _ref.children;
    var conditionResult = Boolean($716d27c269421560$var$getConditionResult(condition));
    return conditionResult && children ? $716d27c269421560$var$render({
        children: children
    }) : null;
};
$716d27c269421560$export$26a4295b0cbd3d5e.defaultProps = {
    children: null
};

});

parcelRegister("c0njb", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $8bd790acdbe4145e$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $81N94 = parcelRequire("81N94");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $ePG8R = parcelRequire("ePG8R");

var $gCzsf = parcelRequire("gCzsf");
var $8bd790acdbe4145e$export$5e725b8338a85d51 = function getTouchY(e) {
    return e.touches ? e.touches[0].pageY : 0;
};
function $8bd790acdbe4145e$var$PullDown(Props) {
    var onPullDownOpt = Props.onPullDown;
    var classNameOpt = Props.className;
    var childrenOpt = Props.children;
    var scaleOpt = Props.scale;
    var limit = Props.limit;
    var touchNoneOpt = Props.touchNone;
    var dataTestId = Props.dataTestId;
    var onPullDown = onPullDownOpt !== undefined ? onPullDownOpt : function onPullDown(param) {};
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var children = childrenOpt !== undefined ? $loT9g.valFromOption(childrenOpt) : null;
    var scale = scaleOpt !== undefined ? scaleOpt : 1.0;
    var touchNone = touchNoneOpt !== undefined ? touchNoneOpt : true;
    var match = $g85JO.useState(function() {});
    var setDragStart = match[1];
    var dragging = match[0];
    var match$1 = $ePG8R.use(30, true, function(param) {
        return 0.0;
    });
    var setOffsetY = match$1[1];
    var offsetY = match$1[0];
    var onTouchStart = function onTouchStart(e) {
        e.stopPropagation();
    };
    var onTouchMove = function onTouchMove(e) {
        var touchY = $8bd790acdbe4145e$export$5e725b8338a85d51(e);
        if (dragging === undefined) $iv6Yc._1(setDragStart, function(param) {
            return touchY;
        });
        else if (dragging !== undefined) $iv6Yc._1(setOffsetY, function(param) {
            return $81N94.float_max(touchY - dragging, 0.0) * scale;
        });
        e.stopPropagation();
    };
    var onTouchEnd = function onTouchEnd(e) {
        if (offsetY > 20.0) $iv6Yc._1(onPullDown, undefined);
        $iv6Yc._1(setOffsetY, function(param) {
            return 0.0;
        });
        $iv6Yc._1(setDragStart, function(param) {});
        e.stopPropagation();
    };
    var style = {
        transform: $ezf3v.translate3d_float(0.0, limit !== undefined ? Math.max(offsetY, limit) : offsetY, 0.0)
    };
    var tmp = {
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            className: $1TRFX.make([
                $ezf3v.prefix("absolute inset-0"),
                touchNone ? $ezf3v.prefix("touch-none") : "",
                dragging === undefined ? $ezf3v.prefix("transform-translate duration-250") : "",
                className
            ]),
            style: style,
            onTouchEnd: onTouchEnd,
            onTouchMove: onTouchMove,
            onTouchStart: onTouchStart
        }, children)
    };
    if (dataTestId !== undefined) tmp.dataTestId = $loT9g.valFromOption(dataTestId);
    return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, tmp);
}
$8bd790acdbe4145e$var$PullDown.displayName = "PullDown";
var $8bd790acdbe4145e$export$dd44f18ab656f3bb = $8bd790acdbe4145e$var$PullDown;
 /* react Not a pure module */ 
});

parcelRegister("9tGYJ", function(module, exports) {

$parcel$export(module.exports, "useImageSize", function () { return $6e68291e0420c855$export$7989bea419552e6d; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $lWvFd = parcelRequire("lWvFd");
function $6e68291e0420c855$export$7989bea419552e6d(url) {
    var match = $g85JO.useState(function() {
        return [
            0,
            0
        ];
    });
    var setSize = match[1];
    $g85JO.useEffect(function() {
        var handleLoad = function handleLoad($$event) {
            var target = $iv6Yc._1($lWvFd.ofElement, $$event.target);
            var naturalHeight = $2whNH.mapWithDefault(target, 0, function(prim) {
                return prim.naturalHeight;
            });
            var naturalWidth = $2whNH.mapWithDefault(target, 0, function(prim) {
                return prim.naturalWidth;
            });
            $iv6Yc._1(setSize, function(param) {
                return [
                    naturalWidth,
                    naturalHeight
                ];
            });
        };
        var img;
        if (url === "") img = undefined;
        else {
            var img$1 = document.createElement("img");
            img$1.addEventListener("load", handleLoad);
            img$1.setAttribute("src", url);
            img = $loT9g.some(img$1);
        }
        return function(param) {
            $2whNH.forEach(img, function(__x) {
                __x.removeEventListener("load", handleLoad);
            });
        };
    }, [
        url
    ]);
    return match[0];
}
 /* react Not a pure module */ 
});
parcelRegister("lWvFd", function(module, exports) {

$parcel$export(module.exports, "ofElement", function () { return $ff9793895528f3ea$export$f5fec2f60b925e79; });

var $itw3q = parcelRequire("itw3q");

var $amOA8 = parcelRequire("amOA8");

var $b5aRK = parcelRequire("b5aRK");

var $5OXjM = parcelRequire("5OXjM");

var $3Q6OI = parcelRequire("3Q6OI");
function $ff9793895528f3ea$export$e7fd69f64f92856(self, value) {
    self.crossOrigin = $itw3q.fromOption(value);
}
var $ff9793895528f3ea$var$include = $amOA8.Impl({});
$5OXjM.Impl({});
var $ff9793895528f3ea$var$include$1 = $b5aRK.Impl({});
var $ff9793895528f3ea$var$include$2 = $3Q6OI.Impl({});
var $ff9793895528f3ea$export$4debbe1037afe35e = $ff9793895528f3ea$var$include.nodeType;
var $ff9793895528f3ea$export$83b3005418b2b918 = $ff9793895528f3ea$var$include$1.asHtmlElement;
var $ff9793895528f3ea$export$b09cfa9b7e510069 = $ff9793895528f3ea$var$include$1.ofNode;
var $ff9793895528f3ea$export$bcf37bc7ac72b44e = $ff9793895528f3ea$var$include$1.insertAdjacentElement;
var $ff9793895528f3ea$export$56db5d470f98d841 = $ff9793895528f3ea$var$include$1.insertAdjacentHTML;
var $ff9793895528f3ea$export$63b055236462c0b2 = $ff9793895528f3ea$var$include$1.insertAdjacentText;
var $ff9793895528f3ea$export$f5fec2f60b925e79 = $ff9793895528f3ea$var$include$2.ofElement;
var $ff9793895528f3ea$export$d9d317b4285c34e7 = $ff9793895528f3ea$var$include$2.contentEditable;
var $ff9793895528f3ea$export$91a56ab73e46c5d4 = $ff9793895528f3ea$var$include$2.setContentEditable;
var $ff9793895528f3ea$export$147ec2801e896265 = $ff9793895528f3ea$var$include$2.dir;
var $ff9793895528f3ea$export$5d00cbe77a0f4da4 = $ff9793895528f3ea$var$include$2.setDir;
 /* include Not a pure module */ 
});
parcelRegister("itw3q", function(module, exports) {

$parcel$export(module.exports, "fromOption", function () { return $d733ccb90655aa3a$export$172ec0a6ebfeb6fa; });

var $loT9g = parcelRequire("loT9g");
function $d733ccb90655aa3a$export$e0969da9b8fb378d(x) {
    return x === null;
}
function $d733ccb90655aa3a$export$2d6fda808293d631(f) {
    if (f !== null) return f;
    throw new Error("Js.Null.getExn");
}
function $d733ccb90655aa3a$export$2385a24977818dd0(x, f) {
    if (x !== null) return f(x);
    else return null;
}
function $d733ccb90655aa3a$export$c0bf298a2e425654(x, f) {
    if (x !== null) return f(x);
}
function $d733ccb90655aa3a$export$172ec0a6ebfeb6fa(x) {
    if (x !== undefined) return $loT9g.valFromOption(x);
    else return null;
}
var $d733ccb90655aa3a$export$9d85d2d85cb82adf = $d733ccb90655aa3a$export$172ec0a6ebfeb6fa;
 /* No side effect */ 
});



parcelRegister("1Ij4x", function(module, exports) {

$parcel$export(module.exports, "makeSection", function () { return $13f8b1d80e96cbbf$export$b8ad1621112a78f4; });
$parcel$export(module.exports, "fromDetailedSections", function () { return $13f8b1d80e96cbbf$export$bf7b6609befbfdfb; });
$parcel$export(module.exports, "Header", function () { return $13f8b1d80e96cbbf$export$8b251419efc915eb; });
$parcel$export(module.exports, "make", function () { return $13f8b1d80e96cbbf$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $5ANIF = parcelRequire("5ANIF");

var $gCzsf = parcelRequire("gCzsf");

var $8AXqM = parcelRequire("8AXqM");

var $5bEXW = parcelRequire("5bEXW");

var $9pMGg = parcelRequire("9pMGg");

var $4LKt6 = parcelRequire("4LKt6");

var $fOz3p = parcelRequire("fOz3p");

var $hQWQG = parcelRequire("hQWQG");

var $hPPub = parcelRequire("hPPub");
function $13f8b1d80e96cbbf$export$b8ad1621112a78f4(titleOpt, id, children, renderer, collapsible, separator, padding, unit) {
    var title = titleOpt !== undefined ? titleOpt : {
        TAG: /* Element */ 1,
        _0: null
    };
    return {
        title: title,
        id: id,
        children: children,
        renderer: $2whNH.getWithDefault(renderer, function(a) {
            return a;
        }),
        collapsible: $2whNH.getWithDefault(collapsible, false),
        separator: $2whNH.getWithDefault(separator, false),
        padding: $2whNH.getWithDefault(padding, true)
    };
}
function $13f8b1d80e96cbbf$export$bf7b6609befbfdfb(detailedSections, product, variant, config) {
    return $i7mYY.keepMap($i7mYY.mapWithIndex(detailedSections, function(i, section) {
        var children = $fOz3p.DetailedSection.renderContents(undefined, product, variant, config, section);
        var match = section.accordionState;
        var collapsible = match ? false : true;
        if (children.length !== 0) return $13f8b1d80e96cbbf$export$b8ad1621112a78f4({
            TAG: /* Text */ 0,
            _0: section.title
        }, $iv6Yc._1($hQWQG.SectionId.toString, section.id), $loT9g.some(children), undefined, collapsible, i !== 0, undefined, undefined);
    }), function(a) {
        return a;
    });
}
function $13f8b1d80e96cbbf$export$ad32757a0e126192(titleStyle, titleSize) {
    return $1TRFX.make([
        titleStyle === "semibold-uppercase" ? "text-primary font-semibold uppercase" : titleStyle === "semibold" ? "text-tertiary font-semibold" : titleStyle === "medium" ? "text-primary font-medium" : titleStyle === "normal" ? "text-primary font-normal" : "text-primary font-semibold",
        titleSize === "small" ? "text-lg" : "text-xl"
    ]);
}
function $13f8b1d80e96cbbf$var$Accordion$Header(Props) {
    var active = Props.active;
    var id = Props.id;
    var classNameOpt = Props.className;
    var tabIndexOpt = Props.tabIndex;
    var titleStyleOpt = Props.titleStyle;
    var titleSizeOpt = Props.titleSize;
    var children = Props.children;
    var contentRight = Props.contentRight;
    var onClickOpt = Props.onClick;
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var tabIndex = tabIndexOpt !== undefined ? tabIndexOpt : -1;
    var titleStyle = titleStyleOpt !== undefined ? titleStyleOpt : "semibold-primary";
    var titleSize = titleSizeOpt !== undefined ? titleSizeOpt : "base";
    var onClick = onClickOpt !== undefined ? onClickOpt : function onClick(param) {};
    var titleClassName = $13f8b1d80e96cbbf$export$ad32757a0e126192(titleStyle, titleSize);
    var ref = $g85JO.useRef(null);
    var handleClick = function handleClick(e) {
        $iv6Yc._1(onClick, e);
        setTimeout(function(param) {
            var el = ref.current;
            if (!(el == null)) {
                (0, $hPPub.default)(el, {
                    behavior: "instant",
                    block: "nearest",
                    inline: "nearest",
                    scrollMode: "if-needed"
                });
                return;
            }
        }, 0);
    };
    return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
        dataActive: active === id,
        dataTestId: "pdp-accordion-title",
        ariaExpanded: active === id,
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            ref: $5bEXW.Ref.domRef(ref),
            "aria-controls": id,
            className: className,
            role: "button",
            tabIndex: tabIndex,
            onClick: handleClick
        }, $7bjme.notequal(children, null) ? /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("flex items-center")
        }, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix($1TRFX.make([
                "flex-grow font-heading",
                titleClassName
            ]))
        }, children), contentRight !== undefined ? /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("pr-1 pl-2")
        }, $loT9g.valFromOption(contentRight)) : null) : null)
    });
}
$13f8b1d80e96cbbf$var$Accordion$Header.displayName = "Accordion.Header";
var $13f8b1d80e96cbbf$export$8b251419efc915eb = {
    make: $13f8b1d80e96cbbf$var$Accordion$Header
};
function $13f8b1d80e96cbbf$var$Accordion$Section(Props) {
    var index = Props.index;
    var section = Props.section;
    var onExpand = Props.onExpand;
    var onCollapse = Props.onCollapse;
    var active = Props.active;
    var titleStyleOpt = Props.titleStyle;
    var titleSizeOpt = Props.titleSize;
    var forceCollapsibleOpt = Props.forceCollapsible;
    var inlineOpt = Props.inline;
    var truncated = Props.truncated;
    var titleStyle = titleStyleOpt !== undefined ? titleStyleOpt : "semibold-primary";
    var titleSize = titleSizeOpt !== undefined ? titleSizeOpt : "base";
    var forceCollapsible = forceCollapsibleOpt !== undefined ? forceCollapsibleOpt : false;
    var inline = inlineOpt !== undefined ? inlineOpt : false;
    var match = $g85JO.useState(function() {
        return true;
    });
    var setOpen = match[1];
    var isOpen = match[0];
    $g85JO.useEffect(function() {
        $iv6Yc._1(setOpen, function(param) {
            if (section.collapsible) return active === section.id;
            else return true;
        });
    }, [
        active
    ]);
    var onClick = function onClick(param) {
        if (section.collapsible) {
            if (isOpen) return $iv6Yc._1(onCollapse, undefined);
            else return $iv6Yc._1(onExpand, undefined);
        }
    };
    var match$1 = section.padding;
    var content = /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "text-secondary text-lg",
            section.collapsible ? "overflow-hidden" : "",
            isOpen ? "" : forceCollapsible ? "h-0" : "truncate-lines line-clamp-2"
        ]))
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            titleSize === "small" ? "" : titleStyle === "semibold-primary" ? match$1 ? "pb-10" : "" : match$1 ? "pb-2" : "",
            inline ? "flex" : ""
        ]))
    }, $2whNH.getWithDefault(section.children, null)));
    var content$1 = truncated ? /*#__PURE__*/ $g85JO.createElement($4LKt6.make, {
        children: content
    }) : content;
    var icon = isOpen ? /*#__PURE__*/ $g85JO.createElement($8AXqM.make, {
        className: $ezf3v.prefix($1TRFX.make([
            "text-primary w-4 h-4"
        ]))
    }) : /*#__PURE__*/ $g85JO.createElement($5ANIF.make, {
        className: $ezf3v.prefix($1TRFX.make([
            "text-primary w-4 h-4"
        ]))
    });
    var icon$1 = section.collapsible ? icon : null;
    var cursorClass = section.collapsible ? "cursor-pointer" : "";
    var tabIndex = section.collapsible ? 0 : -1;
    var paddingClass = $7bjme.equal(section.title, {
        TAG: /* Element */ 1,
        _0: null
    }) || $7bjme.equal(section.title, {
        TAG: /* Text */ 0,
        _0: ""
    }) ? "" : titleSize === "small" ? "pb-2" : titleStyle === "semibold-primary" ? "py-10" : "py-4";
    var el = section.children;
    if (el === undefined) return null;
    var text = section.title;
    var tmp;
    tmp = text.TAG === /* Text */ 0 ? text._0 : undefined;
    var tmp$1 = {
        key: section.id,
        className: $ezf3v.prefix("flex-shrink-0"),
        id: section.id,
        role: "region"
    };
    if (tmp !== undefined) tmp$1["aria-label"] = $loT9g.valFromOption(tmp);
    var element = section.title;
    var tmp$2;
    tmp$2 = element._0;
    return $iv6Yc._1(section.renderer, /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, section.separator && index > 0 ? /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("border-t border-primary opacity-5 h-0")
    }) : null, /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
        dataSectionId: section.id,
        children: /*#__PURE__*/ $g85JO.createElement("div", tmp$1, /*#__PURE__*/ $g85JO.createElement($13f8b1d80e96cbbf$var$Accordion$Header, {
            active: active,
            id: section.id,
            className: $ezf3v.prefix($1TRFX.make([
                paddingClass,
                cursorClass
            ])),
            tabIndex: tabIndex,
            titleStyle: titleStyle,
            titleSize: titleSize,
            children: tmp$2,
            contentRight: icon$1,
            onClick: onClick
        }), content$1)
    })));
}
$13f8b1d80e96cbbf$var$Accordion$Section.displayName = "Accordion.Section";
var $13f8b1d80e96cbbf$export$6e2c8f0811a474ce = {
    make: $13f8b1d80e96cbbf$var$Accordion$Section
};
function $13f8b1d80e96cbbf$var$Accordion(Props) {
    var id = Props.id;
    var sections = Props.sections;
    var onChangeFocusOpt = Props.onChangeFocus;
    var classNameOpt = Props.className;
    var titleStyleOpt = Props.titleStyle;
    var titleSizeOpt = Props.titleSize;
    var inlineOpt = Props.inline;
    var truncated = Props.truncated;
    var forceCollapsibleOpt = Props.forceCollapsible;
    var active = Props.active;
    var onChangeFocus = onChangeFocusOpt !== undefined ? onChangeFocusOpt : function onChangeFocus(section) {};
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var titleStyle = titleStyleOpt !== undefined ? titleStyleOpt : "semibold-primary";
    var titleSize = titleSizeOpt !== undefined ? titleSizeOpt : "base";
    var inline = inlineOpt !== undefined ? inlineOpt : false;
    var forceCollapsible = forceCollapsibleOpt !== undefined ? forceCollapsibleOpt : false;
    var match = $9pMGg.use(undefined);
    var trackEvent = match.trackEvent;
    var match$1 = $i7mYY.get(sections, 0);
    var initialActive = active !== undefined ? active : match$1 !== undefined ? match$1.id : "";
    var match$2 = $g85JO.useState(function() {
        return initialActive;
    });
    var setActive = match$2[1];
    var active$1 = match$2[0];
    $g85JO.useEffect(function() {
        $iv6Yc._1(setActive, function(param) {
            return initialActive;
        });
    }, [
        id
    ]);
    var sections$1 = $i7mYY.mapWithIndex(sections, function(index, section) {
        var key = section.id + (section.collapsible ? "-" + id : "");
        var onExpand = function onExpand(param) {
            $iv6Yc._1(setActive, function(param) {
                return section.id;
            });
            $iv6Yc._1(onChangeFocus, section.id);
            $iv6Yc.app(trackEvent, [
                {
                    NAME: "Clicked PDP Section Open",
                    VAL: section.id
                },
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined
            ]);
        };
        var onCollapse = function onCollapse(param) {
            $iv6Yc._1(setActive, function(param) {
                return "";
            });
            $iv6Yc._1(onChangeFocus, "");
            $iv6Yc.app(trackEvent, [
                {
                    NAME: "Clicked PDP Section Closed",
                    VAL: section.id
                },
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined
            ]);
        };
        return /*#__PURE__*/ $g85JO.createElement($13f8b1d80e96cbbf$var$Accordion$Section, {
            index: index,
            section: section,
            onExpand: onExpand,
            onCollapse: onCollapse,
            active: active$1,
            titleStyle: titleStyle,
            titleSize: titleSize,
            forceCollapsible: forceCollapsible,
            inline: inline,
            truncated: truncated,
            key: key
        });
    });
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $1TRFX.make([
            $ezf3v.prefix($1TRFX.make([
                "flex-grow",
                inline ? "flex flex-row justify-between gap-10" : ""
            ])),
            className
        ])
    }, sections$1);
}
$13f8b1d80e96cbbf$var$Accordion.displayName = "Accordion";
var $13f8b1d80e96cbbf$export$dd44f18ab656f3bb = $13f8b1d80e96cbbf$var$Accordion;
 /* react Not a pure module */ 
});
parcelRegister("5ANIF", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $4126e1cc6a5ad7fc$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");
function $4126e1cc6a5ad7fc$var$IconPlusBold(Props) {
    var className = Props.className;
    var tmp = {
        height: "14",
        width: "14",
        fill: "none",
        viewBox: "0 0 14 14",
        xmlns: "http://www.w3.org/2000/svg"
    };
    if (className !== undefined) tmp.className = $loT9g.valFromOption(className);
    return /*#__PURE__*/ $g85JO.createElement("svg", tmp, /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M13.5 7C13.5 7.5625 13.0312 8.03125 12.5 8.03125H8V12.5312C8 13.0625 7.53125 13.5 7 13.5C6.4375 13.5 6 13.0625 6 12.5312V8.03125H1.5C0.9375 8.03125 0.5 7.5625 0.5 7C0.5 6.46875 0.9375 6.03125 1.5 6.03125H6V1.53125C6 0.96875 6.4375 0.5 7 0.5C7.53125 0.5 8 0.96875 8 1.53125V6.03125H12.5C13.0312 6 13.5 6.46875 13.5 7Z",
        fill: "currentColor"
    }));
}
$4126e1cc6a5ad7fc$var$IconPlusBold.displayName = "IconPlusBold";
var $4126e1cc6a5ad7fc$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($4126e1cc6a5ad7fc$var$IconPlusBold);
 /* make Not a pure module */ 
});

parcelRegister("8AXqM", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $641fc94840ebf659$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");
function $641fc94840ebf659$var$IconMinusBold(Props) {
    var className = Props.className;
    var tmp = {
        height: "2",
        width: "14",
        fill: "none",
        viewBox: "0 0 14 2",
        xmlns: "http://www.w3.org/2000/svg"
    };
    if (className !== undefined) tmp.className = $loT9g.valFromOption(className);
    return /*#__PURE__*/ $g85JO.createElement("svg", tmp, /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M12.5 2H1.5C0.9375 2 0.5 1.5625 0.5 1C0.5 0.46875 0.9375 0 1.5 0H12.5C13.0312 0 13.5 0.46875 13.5 1C13.5 1.5625 13.0312 2 12.5 2Z",
        fill: "currentColor"
    }));
}
$641fc94840ebf659$var$IconMinusBold.displayName = "IconMinusBold";
var $641fc94840ebf659$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($641fc94840ebf659$var$IconMinusBold);
 /* make Not a pure module */ 
});

parcelRegister("4LKt6", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $378f98d7b949f5d8$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $ezf3v = parcelRequire("ezf3v");

var $gCzsf = parcelRequire("gCzsf");

var $5bEXW = parcelRequire("5bEXW");

var $aSJcu = parcelRequire("aSJcu");
function $378f98d7b949f5d8$var$TruncatedContainer(Props) {
    var children = Props.children;
    var match = $aSJcu.use(undefined);
    var windowHeight = match.windowSize.height;
    var match$1 = $g85JO.useState(function() {
        return false;
    });
    var setExpanded = match$1[1];
    var expanded = match$1[0];
    var ref = $g85JO.useRef(null);
    $g85JO.useEffect(function() {
        var el = ref.current;
        if (!(el == null)) {
            var scrollHeight = el.scrollHeight;
            var clientHeight = el.clientHeight;
            if ((scrollHeight - clientHeight | 0) === 0) $iv6Yc._1(setExpanded, function(param) {
                return true;
            });
        }
    }, []);
    var style = $g85JO.useMemo(function() {
        var maxHeight = expanded ? undefined : $ezf3v.intToPx(windowHeight / 2 | 0);
        var tmp = {};
        if (maxHeight !== undefined) tmp.maxHeight = maxHeight;
        return tmp;
    }, [
        expanded,
        windowHeight
    ]);
    var handleClick = function handleClick(e) {
        $iv6Yc._1(setExpanded, function(prev) {
            return !prev;
        });
    };
    var renderReadMoreButton = function renderReadMoreButton(expanded) {
        if (expanded) return null;
        else return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
            dataTestId: "truncated-container-read-more",
            children: /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("cursor-pointer text-lg absolute bottom-0 left-0 w-full h-24 pb-3 text-center text-accent font-medium flex items-end justify-center"),
                style: {
                    background: "linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, var(--smartnav-background-color) 60%)"
                },
                tabIndex: 0,
                onClick: handleClick
            }, "Read More")
        });
    };
    return /*#__PURE__*/ $g85JO.createElement("div", {
        ref: $5bEXW.Ref.domRef(ref),
        className: $ezf3v.prefix("relative overflow-hidden"),
        style: style
    }, children, renderReadMoreButton(expanded));
}
$378f98d7b949f5d8$var$TruncatedContainer.displayName = "TruncatedContainer";
var $378f98d7b949f5d8$export$dd44f18ab656f3bb = $378f98d7b949f5d8$var$TruncatedContainer;
 /* react Not a pure module */ 
});


parcelRegister("kEThe", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $f0a26bf10370041d$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $9JLuv = parcelRequire("9JLuv");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $diVVk = parcelRequire("diVVk");

var $kQvlq = parcelRequire("kQvlq");

var $hfCPd = parcelRequire("hfCPd");

var $3qnJm = parcelRequire("3qnJm");

var $7KlbQ = parcelRequire("7KlbQ");

var $55MCT = parcelRequire("55MCT");

var $dMhWy = parcelRequire("dMhWy");

var $iOiuS = parcelRequire("iOiuS");

var $l7I7e = parcelRequire("l7I7e");

var $239BR = parcelRequire("239BR");

var $7E1DP = parcelRequire("7E1DP");

var $fCPBg = parcelRequire("fCPBg");

var $8lNXy = parcelRequire("8lNXy");

var $gBkg7 = parcelRequire("gBkg7");

var $5iu1A = parcelRequire("5iu1A");

var $8L1B1 = parcelRequire("8L1B1");

var $fUtdg = parcelRequire("fUtdg");

var $hBcYV = parcelRequire("hBcYV");

var $8zoQU = parcelRequire("8zoQU");

var $aSJcu = parcelRequire("aSJcu");

var $2ZaET = parcelRequire("2ZaET");

var $9pMGg = parcelRequire("9pMGg");

var $5CE1l = parcelRequire("5CE1l");

var $jtD5N = parcelRequire("jtD5N");

var $edu9N = parcelRequire("edu9N");

var $8E2YL = parcelRequire("8E2YL");

var $lHzh8 = parcelRequire("lHzh8");

var $bmEf1 = parcelRequire("bmEf1");

var $1nuZE = parcelRequire("1nuZE");

var $g3aLS = parcelRequire("g3aLS");
function $f0a26bf10370041d$var$ProductCard$Default(Props) {
    var shape = Props.shape;
    var productCategory = Props.productCategory;
    var product = Props.product;
    var productPriceStyle = Props.productPriceStyle;
    var activeVariantId = Props.activeVariantId;
    var enableAddToCartOpt = Props.enableAddToCart;
    var highlightActiveVariantOpt = Props.highlightActiveVariant;
    var onClick = Props.onClick;
    var onAddToCartOpt = Props.onAddToCart;
    var onImageRendered = Props.onImageRendered;
    var fluidOpt = Props.fluid;
    var removeAllInfoOpt = Props.removeAllInfo;
    var onOpenLink = Props.onOpenLink;
    var isMiniPDPVisible = Props.isMiniPDPVisible;
    var dataCount = Props.dataCount;
    var enableAddToCart = enableAddToCartOpt !== undefined ? enableAddToCartOpt : true;
    var highlightActiveVariant = highlightActiveVariantOpt !== undefined ? highlightActiveVariantOpt : true;
    var onAddToCart = onAddToCartOpt !== undefined ? onAddToCartOpt : function onAddToCart(param, param$1, param$2, param$3) {};
    var fluid = fluidOpt !== undefined ? fluidOpt : false;
    var removeAllInfo = removeAllInfoOpt !== undefined ? removeAllInfoOpt : false;
    var store = $8L1B1.use(undefined);
    var ref = $g85JO.useRef(null);
    var match = $9pMGg.use(undefined);
    var displayVariantBy = $jtD5N.useDisplayVariantBy(undefined);
    var match$1 = $8E2YL.use(undefined);
    var match$2 = match$1.config;
    var transitiveAccount = match$2.transitiveAccount;
    var settings = match$2.settings;
    var match$3 = $hBcYV.useRouter(undefined);
    var goTo = match$3.goTo;
    var route = match$3.route;
    var match$4 = $g3aLS.use(undefined);
    var isZoomEnabled = match$4.isZoomEnabled;
    var gridColumns = match$4.gridColumns;
    var match$5 = $aSJcu.use(undefined);
    var isMobile = match$5.isMobile;
    var hideMediaFromOtherVariants = $2whNH.mapWithDefault(transitiveAccount, false, function(account) {
        return account.pdpHideMediaFromOtherVariants;
    });
    var hideOutOfStock = settings.hideOutOfStock;
    var getInitialVariant = function getInitialVariant(param) {
        return $7KlbQ.getInitialDisplayVariant(hideOutOfStock, activeVariantId, displayVariantBy, product);
    };
    var match$6 = $g85JO.useState(function() {
        return getInitialVariant(undefined);
    });
    var setSelectedVariant = match$6[1];
    var selectedVariant = match$6[0];
    var match$7 = $g85JO.useState(function() {
        return false;
    });
    var setIsHovered = match$7[1];
    var isHovered = match$7[0];
    var isHoveredOnce = $l7I7e.useTrue(isHovered);
    var onHover = $g85JO.useCallback(function(param) {
        $iv6Yc._1(setIsHovered, function(param) {
            return true;
        });
    }, [
        setIsHovered
    ]);
    var onMouseLeave = $g85JO.useCallback(function(param) {
        $iv6Yc._1(setIsHovered, function(param) {
            return false;
        });
        $iv6Yc._1(setSelectedVariant, function(param) {
            return getInitialVariant(undefined);
        });
    }, [
        setIsHovered
    ]);
    var overrideAddToCartLabel = $2whNH.flatMap($2whNH.flatMap(transitiveAccount, function(account) {
        return account.productRules.customAddToCartText;
    }), function(data) {
        if ($5CE1l.matchesProduct(data.rule, product, selectedVariant)) return data;
    });
    var disableWhenOutOfStock = $2whNH.mapWithDefault(overrideAddToCartLabel, true, function(data) {
        return !data.overrideOutOfStock;
    });
    var overrideAddToCartLabel$1 = $2whNH.map(overrideAddToCartLabel, function(data) {
        return data.text;
    });
    var hideAddToCartButton = $2whNH.mapWithDefault($2whNH.flatMap(transitiveAccount, function(account) {
        return account.productRules.hideAddToCartButton;
    }), false, function(rule) {
        return $5CE1l.matchesProduct(rule, product, selectedVariant);
    });
    var enableAddToCart$1 = !hideAddToCartButton && enableAddToCart;
    $g85JO.useEffect(function() {
        $iv6Yc._1(setSelectedVariant, function(param) {
            return getInitialVariant(undefined);
        });
    }, [
        activeVariantId
    ]);
    var match$8 = $2whNH.getWithDefault(shape, settings.productCardShape);
    var shape$1 = typeof match$8 === "number" && !(match$8 > 3 || match$8 < 1) ? shape : settings.productCardShape;
    var match$9 = $g85JO.useMemo(function() {
        return $7KlbQ.getDisplayProductCardMedia(hideMediaFromOtherVariants, product, selectedVariant);
    }, [
        selectedVariant
    ]);
    var firstMedia = match$9[0];
    var secondMedia = $i7mYY.get(match$9[1], 0);
    var firstMediaSize = $7KlbQ.Media.getImageSize(firstMedia);
    var firstImageUrl = $7KlbQ.Media.getImageUrlWithPosterFallback(firstMedia);
    var secondImageUrl = $2whNH.flatMap(secondMedia, $7KlbQ.Media.getImageUrlWithPosterFallback);
    var firstVideoUrl = $7KlbQ.Media.getVideoUrl(firstMedia);
    var secondVideoUrl = $2whNH.flatMap(secondMedia, $7KlbQ.Media.getVideoUrl);
    var videoUrl = firstVideoUrl !== undefined ? firstVideoUrl : secondVideoUrl !== undefined ? secondVideoUrl : undefined;
    var renderCardVideo = function renderCardVideo(fallbackImageUrl, videoUrl) {
        var tmp = {
            videoUrl: videoUrl,
            settings: settings,
            showIndicator: false,
            controlsClassName: $ezf3v.prefix("z-20 bottom-14"),
            parentRef: ref,
            alt: product.name,
            fitToContainer: settings.productCardFitToContainer
        };
        if (fallbackImageUrl !== undefined) tmp.imageUrl = $loT9g.valFromOption(fallbackImageUrl);
        if (onImageRendered !== undefined) tmp.onImageRendered = $loT9g.valFromOption(onImageRendered);
        return /*#__PURE__*/ $g85JO.createElement($7E1DP.CardVideo.make, tmp);
    };
    var isProductSelected;
    if (typeof route === "number") isProductSelected = false;
    else switch(route.TAG | 0){
        case /* PDP */ 2:
            isProductSelected = route._0.productId === product.id && highlightActiveVariant;
            break;
        case /* QuickView */ 3:
            isProductSelected = $7bjme.equal(route._0.productId, product.id) && highlightActiveVariant;
            break;
        default:
            isProductSelected = false;
    }
    var match$10 = $g85JO.useState(function() {
        return /* Unmount */ 3;
    });
    var setShowMiniPDP = match$10[1];
    var showMiniPDP = match$10[0];
    var match$11 = $kQvlq.useSafeTimeout(undefined, undefined);
    var setMiniPDPTimeout = match$11.setTimeout;
    var removeOverlay = $g85JO.useMemo(function() {
        if (typeof route === "number" || !(route.TAG === /* ListPage */ 1 && isZoomEnabled && !isMobile)) return false;
        else return gridColumns >= /* TwelveColumnGrid */ 8;
    }, [
        route,
        isZoomEnabled,
        gridColumns,
        match$5.breakpoint,
        isMobile
    ]);
    var renderAddToCartButton = function renderAddToCartButton(selectedVariant) {
        var onClickAddToCartMobile = function onClickAddToCartMobile(param) {
            $iv6Yc._1(setShowMiniPDP, function(param) {
                return /* Render */ 0;
            });
            if (isMiniPDPVisible !== undefined) isMiniPDPVisible.current = true;
            if (typeof route !== "number" && route.TAG === /* QuickView */ 3) {
                var match = route._0;
                var productId = match.productId;
                $iv6Yc._3(goTo, undefined, undefined, {
                    TAG: /* QuickView */ 3,
                    _0: {
                        mediaId: match.mediaId,
                        mediaParentId: match.mediaParentId,
                        albumId: undefined,
                        productId: productId,
                        relatedMediaProductIds: match.relatedMediaProductIds,
                        relatedMediaCategoryId: match.relatedMediaCategoryId,
                        variantId: match.variantId,
                        panelClosed: productId === undefined ? false : match.panelClosed,
                        zoomedPhotoIndex: match.zoomedPhotoIndex,
                        time: match.time
                    }
                });
            }
            setMiniPDPTimeout(function(param) {
                $iv6Yc._1(setShowMiniPDP, function(param) {
                    return /* Show */ 1;
                });
            }, 42);
        };
        var renderAddToCartMobile = function renderAddToCartMobile(param) {
            return /*#__PURE__*/ $g85JO.createElement($edu9N.make, {
                size: /* Sm */ 0,
                icon: /*#__PURE__*/ $g85JO.createElement($iOiuS.make, {
                    size: 22
                }),
                style: {
                    backgroundColor: settings.pdpCTAButtonBgColor,
                    color: settings.pdpCTAButtonTextColor
                },
                onClick: onClickAddToCartMobile,
                disabled: false,
                primary: true,
                preventDefault: true,
                outline: true,
                labelDataTestId: "add-to-cart-label",
                dataTestId: "product-card-add-to-cart"
            });
        };
        var renderAddToCartDesktop = function renderAddToCartDesktop(param) {
            if (isHoveredOnce) return /*#__PURE__*/ $g85JO.createElement($3qnJm.AddToCartButton.make, {
                show: isHovered,
                product: product,
                variant: selectedVariant,
                category: productCategory,
                label: $2whNH.getWithDefault(overrideAddToCartLabel$1, settings.pdpAddToCartLabel),
                disableWhenOutOfStock: disableWhenOutOfStock,
                disabledLabel: settings.outOfStockLabel,
                confirmationLabel: $2whNH.getWithDefault(overrideAddToCartLabel$1, settings.pdpAddToCartConfirmation),
                children: /*#__PURE__*/ $g85JO.createElement($edu9N.make, {
                    size: /* Sm */ 0,
                    style: {
                        backgroundColor: settings.pdpCTAButtonBgColor,
                        color: settings.pdpCTAButtonTextColor
                    },
                    primary: true,
                    preventDefault: true,
                    outline: true,
                    wrapText: true,
                    labelDataTestId: "add-to-cart-label",
                    dataTestId: "product-card-add-to-cart"
                }),
                onAddToCart: onAddToCart
            });
            else return null;
        };
        return /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
            condition: settings.productCardAddToCart && firstImageUrl !== undefined && enableAddToCart$1,
            children: /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix($1TRFX.make([
                    "absolute p-3 bottom-0 transform transition-all duration-150",
                    isMobile ? "w-auto right-0" : "w-full left-0",
                    isMobile ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2",
                    isMobile ? "" : "max-h-full overflow-auto no-scrollbar",
                    "group-2-hover:opacity-100 group-2-hover:translate-y-0",
                    "focus-within-visible:opacity-100 focus-within-visible:translate-y-0",
                    "group-2-focus-visible:opacity-100 group-2-focus-visible:translate-y-0"
                ]))
            }, isMobile ? renderAddToCartMobile(undefined) : renderAddToCartDesktop(undefined))
        });
    };
    var renderReviews = $2whNH.getWithDefault($2whNH.map(product.reviewSummary, function(summary, param) {
        return /*#__PURE__*/ $g85JO.createElement($fUtdg.Summary.make, {
            at: /* PLP */ 1,
            summary: summary,
            className: $ezf3v.prefix("mt-2")
        });
    }), function(param) {
        return null;
    });
    var renderBadges = function renderBadges(param) {
        return /*#__PURE__*/ $g85JO.createElement($gBkg7.make, {
            className: $ezf3v.prefix("pt-2 -mb-1"),
            dataTestId: "plp-product-badges",
            size: /* Sm */ 1,
            product: product,
            variant: selectedVariant
        });
    };
    var renderFavoritesButton = function renderFavoritesButton(param) {
        return /*#__PURE__*/ $g85JO.createElement($dMhWy.ToggleButton.make, {
            product: product,
            tabIndex: 0
        });
    };
    var prioritizedRender = function prioritizedRender(priority) {
        var renderOverlay = function renderOverlay(param) {
            return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, isMobile || removeAllInfo ? null : renderFavoritesButton(undefined), renderAddToCartButton(selectedVariant));
        };
        var tmp;
        if (videoUrl !== undefined) tmp = renderCardVideo(firstImageUrl, videoUrl);
        else {
            var tmp$1 = {
                src: $2whNH.getWithDefault(firstImageUrl, ""),
                fit: settings.productCardFitToContainer ? /* Contain */ 2 : /* Cover */ 1,
                alt: product.name,
                priority: priority
            };
            if (onImageRendered !== undefined) tmp$1.onRender = $loT9g.valFromOption(onImageRendered);
            var tmp$2 = {
                src: $2whNH.getWithDefault(secondImageUrl, ""),
                fit: settings.productCardFitToContainer ? /* Contain */ 2 : /* Cover */ 1,
                alt: product.name,
                priority: priority + 1 | 0,
                enabled: !isMobile && secondImageUrl !== undefined && selectedVariant.id === getInitialVariant(undefined).id
            };
            if (onImageRendered !== undefined) tmp$2.onImageRendered = $loT9g.valFromOption(onImageRendered);
            tmp = /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement($55MCT.make, tmp$1), /*#__PURE__*/ $g85JO.createElement($bmEf1.make, tmp$2));
        }
        var tmp$3 = {
            fluid: fluid,
            id: selectedVariant.id,
            preventLinkDefault: true,
            lineClamp: settings.productCardTitleLineTruncate,
            showTitle: !removeAllInfo,
            selected: isProductSelected,
            title: $7KlbQ.getDisplayName(store, selectedVariant, product),
            contentBoxStylableClassName: "product-card__content-box",
            titleStylableClassName: "product-card__title",
            imageSize: firstMediaSize,
            fwdRef: ref,
            dataTestId: "product-card-test-id",
            titleDataTestId: "product-card-title",
            renderTitle: function renderTitle(title) {
                if (isMobile) return /*#__PURE__*/ $g85JO.createElement("div", {
                    className: $ezf3v.prefix("flex")
                }, /*#__PURE__*/ $g85JO.createElement("div", {
                    className: $ezf3v.prefix("flex-grow flex flex-col overflow-hidden")
                }, renderBadges(undefined), title), /*#__PURE__*/ $g85JO.createElement("div", {
                    className: $ezf3v.prefix("flex-shrink-0")
                }, renderFavoritesButton(undefined)));
                else return /*#__PURE__*/ $g85JO.createElement("div", {
                    className: $ezf3v.prefix("flex flex-col")
                }, renderBadges(undefined), title);
            },
            children: tmp,
            renderAfterTitle: function renderAfterTitle(param) {
                if (removeAllInfo) return;
                var tmp = {
                    at: /* PLP */ 1,
                    product: product,
                    variant: selectedVariant,
                    priceBlockStylableClassName: "product-card__price-box",
                    priceStylableClassName: "product-card__price",
                    salePriceStylableClassName: "product-card__sale-price"
                };
                if (productPriceStyle !== undefined) tmp.style = $loT9g.valFromOption(productPriceStyle);
                return $loT9g.some(/*#__PURE__*/ $g85JO.createElement("div", {
                    className: $ezf3v.prefix("pb-6")
                }, /*#__PURE__*/ $g85JO.createElement($9JLuv.If, {
                    condition: isMobile,
                    children: null
                }, /*#__PURE__*/ $g85JO.createElement($9JLuv.Then, {
                    children: /*#__PURE__*/ $g85JO.createElement($8zoQU.Minimal.make, {
                        hideOutOfStock: hideOutOfStock,
                        product: product
                    })
                }), /*#__PURE__*/ $g85JO.createElement($9JLuv.Else, {
                    children: /*#__PURE__*/ $g85JO.createElement($8zoQU.Large.make, {
                        selectedVariant: selectedVariant,
                        product: product,
                        onChange: function onChange(variant) {
                            $iv6Yc._1(setSelectedVariant, function(param) {
                                return variant;
                            });
                        }
                    })
                })), /*#__PURE__*/ $g85JO.createElement($3qnJm.make, $3qnJm.makeProps(product, selectedVariant, undefined, settings.hideOutOfStock, undefined, undefined, /*#__PURE__*/ $g85JO.createElement($8lNXy.make, tmp), undefined, undefined)), $iv6Yc._1(renderReviews, undefined)));
            },
            renderOverlay: removeAllInfo || removeOverlay ? function(param) {
                return null;
            } : renderOverlay,
            onClickLink: function onClickLink(param) {
                if (settings.openProductLink) return $iv6Yc._5(onOpenLink, productCategory, dataCount, product, selectedVariant, undefined);
                else return $iv6Yc._2(onClick, product, selectedVariant);
            },
            onHover: onHover,
            onMouseLeave: onMouseLeave
        };
        if (shape$1 !== undefined) tmp$3.shape = $loT9g.valFromOption(shape$1);
        var tmp$4 = $2whNH.map(selectedVariant.link, function(url) {
            return {
                TAG: /* URL */ 0,
                _0: url
            };
        });
        if (tmp$4 !== undefined) tmp$3.link = $loT9g.valFromOption(tmp$4);
        if (dataCount !== undefined) tmp$3.dataCount = dataCount;
        return /*#__PURE__*/ $g85JO.createElement($diVVk.make, tmp$3);
    };
    var scrollToDetailsRef = $g85JO.useRef(function(param) {});
    var match$12 = $g85JO.useState(function() {
        return selectedVariant;
    });
    var setMiniPDPSelectedVariant = match$12[1];
    var miniPDPSelectedVariant = match$12[0];
    var handleCloseMiniPDP = function handleCloseMiniPDP(param) {
        $iv6Yc._1(setShowMiniPDP, function(param) {
            return /* Hide */ 2;
        });
        if (isMiniPDPVisible !== undefined) isMiniPDPVisible.current = false;
        setMiniPDPTimeout(function(param) {
            $iv6Yc._1(setShowMiniPDP, function(param) {
                return /* Unmount */ 3;
            });
        }, 500);
    };
    var handleFormChange = function handleFormChange(product, nextVariant) {
        $iv6Yc._1(setMiniPDPSelectedVariant, function(previous) {
            return $2whNH.getWithDefault(nextVariant, previous);
        });
    };
    var handleFormSubmit = function handleFormSubmit(submission) {
        var submissionResult;
        submissionResult = submission.TAG === /* AllGood */ 0 ? submission._0 : undefined;
        if (submissionResult === undefined) return Promise.resolve(undefined);
        var match = submissionResult.submitButtonType;
        if (typeof match === "number") {
            if (match !== 0) {
                $iv6Yc._5(onOpenLink, productCategory, dataCount, submissionResult.product, submissionResult.variant, undefined);
                return Promise.resolve(undefined);
            } else {
                handleCloseMiniPDP(undefined);
                $iv6Yc._4(onAddToCart, submissionResult.product, submissionResult.variant, submissionResult.quantity, productCategory);
                return new Promise(function(resolve, reject) {
                    setTimeout(function(param) {
                        resolve(settings.pdpAddToCartConfirmation);
                    }, 1000);
                });
            }
        }
        var confirmation = match.confirmation;
        $iv6Yc._3(match.run, submissionResult.product, submissionResult.variant, submissionResult.quantity);
        if (confirmation !== undefined) return new Promise(function(resolve, reject) {
            setTimeout(function(param) {
                resolve(confirmation);
            }, 1000);
        });
        else return Promise.resolve(undefined);
    };
    var tmp;
    if (showMiniPDP >= 3) tmp = null;
    else {
        var tmp$1 = {
            product: product,
            variant: miniPDPSelectedVariant,
            shouldForceMobile: true,
            scrollToDetailsRef: scrollToDetailsRef,
            stickyCTA: false,
            sections: [
                "promo",
                "summary",
                "variants",
                "quantity",
                "cta"
            ],
            showSecondaryCTA: false,
            showTertiaryCTA: false,
            showFavoriteButton: $7bjme.notequal(match$3.listPageType, /* Favorites */ 0),
            showCustomColors: false
        };
        if (productCategory !== undefined) tmp$1.productCategory = $loT9g.valFromOption(productCategory);
        tmp = /*#__PURE__*/ $g85JO.createElement($5iu1A.make, {
            children: /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("w-screen")
            }, /*#__PURE__*/ $g85JO.createElement($3qnJm.make, $3qnJm.makeProps(product, miniPDPSelectedVariant, undefined, settings.hideOutOfStock, handleFormChange, handleFormSubmit, /*#__PURE__*/ $g85JO.createElement($lHzh8.make, tmp$1), undefined, undefined)), match.embedType >= 4 ? /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("h-8")
            }) : /*#__PURE__*/ $g85JO.createElement($fCPBg.make, {
                position: /* Relative */ 2,
                initiator: "product-card",
                itemsAlign: "items-center",
                onClick: function onClick(param) {
                    handleCloseMiniPDP(undefined);
                }
            })),
            isOpen: showMiniPDP === /* Show */ 1,
            onClose: handleCloseMiniPDP,
            showHeader: false,
            unmount: false,
            pullDownTarget: "modal",
            dataId: product.id,
            dataTestId: "product-card-add-to-cart-prompt"
        });
    }
    return /*#__PURE__*/ $g85JO.createElement($1nuZE.Provider.make, {
        product: product,
        variant: miniPDPSelectedVariant,
        children: null
    }, /*#__PURE__*/ $g85JO.createElement($239BR.make, {
        render: prioritizedRender
    }), tmp);
}
$f0a26bf10370041d$var$ProductCard$Default.displayName = "ProductCard.Default";
var $f0a26bf10370041d$export$39bcc3f08a9b5fa4 = {
    make: $f0a26bf10370041d$var$ProductCard$Default
};
function $f0a26bf10370041d$var$ProductCard(Props) {
    var shape = Props.shape;
    var productCategory = Props.productCategory;
    var product = Props.product;
    var productPriceStyle = Props.productPriceStyle;
    var activeVariantId = Props.activeVariantId;
    var enableAddToCartOpt = Props.enableAddToCart;
    var highlightActiveVariantOpt = Props.highlightActiveVariant;
    var onClick = Props.onClick;
    var onAddToCartOpt = Props.onAddToCart;
    var onImageRendered = Props.onImageRendered;
    var fluidOpt = Props.fluid;
    var removeAllInfoOpt = Props.removeAllInfo;
    var onOpenLink = Props.onOpenLink;
    var isMiniPDPVisible = Props.isMiniPDPVisible;
    var dataCount = Props.dataCount;
    var enableAddToCart = enableAddToCartOpt !== undefined ? enableAddToCartOpt : true;
    var highlightActiveVariant = highlightActiveVariantOpt !== undefined ? highlightActiveVariantOpt : true;
    var onAddToCart = onAddToCartOpt !== undefined ? onAddToCartOpt : function onAddToCart(param, param$1, param$2, param$3) {};
    var fluid = fluidOpt !== undefined ? fluidOpt : false;
    var removeAllInfo = removeAllInfoOpt !== undefined ? removeAllInfoOpt : false;
    var match = $8E2YL.use(undefined);
    var renderFallback = function renderFallback(param) {
        var tmp = {
            product: product,
            enableAddToCart: enableAddToCart,
            highlightActiveVariant: highlightActiveVariant,
            onClick: onClick,
            onAddToCart: onAddToCart,
            fluid: fluid,
            removeAllInfo: removeAllInfo,
            onOpenLink: onOpenLink
        };
        if (shape !== undefined) tmp.shape = $loT9g.valFromOption(shape);
        if (productCategory !== undefined) tmp.productCategory = $loT9g.valFromOption(productCategory);
        if (productPriceStyle !== undefined) tmp.productPriceStyle = $loT9g.valFromOption(productPriceStyle);
        if (activeVariantId !== undefined) tmp.activeVariantId = activeVariantId;
        if (onImageRendered !== undefined) tmp.onImageRendered = $loT9g.valFromOption(onImageRendered);
        if (isMiniPDPVisible !== undefined) tmp.isMiniPDPVisible = $loT9g.valFromOption(isMiniPDPVisible);
        if (dataCount !== undefined) tmp.dataCount = dataCount;
        return /*#__PURE__*/ $g85JO.createElement($f0a26bf10370041d$var$ProductCard$Default, tmp);
    };
    var match$1 = match.config.settings.productCardComponent;
    if (match$1 === undefined) return renderFallback(undefined);
    var tmp = {
        componentId: match$1.id,
        data: product,
        props: match$1.props,
        renderFallback: renderFallback
    };
    if (activeVariantId !== undefined) tmp.activeVariantId = activeVariantId;
    return /*#__PURE__*/ $g85JO.createElement($hfCPd.ProductRenderer.make, tmp);
}
$f0a26bf10370041d$var$ProductCard.displayName = "ProductCard";
var $f0a26bf10370041d$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($f0a26bf10370041d$var$ProductCard);
 /* make Not a pure module */ 
});
parcelRegister("iOiuS", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $db1b3e9d1b0d34bc$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");
function $db1b3e9d1b0d34bc$var$IconCartAdd(Props) {
    var sizeOpt = Props.size;
    var className = Props.className;
    var size = sizeOpt !== undefined ? sizeOpt : 24;
    var tmp = {
        height: size.toString(),
        width: size.toString(),
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.8",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    };
    if (className !== undefined) tmp.className = $loT9g.valFromOption(className);
    return /*#__PURE__*/ $g85JO.createElement("svg", tmp, /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M12.5 21h-3.926a3 3 0 0 1 -2.965 -2.544l-1.255 -8.152a2 2 0 0 1 1.977 -2.304h11.339a2 2 0 0 1 1.977 2.304l-.263 1.708"
    }), /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M16 19h6"
    }), /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M19 16v6"
    }), /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M9 11v-5a3 3 0 0 1 6 0v5"
    }));
}
$db1b3e9d1b0d34bc$var$IconCartAdd.displayName = "IconCartAdd";
var $db1b3e9d1b0d34bc$export$dd44f18ab656f3bb = $db1b3e9d1b0d34bc$var$IconCartAdd;
 /* react Not a pure module */ 
});

parcelRegister("l7I7e", function(module, exports) {

$parcel$export(module.exports, "use", function () { return $f60c78dfdef922ea$export$1f96ae73734a86cc; });
$parcel$export(module.exports, "useTrue", function () { return $f60c78dfdef922ea$export$f8e5c37f6bc4cf93; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $loT9g = parcelRequire("loT9g");

var $3QSSt = parcelRequire("3QSSt");
function $f60c78dfdef922ea$export$1f96ae73734a86cc(value) {
    var previous = $3QSSt.usePreviousDistinct(value);
    if (value !== undefined) return $loT9g.some($loT9g.valFromOption(value));
    else return previous;
}
function $f60c78dfdef922ea$export$f8e5c37f6bc4cf93(value) {
    var previous = $3QSSt.usePreviousDistinct(value);
    if (value) return true;
    else return previous;
}
 /* Previous-Showside Not a pure module */ 
});

parcelRegister("fCPBg", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $b6026e527a3afbdb$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $9JLuv = parcelRequire("9JLuv");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $7wIsS = parcelRequire("7wIsS");

var $lhKg5 = parcelRequire("lhKg5");

var $dMhWy = parcelRequire("dMhWy");

var $dAJXq = parcelRequire("dAJXq");

var $hvzQE = parcelRequire("hvzQE");

var $1fA44 = parcelRequire("1fA44");

var $2jMpY = parcelRequire("2jMpY");

var $ePRCc = parcelRequire("ePRCc");

var $6Ntmr = parcelRequire("6Ntmr");

var $hBcYV = parcelRequire("hBcYV");

var $fsiJD = parcelRequire("fsiJD");

var $e1Nsu = parcelRequire("e1Nsu");

var $aSJcu = parcelRequire("aSJcu");

var $2ZaET = parcelRequire("2ZaET");

var $9pMGg = parcelRequire("9pMGg");

var $4135i = parcelRequire("4135i");

var $lihS4 = parcelRequire("lihS4");

var $8E2YL = parcelRequire("8E2YL");

var $hYM4T = parcelRequire("hYM4T");

var $5RX6O = parcelRequire("5RX6O");
function $b6026e527a3afbdb$var$MobileNavbar(Props) {
    var position = Props.position;
    var showOpt = Props.show;
    var showSidebarOpt = Props.showSidebar;
    var showFiltersOpt = Props.showFilters;
    var showBackToTopButtonOpt = Props.showBackToTopButton;
    var shadowOpt = Props.shadow;
    var initiator = Props.initiator;
    var itemsAlign = Props.itemsAlign;
    var scrollableContainerRef = Props.scrollableContainerRef;
    var onClick = Props.onClick;
    var show = showOpt !== undefined ? showOpt : true;
    var showSidebar = showSidebarOpt !== undefined ? showSidebarOpt : true;
    var showFilters = showFiltersOpt !== undefined ? showFiltersOpt : false;
    var showBackToTopButton = showBackToTopButtonOpt !== undefined ? showBackToTopButtonOpt : false;
    var shadow = shadowOpt !== undefined ? shadowOpt : false;
    var match = $g85JO.useState(function() {
        return show;
    });
    var setShow = match[1];
    var show$1 = match[0];
    var match$1 = $8E2YL.use(undefined);
    var match$2 = match$1.config;
    var settings = match$2.settings;
    var activeCategory = $hBcYV.useActiveCategory(undefined, undefined, match$2.categories);
    var match$3 = $hBcYV.useRouter(undefined);
    var route = match$3.route;
    var match$4 = $lihS4.useCart(undefined);
    var cart = match$4.cart;
    var isForcingPLP = $5RX6O.useCategoryDisplayPriority(activeCategory) === /* ProductsFirst */ 1;
    var match$5 = $aSJcu.use(undefined);
    var breakpoint = match$5.breakpoint;
    var match$6 = $9pMGg.use(undefined);
    var onBackClick = match$6.onBackClick;
    var onCloseNavigation = match$6.onCloseNavigation;
    var onHomeClick = match$6.onHomeClick;
    var toggleFiltersPanel = match$6.toggleFiltersPanel;
    var toggleSidebar = match$6.toggleSidebar;
    var lastProductAddedToCart = match$6.lastProductAddedToCart;
    var embedType = match$6.embedType;
    var favorites = $dMhWy.useFavorites(undefined);
    var match$7 = $dMhWy.useRecentlyAdded(undefined);
    var lastProductFavorited = match$7[0];
    var isHome;
    if (typeof route === "number" || route.TAG !== /* Home */ 0) isHome = false;
    else {
        var match$8 = route._0;
        isHome = $2whNH.isNone(match$8.filters) && match$8.homeType === /* Index */ 0;
    }
    var match$9 = $g85JO.useState(function() {
        return false;
    });
    var setIsVisible = match$9[1];
    var match$10;
    if (typeof route === "number") match$10 = [
        undefined,
        undefined,
        undefined,
        undefined,
        undefined
    ];
    else switch(route.TAG | 0){
        case /* Home */ 0:
        case /* ListPage */ 1:
            match$10 = [
                "navbar-button-back",
                "navbar-button-home",
                "navbar-button-sidebar",
                "navbar-button-checkout",
                "navbar-button-open-close"
            ];
            break;
        case /* PDP */ 2:
            match$10 = [
                "pdp2-button-back",
                "pdp2-button-home",
                "pdp2-button-sidebar",
                "pdp2-button-checkout",
                "pdp2-button-open-close"
            ];
            break;
        case /* QuickView */ 3:
            match$10 = [
                undefined,
                undefined,
                undefined,
                undefined,
                undefined
            ];
            break;
    }
    var openCloseTestId = match$10[4];
    var checkoutTestId = match$10[3];
    var sidebarTestId = match$10[2];
    var homeTestId = match$10[1];
    var backTestId = match$10[0];
    var zIndex = String($ezf3v.safeIncrementZIndex(settings.zIndexInt));
    var cartIconPixelAdjustments = breakpoint >= 2 ? "0 0 0 0" : "0 -3px 0 0";
    var iconSizeDiff = match$5.isMobile ? 2 : 0;
    var canRenderFavorites = favorites.source !== /* SourceLocalStorage */ 0 && embedType === /* Inline */ 1 ? false : favorites.enabled;
    var canRenderBackButton = settings.backButton;
    var canRenderSidebar = settings.linksAsSidebar && showSidebar;
    var canRenderCheckout = $2whNH.isSome(settings.checkoutLink) || $2whNH.isSome(match$4.setShowCartDrawer);
    var canRenderOpenClose = embedType !== /* Inline */ 1;
    var match$11 = $hvzQE.isEnabled(activeCategory, settings, match$3.listPageType, isForcingPLP);
    var canRenderFilters = match$11[1] && showFilters;
    var canRenderBackToTopButton = $e1Nsu.isEnabled(activeCategory, settings, isForcingPLP, match$3.productFilters) && showBackToTopButton;
    $g85JO.useEffect(function() {
        $iv6Yc._1(setShow, function(previous) {
            if ($2whNH.isSome(lastProductAddedToCart) && canRenderCheckout || $2whNH.isSome(lastProductFavorited) && canRenderFavorites) return true;
            else return previous;
        });
    }, [
        lastProductAddedToCart,
        lastProductFavorited
    ]);
    $g85JO.useEffect(function() {
        $iv6Yc._1(setShow, function(previous) {
            if ($2whNH.isSome(lastProductAddedToCart) && canRenderCheckout) return previous;
            else return show;
        });
    }, [
        show,
        lastProductAddedToCart
    ]);
    var render = function render(param) {
        var style = shadow ? {
            boxShadow: "0 -1px 3px 0 rgba(0, 0, 0, 0.1), 0 -1px 2px 0 rgba(0, 0, 0, 0.06)"
        } : {};
        var style$1 = Object.assign({}, style, {
            zIndex: zIndex
        });
        var positionCn;
        switch(position){
            case /* Sticky */ 0:
                positionCn = "sticky";
                break;
            case /* Fixed */ 1:
                positionCn = "fixed";
                break;
            case /* Relative */ 2:
                positionCn = "relative";
                break;
        }
        var itemsAlignCn = itemsAlign !== undefined ? itemsAlign : position >= 2 ? "items-stretch" : "items-center";
        var buttonsCount = $i7mYY.reduce([
            canRenderBackButton,
            canRenderCheckout,
            canRenderSidebar,
            canRenderOpenClose
        ], 0, function(acc, curr) {
            return acc + (curr ? 1 : 0) | 0;
        });
        var justifyCn = buttonsCount === 1 ? "justify-center" : "justify-between";
        var match = $4135i.useCheckoutAction(undefined);
        var checkoutOnClick = match.onClick;
        var checkoutHref = match.href;
        var canRenderBar = canRenderBackButton || canRenderCheckout || canRenderSidebar || canRenderOpenClose || canRenderFavorites;
        var tmp = {
            className: $ezf3v.prefix($1TRFX.make([
                "smartnav-mobile-navbar",
                positionCn,
                itemsAlignCn,
                "left-0 shadow-sm",
                show$1 || !canRenderBar ? "bottom-0" : "-bottom-16",
                "bg-main text-primary",
                breakpoint >= /* Md */ 2 || !canRenderBar ? "h-0" : "h-16",
                "w-full flex px-5",
                justifyCn,
                "transition-all duration-300"
            ])),
            style: style$1
        };
        if (onClick !== undefined) tmp.onClick = $loT9g.valFromOption(onClick);
        var tmp$1 = {};
        if (scrollableContainerRef !== undefined) tmp$1.scrollableContainerRef = $loT9g.valFromOption(scrollableContainerRef);
        var tmp$2 = {
            label: "Back",
            children: /*#__PURE__*/ $g85JO.createElement($7wIsS.UilAngleLeftB.make, {
                size: /* Px */ {
                    _0: 26 + iconSizeDiff | 0
                }
            }),
            onClick: function onClick(param) {
                if (embedType === /* Inline */ 1 && isHome) return;
                else return $iv6Yc._1(onBackClick, undefined);
            },
            className: $ezf3v.prefix(embedType === /* Inline */ 1 && isHome ? "opacity-25" : ""),
            disabled: false,
            position: /* Fixed */ 1
        };
        if (backTestId !== undefined) tmp$2.dataTestId = $loT9g.valFromOption(backTestId);
        var tmp$3 = {
            label: "Home",
            children: /*#__PURE__*/ $g85JO.createElement($7wIsS.UilEstate.make, {
                size: /* Px */ {
                    _0: 21
                },
                className: $ezf3v.prefix("w-full")
            }),
            show: true,
            onClick: function onClick(param) {
                if (isHome) return;
                else return $iv6Yc._1(onHomeClick, undefined);
            },
            className: $ezf3v.prefix(isHome ? "opacity-25" : ""),
            position: /* Fixed */ 1
        };
        if (homeTestId !== undefined) tmp$3.dataTestId = $loT9g.valFromOption(homeTestId);
        var tmp$4 = {
            label: "Sidebar",
            children: /*#__PURE__*/ $g85JO.createElement($1fA44.make, {}),
            onClick: function onClick(param) {
                $iv6Yc._1(toggleSidebar, undefined);
            },
            position: position
        };
        if (sidebarTestId !== undefined) tmp$4.dataTestId = $loT9g.valFromOption(sidebarTestId);
        var tmp$5;
        var exit = 0;
        if (checkoutHref !== undefined || checkoutOnClick !== undefined) exit = 1;
        else tmp$5 = null;
        if (exit === 1) {
            var tmp$6 = {
                label: "Checkout",
                children: /*#__PURE__*/ $g85JO.createElement($lhKg5.make, {
                    size: 22 + iconSizeDiff | 0
                }),
                show: $2whNH.isSome(settings.checkoutLink),
                openLinkInNewTab: settings.openLinkInNewTab,
                pixelAdjustments: cartIconPixelAdjustments,
                position: /* Fixed */ 1
            };
            if (checkoutOnClick !== undefined) tmp$6.onClick = $loT9g.valFromOption(checkoutOnClick);
            if (checkoutHref !== undefined) tmp$6.href = checkoutHref;
            var tmp$7 = $2jMpY.fromInt(99, undefined, cart.itemCount);
            if (tmp$7 !== undefined) tmp$6.badge = $loT9g.valFromOption(tmp$7);
            if (checkoutTestId !== undefined) tmp$6.dataTestId = $loT9g.valFromOption(checkoutTestId);
            tmp$5 = /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("relative pointer-events-auto")
            }, /*#__PURE__*/ $g85JO.createElement($dAJXq.make, tmp$6), /*#__PURE__*/ $g85JO.createElement($6Ntmr.make, {
                productDirection: /* Top */ 0,
                tooltipDirection: /* Left */ 2,
                addedLabel: settings.pdpAddToCartConfirmation,
                className: $ezf3v.prefix("absolute w-full h-full")
            }));
        }
        var tmp$8 = {
            label: "Open",
            children: /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("transform -rotate-90")
            }, /*#__PURE__*/ $g85JO.createElement($9JLuv.If, {
                condition: settings.smartbarEnabled,
                children: null
            }, /*#__PURE__*/ $g85JO.createElement($9JLuv.Then, {
                children: /*#__PURE__*/ $g85JO.createElement($7wIsS.UilAngleLeftB.make, {
                    size: /* Px */ {
                        _0: 28 + iconSizeDiff | 0
                    }
                })
            }), /*#__PURE__*/ $g85JO.createElement($9JLuv.Else, {
                children: /*#__PURE__*/ $g85JO.createElement($7wIsS.UilTimes.make, {
                    size: /* Px */ {
                        _0: 28 + iconSizeDiff | 0
                    }
                })
            }))),
            onClick: function onClick(param) {
                $iv6Yc._1(onCloseNavigation, undefined);
            },
            position: position
        };
        if (openCloseTestId !== undefined) tmp$8.dataTestId = $loT9g.valFromOption(openCloseTestId);
        return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
            condition: canRenderBar || canRenderFilters || canRenderBackToTopButton,
            children: /*#__PURE__*/ $g85JO.createElement("div", tmp, /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
                condition: canRenderFilters,
                children: /*#__PURE__*/ $g85JO.createElement($hYM4T.make, {
                    onClick: function onClick(param) {
                        $iv6Yc._1(toggleFiltersPanel, undefined);
                    }
                })
            }), /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
                condition: canRenderBackToTopButton,
                children: /*#__PURE__*/ $g85JO.createElement($e1Nsu.make, tmp$1)
            }), /*#__PURE__*/ $g85JO.createElement((0, (/*@__PURE__*/$parcel$interopDefault($fsiJD))), {
                partialVisibility: true,
                onChange: function onChange(visible) {
                    $iv6Yc._1(setIsVisible, function(param) {
                        return visible;
                    });
                },
                children: /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
                    condition: canRenderBackButton,
                    children: /*#__PURE__*/ $g85JO.createElement($dAJXq.make, tmp$2)
                }), /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
                    condition: embedType !== /* Inline */ 1,
                    children: /*#__PURE__*/ $g85JO.createElement($dAJXq.make, tmp$3)
                }), /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
                    condition: canRenderSidebar,
                    children: /*#__PURE__*/ $g85JO.createElement($dAJXq.make, tmp$4)
                }), /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
                    condition: canRenderCheckout,
                    children: tmp$5
                }), /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
                    condition: canRenderFavorites,
                    children: /*#__PURE__*/ $g85JO.createElement($dMhWy.OpenButton.make, {})
                }), /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
                    condition: canRenderOpenClose,
                    children: /*#__PURE__*/ $g85JO.createElement($dAJXq.make, tmp$8)
                }))
            }))
        }));
    };
    if (position !== 1) return render(undefined);
    else return /*#__PURE__*/ $g85JO.createElement($ePRCc.make, {
        initiator: initiator,
        portal: true,
        children: render(undefined)
    });
}
$b6026e527a3afbdb$var$MobileNavbar.displayName = "MobileNavbar";
var $b6026e527a3afbdb$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($b6026e527a3afbdb$var$MobileNavbar);
 /* make Not a pure module */ 
});
parcelRegister("1fA44", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $0e932ad7147287b2$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");
function $0e932ad7147287b2$var$IconSidebar(Props) {
    var className = Props.className;
    var tmp = {
        height: "21",
        width: "21",
        fill: "none",
        viewBox: "0 0 18 15",
        xmlns: "http://www.w3.org/2000/svg"
    };
    if (className !== undefined) tmp.className = $loT9g.valFromOption(className);
    return /*#__PURE__*/ $g85JO.createElement("svg", tmp, /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M14.5 0H2.5C1.375 0 0.5 0.90625 0.5 2V12C0.5 13.125 1.375 14 2.5 14H14.5C15.5938 14 16.5 13.125 16.5 12V2C16.5 0.90625 15.5938 0 14.5 0ZM4.75 9.5H3.25C2.8125 9.5 2.5 9.1875 2.5 8.75C2.5 8.34375 2.8125 8 3.25 8H4.75C5.15625 8 5.5 8.34375 5.5 8.75C5.5 9.1875 5.15625 9.5 4.75 9.5ZM4.75 6.5H3.25C2.8125 6.5 2.5 6.1875 2.5 5.75C2.5 5.34375 2.8125 5 3.25 5H4.75C5.15625 5 5.5 5.34375 5.5 5.75C5.5 6.1875 5.15625 6.5 4.75 6.5ZM4.75 3.5H3.25C2.8125 3.5 2.5 3.1875 2.5 2.75C2.5 2.34375 2.8125 2 3.25 2H4.75C5.15625 2 5.5 2.34375 5.5 2.75C5.5 3.1875 5.15625 3.5 4.75 3.5ZM15 12C15 12.2812 14.75 12.5 14.5 12.5H7.5V1.5H14.5C14.75 1.5 15 1.75 15 2V12Z",
        fill: "currentColor"
    }));
}
$0e932ad7147287b2$var$IconSidebar.displayName = "IconSidebar";
var $0e932ad7147287b2$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($0e932ad7147287b2$var$IconSidebar);
 /* make Not a pure module */ 
});

parcelRegister("e1Nsu", function(module, exports) {

$parcel$export(module.exports, "isEnabled", function () { return $a3678617433cc0ab$export$3b029eb57ac4d562; });
$parcel$export(module.exports, "make", function () { return $a3678617433cc0ab$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $1xf0g = parcelRequire("1xf0g");

var $kH8HZ = parcelRequire("kH8HZ");

var $aSJcu = parcelRequire("aSJcu");

var $gUsPc = parcelRequire("gUsPc");
function $a3678617433cc0ab$export$3b029eb57ac4d562(category, settings, isForcingPLP, appliedFilters) {
    if (category !== undefined) {
        if ($1xf0g.hasProducts(category) && (!$1xf0g.hasSubCategories(category) || isForcingPLP)) return $1xf0g.ExternalConnection.isConnectedToProductSource(category);
        else return false;
    } else if ($2whNH.mapWithDefault(settings.indexNode, false, function(indexNode) {
        return $2whNH.isSome($1xf0g.ExternalConnection.getStoreCategoryConnection(indexNode));
    })) return $2whNH.isSome(appliedFilters);
    else return false;
}
function $a3678617433cc0ab$var$BackToTopButton(Props) {
    var scrollableContainerRef = Props.scrollableContainerRef;
    var positionOpt = Props.position;
    var position = positionOpt !== undefined ? positionOpt : "absolute";
    var match = $aSJcu.use(undefined);
    var windowHeight = match.windowSize.height;
    var isMobile = match.isMobile;
    var embedTop = $gUsPc.useContainerTop(undefined);
    var match$1 = $g85JO.useState(function() {
        return false;
    });
    var setShow = match$1[1];
    var scrollableElement = $g85JO.useRef({
        TAG: /* Window */ 0,
        _0: window
    });
    var onClick = function onClick(e) {
        var w = scrollableElement.current;
        if (w.TAG === /* Window */ 0) {
            w._0.scrollTo({
                behavior: "smooth",
                left: 0.0,
                top: embedTop
            });
            return;
        }
        w._0.scrollTo({
            behavior: "smooth",
            left: 0.0,
            top: 0.0
        });
    };
    var onScroll = function onScroll(e) {
        var scrollTop = e.target.scrollTop;
        var actualScrollTop = scrollTop == null ? window.scrollY | 0 : scrollTop | 0;
        $iv6Yc._1(setShow, function(param) {
            return actualScrollTop > windowHeight;
        });
    };
    $g85JO.useEffect(function() {
        var el = $2whNH.flatMap(scrollableContainerRef, function(ref) {
            return $loT9g.nullable_to_opt(ref.current);
        });
        var tmp;
        if (el !== undefined) {
            var el$1 = $loT9g.valFromOption(el);
            scrollableElement.current = {
                TAG: /* Element */ 1,
                _0: el$1
            };
            el$1.addEventListener("scroll", onScroll);
            tmp = function tmp(param) {
                el$1.removeEventListener("scroll", onScroll);
            };
        } else {
            window.addEventListener("scroll", onScroll);
            tmp = function tmp(param) {
                window.removeEventListener("scroll", onScroll);
            };
        }
        return tmp;
    }, []);
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            position,
            "bottom-0 left-0",
            isMobile ? "bottom-22" : "bottom-12",
            "pointer-events-none"
        ]))
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "h-13.5 w-13.5",
            "border-1.5 border-solid border-accent",
            "relative",
            "rounded-full bg-accent text-main no-touch-highlight",
            "flex items-center justify-center",
            "cursor-pointer",
            "shadow-lg hover:shadow-xl",
            "dark-hover darker-active",
            isMobile ? "left-6" : "left-12",
            match$1[0] ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none",
            "transition-opacity duration-300",
            "transform scale-110"
        ])),
        title: "Scroll back to top",
        onClick: onClick
    }, /*#__PURE__*/ $g85JO.createElement($kH8HZ.make, {})));
}
$a3678617433cc0ab$var$BackToTopButton.displayName = "BackToTopButton";
var $a3678617433cc0ab$export$dd44f18ab656f3bb = $a3678617433cc0ab$var$BackToTopButton;
 /* react Not a pure module */ 
});
parcelRegister("kH8HZ", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $f10e941b372501a8$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");
function $f10e941b372501a8$var$IconUpArrow(Props) {
    var className = Props.className;
    var tmp = {
        height: "17",
        width: "12",
        fill: "none",
        viewBox: "0 0 12 17",
        xmlns: "http://www.w3.org/2000/svg"
    };
    if (className !== undefined) tmp.className = $loT9g.valFromOption(className);
    return /*#__PURE__*/ $g85JO.createElement("svg", tmp, /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M10.75 6.53125C10.625 6.6875 10.4375 6.75 10.25 6.75C10.0312 6.75 9.84375 6.6875 9.71875 6.53125L6.75 3.5625V16.25C6.75 16.6875 6.40625 17 6 17C5.5625 17 5.25 16.6875 5.25 16.25V3.5625L2.25 6.53125C1.96875 6.8125 1.5 6.8125 1.21875 6.53125C0.90625 6.21875 0.90625 5.75 1.21875 5.46875L5.46875 1.21875C5.75 0.90625 6.21875 0.90625 6.5 1.21875L10.75 5.46875C11.0625 5.78125 11.0625 6.25 10.75 6.53125Z",
        fill: "currentColor"
    }));
}
$f10e941b372501a8$var$IconUpArrow.displayName = "IconUpArrow";
var $f10e941b372501a8$export$dd44f18ab656f3bb = $f10e941b372501a8$var$IconUpArrow;
 /* react Not a pure module */ 
});


parcelRegister("hYM4T", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $d16d55893fa9b5c0$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $ezf3v = parcelRequire("ezf3v");

var $tUpyX = parcelRequire("tUpyX");

var $dzvJv = parcelRequire("dzvJv");

var $fEMeF = parcelRequire("fEMeF");

var $7wIsS = parcelRequire("7wIsS");

var $gCzsf = parcelRequire("gCzsf");

var $hBcYV = parcelRequire("hBcYV");
function $d16d55893fa9b5c0$var$FiltersFloatingButton$View(Props) {
    var positionOpt = Props.position;
    var count = Props.count;
    var handleClearButtonClick = Props.handleClearButtonClick;
    var handleMainButtonClick = Props.handleMainButtonClick;
    var position = positionOpt !== undefined ? positionOpt : "absolute";
    var renderIcon = function renderIcon(param) {
        return /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("w-12 h-12 flex items-center justify-center")
        }, count !== 0 ? /*#__PURE__*/ $g85JO.createElement($dzvJv.make, {
            text: String(count),
            position: "relative",
            color: /* InvertAccent */ 1,
            dataTestId: "filters-count"
        }) : /*#__PURE__*/ $g85JO.createElement($7wIsS.UilSlidersVAlt.make, {
            size: /* Px */ {
                _0: 18
            },
            className: $ezf3v.prefix("rotate-90 transform-gpu")
        }));
    };
    var renderLabel = function renderLabel(param) {
        return /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("mr-1 text-xl font-semibold")
        }, "Filters");
    };
    var renderClearButton = function renderClearButton(param) {
        if (count > 0) return /*#__PURE__*/ $g85JO.createElement($tUpyX.make, {
            children: null,
            unstyled: true,
            className: $ezf3v.prefix("px-4 py-2 mx-1.5 relative cursor-pointer text-base text-main no-underline"),
            dataTestId: "filters-clear-all-badge",
            onClick: handleClearButtonClick
        }, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("relative text-main")
        }, "Clear All"), /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("absolute inset-1 bg-main opacity-15 rounded-full")
        }));
        else return null;
    };
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "w-full pointer-events-none",
            position === "sticky" ? "sticky" : "absolute",
            "bottom-0 left-0 w-full",
            "flex",
            "items-center",
            "justify-center",
            "duration-300 transition-all",
            "mb-22"
        ]))
    }, /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
        dataTestId: "plp-filters-button",
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix($1TRFX.make([
                "h-13.5",
                "border-1.5 border-solid border-accent",
                "rounded-full shadow-xl bg-accent text-main no-touch-highlight pointer-events-auto flex items-center",
                count === 0 ? "pr-3 pl-2" : "",
                "transform transition-transform duration-300",
                "scale-110",
                "cursor-pointer",
                "font-button"
            ])),
            onClick: handleMainButtonClick
        }, renderIcon(undefined), renderLabel(undefined), renderClearButton(undefined))
    }));
}
$d16d55893fa9b5c0$var$FiltersFloatingButton$View.displayName = "FiltersFloatingButton.View";
var $d16d55893fa9b5c0$export$27a5bd065ad55220 = {
    make: $d16d55893fa9b5c0$var$FiltersFloatingButton$View
};
function $d16d55893fa9b5c0$var$FiltersFloatingButton(Props) {
    var positionOpt = Props.position;
    var onClick = Props.onClick;
    var position = positionOpt !== undefined ? positionOpt : "absolute";
    var match = $hBcYV.useRouter(undefined);
    var goTo = match.goTo;
    var route = match.route;
    var count = $2whNH.mapWithDefault(match.productFilters, 0, $fEMeF.length);
    var handleMainButtonClick = $iv6Yc.__1(onClick);
    var handleClearButtonClick = function handleClearButtonClick(e) {
        e.stopPropagation();
        var tmp;
        if (typeof route === "number") tmp = route;
        else switch(route.TAG | 0){
            case /* Home */ 0:
                var data = route._0;
                tmp = {
                    TAG: /* Home */ 0,
                    _0: {
                        homeType: data.homeType,
                        filters: undefined,
                        sort: data.sort
                    }
                };
                break;
            case /* ListPage */ 1:
                var data$1 = route._0;
                tmp = {
                    TAG: /* ListPage */ 1,
                    _0: {
                        listPageType: data$1.listPageType,
                        viewPLP: data$1.viewPLP,
                        filters: undefined,
                        sort: data$1.sort
                    }
                };
                break;
            default:
                tmp = route;
        }
        $iv6Yc._3(goTo, undefined, undefined, tmp);
    };
    return /*#__PURE__*/ $g85JO.createElement($d16d55893fa9b5c0$var$FiltersFloatingButton$View, {
        position: position,
        count: count,
        handleClearButtonClick: handleClearButtonClick,
        handleMainButtonClick: handleMainButtonClick
    });
}
$d16d55893fa9b5c0$var$FiltersFloatingButton.displayName = "FiltersFloatingButton";
var $d16d55893fa9b5c0$export$dd44f18ab656f3bb = $d16d55893fa9b5c0$var$FiltersFloatingButton;
 /* react Not a pure module */ 
});


parcelRegister("gBkg7", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $c15fd1136db7b365$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $gCzsf = parcelRequire("gCzsf");

var $k0ukS = parcelRequire("k0ukS");

var $fOz3p = parcelRequire("fOz3p");

var $8E2YL = parcelRequire("8E2YL");

var $1nuZE = parcelRequire("1nuZE");

var $hQWQG = parcelRequire("hQWQG");
function $c15fd1136db7b365$var$ProductBadges$Badge(Props) {
    var badge = Props.badge;
    var children = Props.children;
    return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
        dataTestId: "product-badge",
        dataId: $iv6Yc._1($hQWQG.SectionId.toString, badge.id),
        children: /*#__PURE__*/ $g85JO.createElement("div", undefined, children)
    });
}
$c15fd1136db7b365$var$ProductBadges$Badge.displayName = "ProductBadges.Badge";
var $c15fd1136db7b365$var$make = /*#__PURE__*/ $g85JO.memo($c15fd1136db7b365$var$ProductBadges$Badge);
var $c15fd1136db7b365$export$37acb3580601e69a = {
    make: $c15fd1136db7b365$var$make
};
function $c15fd1136db7b365$export$cb901761923865e3(badge, product, variant) {
    var badgeId = $iv6Yc._1($hQWQG.SectionId.toString, badge.id);
    if (variant !== undefined) return badgeId + product.id + variant.id;
    else return badgeId + product.id;
}
function $c15fd1136db7b365$var$ProductBadges(Props) {
    var className = Props.className;
    var dataTestId = Props.dataTestId;
    var style = Props.style;
    var sizeOpt = Props.size;
    var product = Props.product;
    var variant = Props.variant;
    var size = sizeOpt !== undefined ? sizeOpt : /* Md */ 0;
    var match = $8E2YL.use(undefined);
    var config = match.config;
    var pdpConfig = $1nuZE.use(undefined);
    var className$1 = $1TRFX.make([
        $2whNH.getWithDefault(className, ""),
        $k0ukS.toString("product-card__badge-box"),
        $ezf3v.prefix("flex flex-wrap items-start justify-start"),
        size ? $ezf3v.prefix("gap-1") : $ezf3v.prefix("gap-3")
    ]);
    var badges = $i7mYY.map($i7mYY.keepMap(pdpConfig.badges, function(badge) {
        var style = {
            backgroundColor: badge.backgroundColor,
            color: badge.textColor,
            lineHeight: "normal"
        };
        var className = $1TRFX.make([
            $k0ukS.toString("product-card__badge"),
            $ezf3v.prefix("rounded-custom leading-normal"),
            size ? $ezf3v.prefix("text-base px-2 py-0.5") : $ezf3v.prefix("text-lg px-2 py-1")
        ]);
        return $2whNH.map($fOz3p.Badge.renderContent($loT9g.some(style), className, product, variant, config, badge), function(content) {
            return [
                content,
                badge
            ];
        });
    }), function(param) {
        var badge = param[1];
        return /*#__PURE__*/ $g85JO.createElement($c15fd1136db7b365$var$make, {
            badge: badge,
            children: param[0],
            key: $c15fd1136db7b365$export$cb901761923865e3(badge, product, variant)
        });
    });
    if (badges.length === 0) return null;
    var tmp = {
        "aria-label": "product badges",
        className: className$1
    };
    if (style !== undefined) tmp.style = $loT9g.valFromOption(style);
    var tmp$1 = {
        children: /*#__PURE__*/ $g85JO.createElement("div", tmp, badges)
    };
    if (dataTestId !== undefined) tmp$1.dataTestId = $loT9g.valFromOption(dataTestId);
    return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, tmp$1);
}
$c15fd1136db7b365$var$ProductBadges.displayName = "ProductBadges";
var $c15fd1136db7b365$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($c15fd1136db7b365$var$ProductBadges);
 /* make Not a pure module */ 
});

parcelRegister("5iu1A", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $3db5ec6f86ff6046$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $tUpyX = parcelRequire("tUpyX");

var $7wIsS = parcelRequire("7wIsS");

var $c0njb = parcelRequire("c0njb");

var $849Xu = parcelRequire("849Xu");

var $ePRCc = parcelRequire("ePRCc");

var $gCzsf = parcelRequire("gCzsf");

var $jBcRb = parcelRequire("jBcRb");

var $aSJcu = parcelRequire("aSJcu");

var $2wB5I = parcelRequire("2wB5I");

var $8E2YL = parcelRequire("8E2YL");
function $3db5ec6f86ff6046$var$PullDownModal(Props) {
    var children = Props.children;
    var isOpen = Props.isOpen;
    var onClose = Props.onClose;
    var learnMoreLink = Props.learnMoreLink;
    var label = Props.label;
    var showHeaderOpt = Props.showHeader;
    var fullWidthOpt = Props.fullWidth;
    var unmountOpt = Props.unmount;
    var pullDownTargetOpt = Props.pullDownTarget;
    var zIndex = Props.zIndex;
    var dataId = Props.dataId;
    var dataTestId = Props.dataTestId;
    var showHeader = showHeaderOpt !== undefined ? showHeaderOpt : true;
    var fullWidth = fullWidthOpt !== undefined ? fullWidthOpt : false;
    var unmount = unmountOpt !== undefined ? unmountOpt : true;
    var pullDownTarget = pullDownTargetOpt !== undefined ? pullDownTargetOpt : "header";
    $8E2YL.use(undefined);
    var match = $aSJcu.use(undefined);
    var breakpoint = match.breakpoint;
    var renderCloseButton = function renderCloseButton(param) {
        return /*#__PURE__*/ $g85JO.createElement($jBcRb.make, {
            className: $ezf3v.prefix($1TRFX.make([
                "w-12 h-12 flex flex-shrink-0 items-center justify-center hover:opacity-90 pointer-events-auto",
                showHeader ? "text-primary" : "m-2 bg-white rounded-full text-black"
            ])),
            onClick: function onClick(param) {
                $iv6Yc._1(onClose, undefined);
            },
            children: /*#__PURE__*/ $g85JO.createElement($7wIsS.UilTimes.make, {}),
            dataTestId: "modal-button-close"
        });
    };
    var renderLearnMore = function renderLearnMore(param) {
        if (learnMoreLink !== undefined) return /*#__PURE__*/ $g85JO.createElement($tUpyX.make, {
            children: null,
            href: learnMoreLink,
            unstyled: true,
            className: $ezf3v.prefix("text-accent font-medium text-base flex items-center space-x-1"),
            openLinkInNewTab: true
        }, /*#__PURE__*/ $g85JO.createElement("div", undefined, "Learn More"), /*#__PURE__*/ $g85JO.createElement($7wIsS.UilExternalLinkAlt.make, {
            size: /* Px */ {
                _0: 14
            }
        }));
        else return null;
    };
    var stopScrollPropagation = function stopScrollPropagation(contentOpt, e) {
        var content = contentOpt !== undefined ? contentOpt : false;
        if (content && pullDownTarget === "modal") return;
        else {
            e.stopPropagation();
            return;
        }
    };
    var stopTouchPropagation = function stopTouchPropagation(contentOpt, e) {
        var content = contentOpt !== undefined ? contentOpt : false;
        if (content && pullDownTarget === "modal") return;
        else {
            e.stopPropagation();
            return;
        }
    };
    var alignmentCn = breakpoint >= 2 ? "items-center justify-center" : "items-end";
    var roundedCn = breakpoint >= 2 ? "rounded-md" : "rounded-t-xl";
    var paddingCn = breakpoint >= 2 ? "p-6" : "";
    var widthCn = fullWidth ? "w-full" : "";
    var enter = $ezf3v.prefix(breakpoint >= 2 ? "transiton-opacity duration-200" : "transiton-transform transform ease-out-bounce duration-300");
    var leave = $ezf3v.prefix(breakpoint >= 2 ? "transiton-opacity duration-100" : "transiton-transform transform ease-out duration-300");
    var enterFrom = $ezf3v.prefix(breakpoint >= 2 ? "opacity-0" : "translate-y-full");
    var enterTo = $ezf3v.prefix(breakpoint >= 2 ? "opacity-100" : "translate-y-0");
    var leaveFrom = $ezf3v.prefix(breakpoint >= 2 ? "opacity-100" : "translate-y-0");
    var leaveTo = $ezf3v.prefix(breakpoint >= 2 ? "opacity-0" : "translate-y-full");
    var partial_arg = false;
    var partial_arg$1 = false;
    var partial_arg$2 = false;
    var partial_arg$3 = false;
    var tmp = {
        "aria-modal": true,
        className: $ezf3v.prefix($1TRFX.make([
            "fixed bottom-0 left-0 w-full h-full overflow-hidden flex",
            alignmentCn,
            isOpen ? "" : "pointer-events-none",
            zIndex !== undefined ? "" : "z-max"
        ])),
        onTouchEnd: function onTouchEnd(param) {
            return stopTouchPropagation(partial_arg, param);
        },
        onTouchMove: function onTouchMove(param) {
            return stopTouchPropagation(partial_arg$1, param);
        },
        onTouchStart: function onTouchStart(param) {
            return stopTouchPropagation(partial_arg$2, param);
        },
        onScroll: function onScroll(param) {
            return stopScrollPropagation(partial_arg$3, param);
        }
    };
    if (label !== undefined) tmp["aria-label"] = $loT9g.valFromOption(label);
    var tmp$1 = zIndex !== undefined ? {
        zIndex: String(zIndex)
    } : undefined;
    if (tmp$1 !== undefined) tmp.style = $loT9g.valFromOption(tmp$1);
    var partial_arg$4 = true;
    var partial_arg$5 = true;
    var partial_arg$6 = true;
    var partial_arg$7 = true;
    var tmp$2 = {
        children: /*#__PURE__*/ $g85JO.createElement("div", tmp, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix($1TRFX.make([
                "bg-black bg-opacity-50 absolute inset-0 transiton-opacity duration-300",
                isOpen ? "opacity-100" : "opacity-0"
            ])),
            onClick: function onClick(param) {
                $iv6Yc._1(onClose, undefined);
            }
        }), /*#__PURE__*/ $g85JO.createElement($c0njb.make, {
            onPullDown: function onPullDown(param) {
                $iv6Yc._1(onClose, undefined);
            },
            className: $ezf3v.prefix($1TRFX.make([
                "flex flex-col justify-end pointer-events-none",
                paddingCn,
                alignmentCn
            ])),
            children: null
        }, !showHeader && isOpen ? renderCloseButton(undefined) : null, /*#__PURE__*/ $g85JO.createElement($849Xu.make, {
            show: isOpen,
            unmount: unmount,
            enter: enter,
            enterFrom: enterFrom,
            enterTo: enterTo,
            leave: leave,
            leaveFrom: leaveFrom,
            leaveTo: leaveTo,
            className: $ezf3v.prefix($1TRFX.make([
                "max-h-full bg-main shadow-xl flex flex-col overflow-hidden pointer-events-auto",
                widthCn,
                roundedCn
            ])),
            children: null,
            style: {
                maxWidth: "1366px"
            },
            dataTestId: "pull-down-modal"
        }, isOpen ? /*#__PURE__*/ $g85JO.createElement($2wB5I.make, {}) : null, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("py-2 px-4 flex items-center space-x-2")
        }, showHeader ? /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("text-xl flex-grow font-semibold text-primary")
        }, $2whNH.getWithDefault(label, "")), /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("flex-shrink-0")
        }, renderLearnMore(undefined)), /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("flex-shrink-0")
        }, renderCloseButton(undefined))) : null), /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("overflow-x-hidden overflow-y-auto flex-grow relative leading-0 text-primary"),
            onTouchEnd: function onTouchEnd(param) {
                return stopTouchPropagation(partial_arg$4, param);
            },
            onTouchMove: function onTouchMove(param) {
                return stopTouchPropagation(partial_arg$5, param);
            },
            onTouchStart: function onTouchStart(param) {
                return stopTouchPropagation(partial_arg$6, param);
            },
            onScroll: function onScroll(param) {
                return stopScrollPropagation(partial_arg$7, param);
            }
        }, children))))
    };
    if (dataTestId !== undefined) tmp$2.dataTestId = $loT9g.valFromOption(dataTestId);
    if (dataId !== undefined) tmp$2.dataId = dataId;
    return /*#__PURE__*/ $g85JO.createElement($ePRCc.make, {
        initiator: "pulldown-modal",
        portal: true,
        children: /*#__PURE__*/ $g85JO.createElement($gCzsf.make, tmp$2)
    });
}
$3db5ec6f86ff6046$var$PullDownModal.displayName = "PullDownModal";
var $3db5ec6f86ff6046$export$dd44f18ab656f3bb = $3db5ec6f86ff6046$var$PullDownModal;
 /* react Not a pure module */ 
});

parcelRegister("lHzh8", function(module, exports) {

$parcel$export(module.exports, "DetailedAccordions", function () { return $fcc8fa15116a4f7a$export$9de86a6dcb1f7c50; });
$parcel$export(module.exports, "MoreSections", function () { return $fcc8fa15116a4f7a$export$4fac0316b0ae6800; });
$parcel$export(module.exports, "make", function () { return $fcc8fa15116a4f7a$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $6iioJ = parcelRequire("6iioJ");

var $3qnJm = parcelRequire("3qnJm");

var $7KlbQ = parcelRequire("7KlbQ");

var $55MCT = parcelRequire("55MCT");

var $1Ij4x = parcelRequire("1Ij4x");

var $dMhWy = parcelRequire("dMhWy");

var $cVkRC = parcelRequire("cVkRC");

var $j96aJ = parcelRequire("j96aJ");

var $b0WLQ = parcelRequire("b0WLQ");

var $l8eKb = parcelRequire("l8eKb");

var $b3dTC = parcelRequire("b3dTC");

var $8lNXy = parcelRequire("8lNXy");

var $gCzsf = parcelRequire("gCzsf");

var $1JV3u = parcelRequire("1JV3u");

var $gBkg7 = parcelRequire("gBkg7");

var $5bEXW = parcelRequire("5bEXW");

var $8L1B1 = parcelRequire("8L1B1");

var $fUtdg = parcelRequire("fUtdg");

var $hBcYV = parcelRequire("hBcYV");

var $2DUkv = parcelRequire("2DUkv");

var $fsiJD = parcelRequire("fsiJD");

var $9EMq4 = parcelRequire("9EMq4");

var $aSJcu = parcelRequire("aSJcu");

var $2ZaET = parcelRequire("2ZaET");

var $9pMGg = parcelRequire("9pMGg");

var $9KgIa = parcelRequire("9KgIa");

var $jtD5N = parcelRequire("jtD5N");

var $fOz3p = parcelRequire("fOz3p");

var $8E2YL = parcelRequire("8E2YL");

var $1nuZE = parcelRequire("1nuZE");

var $hQWQG = parcelRequire("hQWQG");

var $9FsAc = parcelRequire("9FsAc");
function $fcc8fa15116a4f7a$var$PDPContentDetailsCard$DetailedAccordions(Props) {
    var variant = Props.variant;
    var product = Props.product;
    var pdpConfig = $1nuZE.use(undefined);
    var match = $9pMGg.use(undefined);
    var trackEvent = match.trackEvent;
    var match$1 = $8E2YL.use(undefined);
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "flex flex-col smartnav-pdp__description"
        ]))
    }, /*#__PURE__*/ $g85JO.createElement($1Ij4x.make, {
        id: product.id,
        sections: $1Ij4x.fromDetailedSections(pdpConfig.detailedSections, product, variant, match$1.config),
        onChangeFocus: function onChangeFocus(id) {
            if (id === "description") return $iv6Yc.app(trackEvent, [
                "product details:description",
                undefined,
                undefined,
                product,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined
            ]);
        },
        titleStyle: "semibold-uppercase",
        truncated: true,
        forceCollapsible: true
    }));
}
$fcc8fa15116a4f7a$var$PDPContentDetailsCard$DetailedAccordions.displayName = "PDPContentDetailsCard.DetailedAccordions";
var $fcc8fa15116a4f7a$export$9de86a6dcb1f7c50 = {
    make: $fcc8fa15116a4f7a$var$PDPContentDetailsCard$DetailedAccordions
};
function $fcc8fa15116a4f7a$var$PDPContentDetailsCard$MoreSections(Props) {
    var product = Props.product;
    var moreSections = Props.moreSections;
    var match = $9pMGg.use(undefined);
    var trackEvent = match.trackEvent;
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "flex flex-col"
        ]))
    }, /*#__PURE__*/ $g85JO.createElement($1Ij4x.make, {
        id: product.id,
        sections: moreSections,
        onChangeFocus: function onChangeFocus(id) {
            if (id === "description") return $iv6Yc.app(trackEvent, [
                "product details:description",
                undefined,
                undefined,
                product,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined
            ]);
        },
        titleStyle: "semibold-uppercase",
        truncated: false
    }));
}
$fcc8fa15116a4f7a$var$PDPContentDetailsCard$MoreSections.displayName = "PDPContentDetailsCard.MoreSections";
var $fcc8fa15116a4f7a$export$4fac0316b0ae6800 = {
    make: $fcc8fa15116a4f7a$var$PDPContentDetailsCard$MoreSections
};
function $fcc8fa15116a4f7a$var$PDPContentDetailsCard$PromoSection(Props) {
    var data = Props.data;
    var product = Props.product;
    var variant = Props.variant;
    var layout = Props.layout;
    var match = $8E2YL.use(undefined);
    var contents = $fOz3p.isVisible(product, variant, data.visible) ? $fOz3p.PromoSection.renderContents($ezf3v.prefix("text-product-promo-label"), product, variant, match.config, data) : [];
    if (contents.length !== 0) return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
        dataTestId: "pdp-product-promo",
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix($1TRFX.make([
                "p-3 text-lg text-product-promo-label font-normal bg-product-promo-main select-text text-center",
                layout !== 1 ? "my-3 col-span-1" : "col-span-2"
            ]))
        }, contents)
    });
    else return null;
}
$fcc8fa15116a4f7a$var$PDPContentDetailsCard$PromoSection.displayName = "PDPContentDetailsCard.PromoSection";
var $fcc8fa15116a4f7a$export$9586e2f332c8a6f5 = {
    make: $fcc8fa15116a4f7a$var$PDPContentDetailsCard$PromoSection
};
function $fcc8fa15116a4f7a$var$make(data, product, variant, param) {
    var match = $8E2YL.use(undefined);
    var config = match.config;
    var renderSection = function renderSection(section) {
        var content = $fOz3p.SummarySection.renderContent(undefined, undefined, product, variant, config, section);
        var isAvailable;
        if (variant !== undefined) {
            var match = variant.availability;
            isAvailable = match ? true : false;
        } else isAvailable = !$7KlbQ.isOutOfStock(product);
        var renderIcon = function renderIcon(param) {
            var iconCn = $ezf3v.prefix("w-5.5 h-5.5 flex-shrink-0");
            var availabilityIcon = /*#__PURE__*/ $g85JO.createElement("div", {
                className: $1TRFX.make([
                    iconCn,
                    $ezf3v.prefix("flex items-center justify-center")
                ])
            }, isAvailable ? /*#__PURE__*/ $g85JO.createElement($cVkRC.make, {
                className: $ezf3v.prefix("w-4 h-4")
            }) : /*#__PURE__*/ $g85JO.createElement($j96aJ.make, {
                className: $ezf3v.prefix("w-4 h-4")
            }));
            var match = $iv6Yc._1($hQWQG.SectionId.toString, section.id);
            var match$1 = $fOz3p.Content.getDynamicSource(section.content);
            var match$2 = section.iconUrl.trim();
            switch(match){
                case "arrival":
                    return /*#__PURE__*/ $g85JO.createElement($b0WLQ.make, {
                        className: iconCn
                    });
                case "availability":
                    return availabilityIcon;
                case "shippingShort":
                    return /*#__PURE__*/ $g85JO.createElement($l8eKb.make, {
                        className: iconCn
                    });
                default:
                    if (match$1 !== undefined && match$1.TAG === /* Availability */ 3) return availabilityIcon;
            }
            if (match$2 !== "") return /*#__PURE__*/ $g85JO.createElement("div", {
                className: $1TRFX.make([
                    iconCn,
                    $ezf3v.prefix("relative")
                ])
            }, /*#__PURE__*/ $g85JO.createElement($55MCT.Sized.make, {
                src: match$2,
                containerWidth: 16,
                containerHeight: 16,
                fit: /* Contain */ 2,
                priority: 0
            }));
            var match$3 = section.content;
            if (match$3.TAG === /* Image */ 2) return null;
            else return /*#__PURE__*/ $g85JO.createElement("div", {
                className: $1TRFX.make([
                    iconCn,
                    $ezf3v.prefix("relative items-center justify-center flex")
                ])
            }, /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("rounded-full bg-primary w-2 h-2 inline-block")
            }));
        };
        var match$1 = $iv6Yc._1($hQWQG.SectionId.toString, section.id);
        var match$2 = section.content;
        var extraCns = match$1 === "availability" ? isAvailable ? "text-primary" : "text-tertiary" : match$2.TAG === /* DynamicSource */ 0 && match$2._0.source.TAG === /* Availability */ 3 && !isAvailable ? "text-tertiary" : "text-primary";
        var match$3 = $iv6Yc._1($hQWQG.SectionId.toString, section.id);
        var dataTestId;
        switch(match$3){
            case "arrival":
                dataTestId = "pdp-product-arrival-summary";
                break;
            case "availability":
                dataTestId = "pdp-product-availability-summary";
                break;
            case "shippingShort":
                dataTestId = "pdp-product-shipping-summary";
                break;
            default:
                dataTestId = "pdp-product-custom-summary";
        }
        if (content !== undefined) return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
            dataTestId: dataTestId,
            children: /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix($1TRFX.make([
                    "flex items-start space-x-2",
                    extraCns
                ]))
            }, renderIcon(undefined), $loT9g.valFromOption(content)),
            key: $iv6Yc._1($hQWQG.SectionId.toString, section.id)
        });
        else return null;
    };
    if (data.length !== 0) return $1Ij4x.makeSection(undefined, "summary", $loT9g.some(/*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("flex space-y-2 text-primary text-lg flex-col mt-2")
    }, $i7mYY.map(data, renderSection))), undefined, undefined, undefined, undefined, undefined);
}
var $fcc8fa15116a4f7a$export$77fc3e7c6375c538 = {
    make: $fcc8fa15116a4f7a$var$make
};
function $fcc8fa15116a4f7a$var$PDPContentDetailsCard(Props) {
    var product = Props.product;
    var variant = Props.variant;
    var productCategory = Props.productCategory;
    var shouldForceMobileOpt = Props.shouldForceMobile;
    var scrollToDetailsRef = Props.scrollToDetailsRef;
    var onCTAButtonVisibilityChange = Props.onCTAButtonVisibilityChange;
    var showHeaderOpt = Props.showHeader;
    var headerSizeOpt = Props.headerSize;
    var largeTitleStyleOpt = Props.largeTitleStyle;
    var titleSizeOpt = Props.titleSize;
    var optionSizeOpt = Props.optionSize;
    var optionStyleOpt = Props.optionStyle;
    var colorOptionSizeOpt = Props.colorOptionSize;
    var moreSectionsOpt = Props.moreSections;
    var stickyCTA = Props.stickyCTA;
    var layoutOpt = Props.layout;
    var sectionsOpt = Props.sections;
    var showSizeGuideOpt = Props.showSizeGuide;
    var singleColumnHorizontalPaddingOpt = Props.singleColumnHorizontalPadding;
    var showPrimaryCTAOpt = Props.showPrimaryCTA;
    var showSecondaryCTAOpt = Props.showSecondaryCTA;
    var showTertiaryCTAOpt = Props.showTertiaryCTA;
    var showFavoriteButtonOpt = Props.showFavoriteButton;
    var showCustomColorsOpt = Props.showCustomColors;
    var tabIndex = Props.tabIndex;
    var shouldForceMobile = shouldForceMobileOpt !== undefined ? shouldForceMobileOpt : false;
    var showHeader = showHeaderOpt !== undefined ? showHeaderOpt : true;
    var headerSize = headerSizeOpt !== undefined ? headerSizeOpt : /* Base */ 0;
    var largeTitleStyle = largeTitleStyleOpt !== undefined ? largeTitleStyleOpt : "medium";
    var titleSize = titleSizeOpt !== undefined ? titleSizeOpt : "base";
    var optionSize = optionSizeOpt !== undefined ? optionSizeOpt : /* Lg */ 3;
    var optionStyle = optionStyleOpt !== undefined ? optionStyleOpt : /* Border */ 0;
    var colorOptionSize = colorOptionSizeOpt !== undefined ? colorOptionSizeOpt : /* Lg */ 3;
    var moreSections = moreSectionsOpt !== undefined ? moreSectionsOpt : [];
    var layout = layoutOpt !== undefined ? layoutOpt : /* SingleColumn */ 0;
    var sections = sectionsOpt !== undefined ? sectionsOpt : [
        "promo",
        "summary",
        "variants",
        "quantity",
        "cta"
    ];
    var showSizeGuide = showSizeGuideOpt !== undefined ? showSizeGuideOpt : true;
    var singleColumnHorizontalPadding = singleColumnHorizontalPaddingOpt !== undefined ? singleColumnHorizontalPaddingOpt : "px-6";
    var showPrimaryCTA = showPrimaryCTAOpt !== undefined ? showPrimaryCTAOpt : true;
    var showSecondaryCTA = showSecondaryCTAOpt !== undefined ? showSecondaryCTAOpt : true;
    var showTertiaryCTA = showTertiaryCTAOpt !== undefined ? showTertiaryCTAOpt : true;
    var showFavoriteButton = showFavoriteButtonOpt !== undefined ? showFavoriteButtonOpt : true;
    var showCustomColors = showCustomColorsOpt !== undefined ? showCustomColorsOpt : true;
    var store = $8L1B1.use(undefined);
    var displayVariantBy = $jtD5N.useDisplayVariantBy(undefined);
    var match = $8E2YL.use(undefined);
    var settings = match.config.settings;
    var match$1 = $aSJcu.use(undefined);
    var entrypointContext = $9pMGg.use(undefined);
    var pdpConfig = $1nuZE.use(undefined);
    var trackEvent = entrypointContext.trackEvent;
    $hBcYV.useRouter(undefined);
    var desktopHeaderContentRef = $g85JO.useRef(null);
    var isMobile = match$1.isMobile || shouldForceMobile;
    var stickyCTA$1 = $2whNH.getWithDefault(stickyCTA, isMobile);
    var selectedVariant = variant !== undefined ? variant : $7KlbQ.getVariantBySelector(product, displayVariantBy);
    var match$2 = $g85JO.useState(function() {
        return false;
    });
    var setShowScrollToTopButton = match$2[1];
    var showScrollToTopButton = match$2[0];
    var productDetailsSize = $2whNH.getWithDefault($9EMq4.useResizeObserver(desktopHeaderContentRef), {
        width: -1,
        height: -1,
        top: -1
    });
    var renderSizeGuideButton = function renderSizeGuideButton(param) {
        var sizeGuide = settings.pdpSizeGuide;
        if (sizeGuide === undefined) return null;
        if (!showSizeGuide) return null;
        var tmp = {
            sizeGuide: sizeGuide,
            product: product,
            variant: selectedVariant
        };
        var tmp$1 = $2whNH.map(productCategory, function(category) {
            return category.id;
        });
        if (tmp$1 !== undefined) tmp.activeCategoryId = $loT9g.valFromOption(tmp$1);
        return /*#__PURE__*/ $g85JO.createElement($2DUkv.make, tmp);
    };
    var match$3 = $3qnJm.use(undefined);
    var fields = match$3.form.fields;
    var options = $i7mYY.keep($i7mYY.mapWithIndex(fields, function(i, field) {
        var separator = i === (fields.length - 2 | 0) ? " & " : i === (fields.length - 1 | 0) ? "" : ", ";
        if (field.options.length > 1) return field.label + separator;
        else return "";
    }), function(x) {
        return x !== "";
    }).join("");
    var options$1 = options === "" ? undefined : "See All " + options + " Options";
    var scrollToTopButton = options$1 !== undefined ? $loT9g.some(/*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            stickyCTA$1 && showScrollToTopButton ? "opacity-100" : "opacity-0 pointer-events-none",
            "font-bold text-sm absolute bottom-2 left-6 transition-opacity duration-150"
        ]))
    }, /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
        dataTestId: "pdp-see-all-options-button",
        children: /*#__PURE__*/ $g85JO.createElement("span", {
            className: $ezf3v.prefix("text-accent hover:underline cursor-pointer select-none"),
            onClick: function onClick(e) {
                $iv6Yc._1(scrollToDetailsRef.current, undefined);
            }
        }, options$1.toUpperCase())
    }))) : undefined;
    var showingDesktopSticky = stickyCTA$1 && showScrollToTopButton && $2whNH.isSome(scrollToTopButton);
    var productPriceContent = /*#__PURE__*/ $g85JO.createElement($8lNXy.make, {
        at: /* PDP */ 0,
        product: product,
        variant: selectedVariant,
        size: isMobile ? /* Md */ 1 : /* Xl */ 0,
        align: isMobile ? /* Right */ 1 : /* Left */ 0,
        minPriceFirst: !isMobile,
        multiline: isMobile,
        bold: false
    });
    var productPriceContent$1 = isMobile ? /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("-mt-2")
    }, productPriceContent) : /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("pt-2")
    }, productPriceContent);
    var tmp = {
        at: /* PDP */ 0,
        product: product,
        className: $ezf3v.prefix("mt-2")
    };
    if (variant !== undefined) tmp.variant = $loT9g.valFromOption(variant);
    var headerContent = /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("flex items-start select-text flex-col")
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "flex",
            isMobile ? "w-full space-x-4" : "w-9/12",
            layout !== 1 ? isMobile ? "pt-6" : "py-6" : ""
        ]))
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            showingDesktopSticky ? "scale-85" : "scale-100",
            "transform-gpu transition-transform origin-top-left duration-150 flex-grow"
        ]))
    }, /*#__PURE__*/ $g85JO.createElement($gBkg7.make, {
        className: $ezf3v.prefix("mb-2"),
        dataTestId: "pdp-product-badges",
        product: product,
        variant: selectedVariant
    }), /*#__PURE__*/ $g85JO.createElement("div", {
        "aria-level": 1,
        className: $ezf3v.prefix($1TRFX.make([
            "text-secondary font-heading pb-1 select-text",
            headerSize ? "text-5xl font-semibold" : "text-xl"
        ])),
        role: "heading",
        tabIndex: 0
    }, /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
        dataTestId: "pdp-product-title",
        children: /*#__PURE__*/ $g85JO.createElement("div", undefined, $7KlbQ.getDisplayName(store, selectedVariant, product))
    })), /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: !isMobile,
        children: productPriceContent$1
    }), /*#__PURE__*/ $g85JO.createElement($fUtdg.make, tmp)), /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: isMobile,
        children: productPriceContent$1
    }), $2whNH.getWithDefault(scrollToTopButton, null)));
    var headerContent$1 = stickyCTA$1 ? /*#__PURE__*/ $g85JO.createElement("div", {
        ref: $5bEXW.Ref.domRef(desktopHeaderContentRef),
        className: $ezf3v.prefix("sticky top-0 bg-main -mx-6 px-6 mb-4"),
        style: {
            zIndex: "11"
        }
    }, headerContent) : /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("mb-4")
    }, headerContent);
    var showQuantity = settings.quantityPicker;
    var renderQuantity = function renderQuantity(param) {
        return /*#__PURE__*/ $g85JO.createElement($3qnJm.QuantityPicker.make, {
            optionSize: optionSize
        });
    };
    var onRenderVariantFields = $g85JO.useCallback(function(inline) {
        return function(field, onChange, fieldElement) {
            var requireSizeGuide = field.name.toLowerCase().includes("size");
            var tmp = {
                active: $iv6Yc._1($b3dTC.FieldId.toString, field.id),
                id: $iv6Yc._1($b3dTC.FieldId.toString, field.id),
                className: inline ? $ezf3v.prefix("pb-2") : $ezf3v.prefix("py-4"),
                titleStyle: largeTitleStyle,
                titleSize: titleSize,
                children: null
            };
            var tmp$1 = requireSizeGuide ? $loT9g.some(renderSizeGuideButton(undefined)) : undefined;
            if (tmp$1 !== undefined) tmp.contentRight = $loT9g.valFromOption(tmp$1);
            var match = field.value;
            var match$1 = field.initialValue;
            return /*#__PURE__*/ $g85JO.createElement((0, (/*@__PURE__*/$parcel$interopDefault($fsiJD))), {
                partialVisibility: false,
                onChange: function onChange(visible) {
                    $iv6Yc._1(setShowScrollToTopButton, function(param) {
                        return !visible;
                    });
                },
                children: /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
                    dataSectionId: field.name.toLocaleLowerCase() + "s",
                    children: /*#__PURE__*/ $g85JO.createElement("div", {
                        className: inline ? $ezf3v.prefix("pr-8") : $ezf3v.prefix("pb-2")
                    }, /*#__PURE__*/ $g85JO.createElement($1Ij4x.Header.make, tmp, field.label, /*#__PURE__*/ $g85JO.createElement($2ZaET.OptionMap.make, {
                        option: match !== undefined ? field.value : match$1 !== undefined ? field.initialValue : undefined,
                        condition: function condition(param) {
                            return field.kind === /* SwatchButton */ 1;
                        },
                        children: function children(value) {
                            return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, ": ", /*#__PURE__*/ $g85JO.createElement("div", {
                                className: $ezf3v.prefix("inline text-secondary font-bold")
                            }, value));
                        }
                    })), fieldElement)
                })
            });
        };
    }, [
        setShowScrollToTopButton,
        settings.pdpSizeGuide
    ]);
    var dropdownDirection = $g85JO.useCallback(function(inline) {
        var match = settings.desktopPDPLayout;
        if (match !== 0) return [
            inline ? /* Right */ 1 : /* Left */ 0,
            /* Top */ 0
        ];
        else return [
            inline ? /* Right */ 1 : /* Left */ 0,
            /* Bottom */ 1
        ];
    }, [
        settings.desktopPDPLayout
    ]);
    var renderAccordionContent = function renderAccordionContent(moreSectionsOpt, param) {
        var moreSections = moreSectionsOpt !== undefined ? moreSectionsOpt : [];
        var inline = layout === /* Inline */ 2;
        var partial_arg = inline;
        return /*#__PURE__*/ $g85JO.createElement($1Ij4x.make, {
            id: product.id,
            sections: $i7mYY.concat($i7mYY.keepMap(sections, function(param) {
                var inline = partial_arg !== undefined ? partial_arg : false;
                if (param === "variants") {
                    var tmp = {
                        dropdownDirection: $iv6Yc._1(dropdownDirection, inline),
                        optionSize: optionSize,
                        optionStyle: optionStyle,
                        colorOptionSize: colorOptionSize,
                        hideEmptyOptions: inline,
                        scrollIntoViewOnError: !inline,
                        onRender: $iv6Yc._1(onRenderVariantFields, inline)
                    };
                    var tmp$1 = inline ? 5 : undefined;
                    if (tmp$1 !== undefined) tmp.truncateAt = tmp$1;
                    if (tabIndex !== undefined) tmp.tabIndex = $loT9g.valFromOption(tabIndex);
                    return $1Ij4x.makeSection({
                        TAG: /* Element */ 1,
                        _0: null
                    }, inline ? "sticky-variants" : "variants", $loT9g.some(/*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, showCustomColors ? /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement($9FsAc.make, {
                        product: product,
                        inline: inline
                    }), /*#__PURE__*/ $g85JO.createElement($9KgIa.ColorPicker.make, {
                        inline: inline,
                        product: product
                    })) : null, /*#__PURE__*/ $g85JO.createElement($3qnJm.AllFields.make, tmp))), undefined, undefined, undefined, false, undefined);
                }
                if (param !== "cta") {
                    if (param === "summary") return $fcc8fa15116a4f7a$var$make(pdpConfig.summarySections, product, selectedVariant, undefined);
                    else if (param === "quantity") return $1Ij4x.makeSection({
                        TAG: /* Text */ 0,
                        _0: "Quantity"
                    }, "quantity", showQuantity ? $loT9g.some(renderQuantity(undefined)) : undefined, undefined, undefined, undefined, undefined, undefined);
                    else return;
                }
                var tmp$2;
                if (showFavoriteButton) {
                    var tmp$3 = {
                        product: product,
                        at: inline ? /* PDPSticky */ 2 : /* PDP */ 1
                    };
                    if (tabIndex !== undefined) tmp$3.tabIndex = $loT9g.valFromOption(tabIndex);
                    tmp$2 = $loT9g.some(/*#__PURE__*/ $g85JO.createElement($dMhWy.ToggleButton.make, tmp$3));
                } else tmp$2 = undefined;
                var tmp$4 = {
                    product: product,
                    variant: selectedVariant,
                    isMobile: isMobile,
                    size: inline ? /* Xl */ 3 : /* Lg */ 1,
                    primary: showPrimaryCTA,
                    secondary: !inline && showSecondaryCTA,
                    tertiary: !inline && showTertiaryCTA
                };
                if (tmp$2 !== undefined) tmp$4.extraButton = $loT9g.valFromOption(tmp$2);
                if (tabIndex !== undefined) tmp$4.tabIndex = $loT9g.valFromOption(tabIndex);
                var partial_arg$1 = inline;
                return $1Ij4x.makeSection(undefined, "cta buttons", $loT9g.some(/*#__PURE__*/ $g85JO.createElement($6iioJ.make, tmp$4)), function(param) {
                    var inline = partial_arg$1 !== undefined ? partial_arg$1 : false;
                    if (inline) return param;
                    var match = settings.desktopPDPLayout;
                    var tmp;
                    switch(match){
                        case /* Old */ 0:
                            tmp = /* Visible */ 3;
                            break;
                        case /* Horizontal */ 1:
                            tmp = /* HiddenTop */ 0;
                            break;
                        case /* Vertical */ 2:
                            tmp = /* HiddenBottom */ 1;
                            break;
                    }
                    var tmp$1 = {
                        style: {
                            top: $ezf3v.intToPx(productDetailsSize.height),
                            zIndex: "1"
                        },
                        className: $ezf3v.prefix($1TRFX.make([
                            stickyCTA$1 ? "-mx-6 px-6" : "",
                            stickyCTA$1 && isMobile ? "-mb-4" : "",
                            stickyCTA$1 ? "sticky top-0 bg-main" : "relative",
                            "mt-4 pb-4"
                        ])),
                        initial: tmp,
                        children: param,
                        key: product.id
                    };
                    if (onCTAButtonVisibilityChange !== undefined) tmp$1.onChangeVisibility = $loT9g.valFromOption(onCTAButtonVisibilityChange);
                    return /*#__PURE__*/ $g85JO.createElement($1JV3u.make, tmp$1);
                }, undefined, undefined, undefined, undefined);
            }), moreSections),
            onChangeFocus: function onChangeFocus(id) {
                if (id === "description") return $iv6Yc.app(trackEvent, [
                    "product details:description",
                    undefined,
                    undefined,
                    product,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined
                ]);
            },
            titleStyle: largeTitleStyle,
            titleSize: titleSize,
            inline: inline,
            truncated: false
        });
    };
    var renderDetailedAccordions = function renderDetailedAccordions(param) {
        return /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix($1TRFX.make([
                "flex-grow"
            ]))
        }, /*#__PURE__*/ $g85JO.createElement($fcc8fa15116a4f7a$var$PDPContentDetailsCard$DetailedAccordions, {
            variant: selectedVariant,
            product: product
        }));
    };
    var tmp$1;
    switch(layout){
        case /* SingleColumn */ 0:
            tmp$1 = {
                gridTemplateColumns: "minmax(0, 600px)"
            };
            break;
        case /* TwoColumns */ 1:
            tmp$1 = {
                gridTemplateColumns: "minmax(0, 591px) minmax(0, 591px)"
            };
            break;
        case /* Inline */ 2:
            tmp$1 = {
                gridTemplateColumns: "1fr"
            };
            break;
    }
    var tmp$2 = {
        className: $ezf3v.prefix($1TRFX.make([
            "grid grid-rows-1 justify-center",
            layout !== 1 ? "" : "gap-x-6 gap-y-3 mb-8"
        ]))
    };
    if (tmp$1 !== undefined) tmp$2.style = $loT9g.valFromOption(tmp$1);
    var match$4 = $i7mYY.some(sections, function(s) {
        return s === "promo";
    });
    var match$5 = $i7mYY.getBy(sections, function(section) {
        return section === "detailed";
    });
    var tmp$3;
    var exit = 0;
    switch(layout){
        case /* SingleColumn */ 0:
            if (stickyCTA$1) tmp$3 = renderAccordionContent(moreSections, undefined);
            else exit = 1;
            break;
        case /* TwoColumns */ 1:
            tmp$3 = /*#__PURE__*/ $g85JO.createElement("div", undefined, /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix($1TRFX.make([
                    "flex-grow flex flex-col",
                    layout !== 1 ? "" : "p-10 shadow-lg"
                ]))
            }, showHeader ? headerContent$1 : null, renderAccordionContent(undefined, undefined)));
            break;
        case /* Inline */ 2:
            exit = 1;
            break;
    }
    if (exit === 1) tmp$3 = /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "flex-grow flex flex-col",
            layout !== 1 ? "" : "p-10 shadow-lg"
        ]))
    }, renderAccordionContent(undefined, undefined));
    var match$6 = $i7mYY.getBy(sections, function(section) {
        return section === "detailed";
    });
    var tmp$4;
    var exit$1 = 0;
    if (layout !== 0 || !stickyCTA$1) exit$1 = 1;
    else tmp$4 = null;
    if (exit$1 === 1) tmp$4 = /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "flex-grow"
        ]))
    }, /*#__PURE__*/ $g85JO.createElement($fcc8fa15116a4f7a$var$PDPContentDetailsCard$MoreSections, {
        product: product,
        moreSections: moreSections
    }));
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "flex-grow flex flex-col flex-shrink-0",
            layout !== 0 ? "" : singleColumnHorizontalPadding
        ]))
    }, showHeader && layout !== 1 ? headerContent$1 : null, /*#__PURE__*/ $g85JO.createElement("div", tmp$2, match$4 ? /*#__PURE__*/ $g85JO.createElement($fcc8fa15116a4f7a$var$PDPContentDetailsCard$PromoSection, {
        data: pdpConfig.promoSection,
        product: product,
        variant: selectedVariant,
        layout: layout
    }) : null, layout !== 1 || match$5 === undefined ? null : /*#__PURE__*/ $g85JO.createElement("div", undefined, renderDetailedAccordions(undefined)), tmp$3), /*#__PURE__*/ $g85JO.createElement("div", undefined, layout !== 0 || match$6 === undefined ? null : /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("border-t border-primary opacity-5 h-0 mt-4")
    }), renderDetailedAccordions(undefined), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("border-t border-primary opacity-5 h-0")
    }))), tmp$4);
}
$fcc8fa15116a4f7a$var$PDPContentDetailsCard.displayName = "PDPContentDetailsCard";
var $fcc8fa15116a4f7a$export$dd44f18ab656f3bb = $fcc8fa15116a4f7a$var$PDPContentDetailsCard;
 /* react Not a pure module */ 
});
parcelRegister("6iioJ", function(module, exports) {

$parcel$export(module.exports, "OverrideContextProvider", function () { return $4952b1f0ebd807e0$export$9fabb36cda1378cf; });
$parcel$export(module.exports, "make", function () { return $4952b1f0ebd807e0$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $3qnJm = parcelRequire("3qnJm");

var $7KlbQ = parcelRequire("7KlbQ");

var $dzlIC = parcelRequire("dzlIC");

var $aSJcu = parcelRequire("aSJcu");

var $9pMGg = parcelRequire("9pMGg");

var $5CE1l = parcelRequire("5CE1l");

var $edu9N = parcelRequire("edu9N");

var $8E2YL = parcelRequire("8E2YL");
function $4952b1f0ebd807e0$var$getActionLabel(action) {
    switch(action.TAG | 0){
        case /* AddToCart */ 0:
            return action._0.label;
        case /* OpenLink */ 1:
            return action._0;
        case /* Custom */ 2:
            return action._0.label;
        case /* CustomAction */ 3:
            return action._0.label;
    }
}
function $4952b1f0ebd807e0$var$actionFromLegacy(action) {
    switch(action.TAG | 0){
        case /* AddToCart */ 0:
            var match = action._0;
            return {
                TAG: /* AddToCart */ 0,
                _0: {
                    textColor: match.textColor,
                    bgColor: match.bgColor,
                    label: match.label,
                    overrideLabel: undefined,
                    confirmationMessage: match.confirmationMessage
                }
            };
        case /* OpenLink */ 1:
            return {
                TAG: /* OpenLink */ 1,
                _0: action._0
            };
        case /* CustomAction */ 2:
            var match$1 = action._0;
            return {
                TAG: /* CustomAction */ 3,
                _0: {
                    id: match$1.id,
                    textColor: match$1.textColor,
                    bgColor: match$1.bgColor,
                    label: match$1.label,
                    confirmationMessage: match$1.confirmationMessage,
                    onClickFn: match$1.onClickFn,
                    renderFn: match$1.renderFn
                }
            };
    }
}
function $4952b1f0ebd807e0$var$fromSettingsPDPCTAConfig(param) {
    return {
        primary: $4952b1f0ebd807e0$var$actionFromLegacy(param.primary),
        secondary: $2whNH.map(param.secondary, $4952b1f0ebd807e0$var$actionFromLegacy),
        tertiary: $2whNH.map(param.tertiary, $4952b1f0ebd807e0$var$actionFromLegacy)
    };
}
var $4952b1f0ebd807e0$var$context = /*#__PURE__*/ $g85JO.createContext(undefined);
var $4952b1f0ebd807e0$var$provider = $4952b1f0ebd807e0$var$context.Provider;
function $4952b1f0ebd807e0$var$CTABar$OverrideContextProvider(Props) {
    var value = Props.value;
    var children = Props.children;
    return /*#__PURE__*/ $g85JO.createElement($4952b1f0ebd807e0$var$provider, {
        value: value,
        children: children
    });
}
$4952b1f0ebd807e0$var$CTABar$OverrideContextProvider.displayName = "CTABar.OverrideContextProvider";
function $4952b1f0ebd807e0$var$useWithDefault($$default) {
    var $$default$1 = $4952b1f0ebd807e0$var$fromSettingsPDPCTAConfig($$default);
    return $2whNH.mapWithDefault($g85JO.useContext($4952b1f0ebd807e0$var$context), $$default$1, function(values) {
        var run = values.onClickPrimaryButton;
        var run$1 = values.onClickSecondaryButton;
        return {
            primary: run !== undefined ? {
                TAG: /* Custom */ 2,
                _0: {
                    label: $2whNH.getWithDefault(values.primaryButtonLabel, ""),
                    disabledLabel: undefined,
                    confirmationMessage: values.primaryButtonConfirmation,
                    style: values.primaryButtonStyle,
                    run: run
                }
            } : $$default$1.primary,
            secondary: run$1 !== undefined ? {
                TAG: /* Custom */ 2,
                _0: {
                    label: $2whNH.getWithDefault(values.secondaryButtonLabel, ""),
                    disabledLabel: undefined,
                    confirmationMessage: values.secondaryButtonConfirmation,
                    style: undefined,
                    run: run$1
                }
            } : $$default$1.secondary,
            tertiary: $$default$1.tertiary
        };
    });
}
var $4952b1f0ebd807e0$export$9fabb36cda1378cf = {
    getActionLabel: $4952b1f0ebd807e0$var$getActionLabel,
    actionFromLegacy: $4952b1f0ebd807e0$var$actionFromLegacy,
    fromSettingsPDPCTAConfig: $4952b1f0ebd807e0$var$fromSettingsPDPCTAConfig,
    context: $4952b1f0ebd807e0$var$context,
    provider: $4952b1f0ebd807e0$var$provider,
    make: $4952b1f0ebd807e0$var$CTABar$OverrideContextProvider,
    useWithDefault: $4952b1f0ebd807e0$var$useWithDefault
};
function $4952b1f0ebd807e0$var$buttonExists(cta, product, variant) {
    if (cta.TAG !== /* CustomAction */ 3) return true;
    var match = cta._0;
    var label = match.label;
    var html = $2whNH.flatMap(match.renderFn, function(code) {
        return $dzlIC.triggerCustomFunctionReturningString(code, product, variant, label, undefined, undefined);
    });
    if (html === "") return false;
    else return true;
}
function $4952b1f0ebd807e0$var$CTABar$CTAButtonWrapper(Props) {
    var product = Props.product;
    var variant = Props.variant;
    var isMobile = Props.isMobile;
    var cta = Props.cta;
    var disableWhenOutOfStock = Props.disableWhenOutOfStock;
    var isPrimaryOpt = Props.isPrimary;
    var size = Props.size;
    var onSubmit = Props.onSubmit;
    var tabIndex = Props.tabIndex;
    var isPrimary = isPrimaryOpt !== undefined ? isPrimaryOpt : false;
    var match = $aSJcu.use(undefined);
    var match$1 = $9pMGg.use(undefined);
    var trackEvent = match$1.trackEvent;
    var isMobile$1 = $2whNH.getWithDefault(isMobile, match.isMobile);
    var match$2 = $8E2YL.use(undefined);
    var settings = match$2.config.settings;
    var ctaSize = isMobile$1 ? /* Md */ 2 : size !== undefined ? size : undefined;
    switch(cta.TAG | 0){
        case /* AddToCart */ 0:
            var match$3 = cta._0;
            var overrideLabel = match$3.overrideLabel;
            var disabledLabel = $2whNH.getWithDefault(overrideLabel, settings.outOfStockLabel);
            var label = $2whNH.getWithDefault(overrideLabel, match$3.label);
            var style = isPrimary ? {
                backgroundColor: match$3.bgColor,
                color: match$3.textColor
            } : undefined;
            var tmp = {
                primary: isPrimary,
                labelDataTestId: "open-link-label",
                dataTestId: "pdp-button-add-to-cart"
            };
            if (ctaSize !== undefined) tmp.size = $loT9g.valFromOption(ctaSize);
            if (style !== undefined) tmp.style = $loT9g.valFromOption(style);
            if (tabIndex !== undefined) tmp.tabIndex = $loT9g.valFromOption(tabIndex);
            var tmp$1 = {
                children: /*#__PURE__*/ $g85JO.createElement($edu9N.make, tmp),
                label: label,
                disabledLabel: disabledLabel,
                submitButtonType: /* AddToCart */ 0
            };
            if (disableWhenOutOfStock !== undefined) tmp$1.disableWhenOutOfStock = disableWhenOutOfStock;
            if (onSubmit !== undefined) tmp$1.onSubmit = $loT9g.valFromOption(onSubmit);
            return /*#__PURE__*/ $g85JO.createElement($3qnJm.SubmitButton.make, tmp$1);
        case /* OpenLink */ 1:
            var tmp$2 = {
                disabled: false,
                primary: isPrimary,
                labelDataTestId: "open-link-label",
                dataTestId: "pdp-button-open-link"
            };
            if (ctaSize !== undefined) tmp$2.size = $loT9g.valFromOption(ctaSize);
            if (tabIndex !== undefined) tmp$2.tabIndex = $loT9g.valFromOption(tabIndex);
            var tmp$3 = {
                children: /*#__PURE__*/ $g85JO.createElement($edu9N.make, tmp$2),
                label: cta._0,
                submitButtonType: /* OpenLink */ 1
            };
            if (onSubmit !== undefined) tmp$3.onSubmit = $loT9g.valFromOption(onSubmit);
            return /*#__PURE__*/ $g85JO.createElement($3qnJm.SubmitButton.make, tmp$3);
        case /* Custom */ 2:
            var match$4 = cta._0;
            var style$1 = isPrimary ? match$4.style : undefined;
            var tmp$4 = {
                primary: isPrimary,
                labelDataTestId: "custom-label",
                dataTestId: "pdp-button-custom"
            };
            if (ctaSize !== undefined) tmp$4.size = $loT9g.valFromOption(ctaSize);
            if (style$1 !== undefined) tmp$4.style = $loT9g.valFromOption(style$1);
            if (tabIndex !== undefined) tmp$4.tabIndex = $loT9g.valFromOption(tabIndex);
            var tmp$5 = {
                children: /*#__PURE__*/ $g85JO.createElement($edu9N.make, tmp$4),
                label: match$4.label,
                submitButtonType: /* Custom */ {
                    confirmation: match$4.confirmationMessage,
                    run: match$4.run
                }
            };
            if (match$4.disabledLabel !== undefined) tmp$5.disabledLabel = match$4.disabledLabel;
            if (onSubmit !== undefined) tmp$5.onSubmit = $loT9g.valFromOption(onSubmit);
            return /*#__PURE__*/ $g85JO.createElement($3qnJm.SubmitButton.make, tmp$5);
        case /* CustomAction */ 3:
            var match$5 = cta._0;
            var onClickFn = match$5.onClickFn;
            var confirmationMessage = match$5.confirmationMessage;
            var label$1 = match$5.label;
            var id = match$5.id;
            var disabledLabel$1 = settings.outOfStockLabel;
            var style$2 = {
                backgroundColor: match$5.bgColor,
                color: match$5.textColor
            };
            var html = $2whNH.flatMap(match$5.renderFn, function(code) {
                return $dzlIC.triggerCustomFunctionReturningString(code, product, variant, label$1, undefined, undefined);
            });
            var tmp$6;
            if (html !== undefined) tmp$6 = /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("inline-block cursor-pointer select-none flex flex-grow"),
                dangerouslySetInnerHTML: {
                    __html: html
                }
            });
            else {
                var tmp$7 = {
                    primary: isPrimary,
                    labelDataTestId: "custom-action-label",
                    dataTestId: "pdp-button-custom-action"
                };
                if (ctaSize !== undefined) tmp$7.size = $loT9g.valFromOption(ctaSize);
                if (style$2 !== undefined) tmp$7.style = $loT9g.valFromOption(style$2);
                if (tabIndex !== undefined) tmp$7.tabIndex = $loT9g.valFromOption(tabIndex);
                tmp$6 = /*#__PURE__*/ $g85JO.createElement($edu9N.make, tmp$7);
            }
            var tmp$8 = confirmationMessage === "" ? undefined : confirmationMessage;
            var tmp$9 = {
                children: tmp$6,
                label: label$1,
                disabledLabel: disabledLabel$1,
                submitButtonType: /* Custom */ {
                    confirmation: tmp$8,
                    run: function run(product, variant, quantity) {
                        $iv6Yc.app(trackEvent, [
                            {
                                NAME: "clicked action",
                                VAL: id
                            },
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined
                        ]);
                        $dzlIC.triggerCustomFunction(onClickFn, product, variant, quantity, "CTA button", undefined, undefined);
                    }
                }
            };
            if (onSubmit !== undefined) tmp$9.onSubmit = $loT9g.valFromOption(onSubmit);
            return /*#__PURE__*/ $g85JO.createElement($3qnJm.SubmitButton.make, tmp$9);
    }
}
$4952b1f0ebd807e0$var$CTABar$CTAButtonWrapper.displayName = "CTABar.CTAButtonWrapper";
var $4952b1f0ebd807e0$export$4eb2679d8d804029 = {
    buttonExists: $4952b1f0ebd807e0$var$buttonExists,
    make: $4952b1f0ebd807e0$var$CTABar$CTAButtonWrapper
};
function $4952b1f0ebd807e0$var$CTABar(Props) {
    var product = Props.product;
    var variant = Props.variant;
    var isMobile = Props.isMobile;
    var size = Props.size;
    var primaryOpt = Props.primary;
    var secondaryOpt = Props.secondary;
    var tertiaryOpt = Props.tertiary;
    var extraButton = Props.extraButton;
    var tabIndex = Props.tabIndex;
    var primary = primaryOpt !== undefined ? primaryOpt : true;
    var secondary = secondaryOpt !== undefined ? secondaryOpt : true;
    var tertiary = tertiaryOpt !== undefined ? tertiaryOpt : true;
    var match = $8E2YL.use(undefined);
    var match$1 = match.config;
    var transitiveAccount = match$1.transitiveAccount;
    var ctaConfig = $4952b1f0ebd807e0$var$useWithDefault(match$1.settings.pdpCTAConfig);
    var match$2 = ctaConfig.primary;
    var match$3 = ctaConfig.secondary;
    var match$4 = ctaConfig.tertiary;
    var hasAddToCartButton;
    var exit = 0;
    var exit$1 = 0;
    if (match$2 !== undefined && match$2.TAG === /* AddToCart */ 0) hasAddToCartButton = true;
    else exit$1 = 2;
    if (exit$1 === 2) {
        if (match$3 !== undefined && match$3.TAG === /* AddToCart */ 0) hasAddToCartButton = true;
        else exit = 1;
    }
    if (exit === 1) hasAddToCartButton = match$4 !== undefined && match$4.TAG === /* AddToCart */ 0 ? true : false;
    var match$5 = ctaConfig.primary;
    var match$6 = ctaConfig.secondary;
    var match$7 = ctaConfig.tertiary;
    var hasOpenLinkButton;
    var exit$2 = 0;
    var exit$3 = 0;
    if (match$5 !== undefined && match$5.TAG === /* OpenLink */ 1) hasOpenLinkButton = true;
    else exit$3 = 2;
    if (exit$3 === 2) {
        if (match$6 !== undefined && match$6.TAG === /* OpenLink */ 1) hasOpenLinkButton = true;
        else exit$2 = 1;
    }
    if (exit$2 === 1) hasOpenLinkButton = match$7 !== undefined && match$7.TAG === /* OpenLink */ 1 ? true : false;
    var hideAddToCartButton = hasAddToCartButton && $2whNH.mapWithDefault($2whNH.flatMap(transitiveAccount, function(account) {
        return account.productRules.hideAddToCartButton;
    }), false, function(rule) {
        return $5CE1l.matchesProduct(rule, product, variant);
    });
    var hideOpenLinkButton = hasOpenLinkButton && $2whNH.mapWithDefault($2whNH.flatMap(transitiveAccount, function(account) {
        return account.productRules.hideOpenLinkButton;
    }), false, function(rule) {
        return $5CE1l.matchesProduct(rule, product, variant);
    });
    var hideOpenLinkButton$1 = hideOpenLinkButton && !hideAddToCartButton;
    var overrideAddToCartLabel = $2whNH.flatMap($2whNH.flatMap(transitiveAccount, function(account) {
        return account.productRules.customAddToCartText;
    }), function(data) {
        if ($5CE1l.matchesProduct(data.rule, product, variant)) return data;
    });
    var disableWhenOutOfStock = $2whNH.mapWithDefault(overrideAddToCartLabel, true, function(data) {
        return !data.overrideOutOfStock;
    });
    var overrideAddToCartLabel$1 = $2whNH.map(overrideAddToCartLabel, function(data) {
        return data.text;
    });
    var moveUpPrimary = function moveUpPrimary(ctaConfig) {
        var match = ctaConfig.primary;
        var swap;
        if (match !== undefined) switch(match.TAG | 0){
            case /* AddToCart */ 0:
                swap = hideAddToCartButton;
                break;
            case /* OpenLink */ 1:
                swap = hideOpenLinkButton$1;
                break;
            case /* Custom */ 2:
            case /* CustomAction */ 3:
                swap = false;
                break;
        }
        else swap = false;
        return {
            primary: swap ? ctaConfig.secondary : ctaConfig.primary,
            secondary: ctaConfig.secondary,
            tertiary: ctaConfig.tertiary
        };
    };
    var moveUpSecondary = function moveUpSecondary(ctaConfig) {
        var match = ctaConfig.secondary;
        var tmp;
        if (match !== undefined) switch(match.TAG | 0){
            case /* AddToCart */ 0:
                tmp = hideAddToCartButton;
                break;
            case /* OpenLink */ 1:
                tmp = hideOpenLinkButton$1;
                break;
            case /* Custom */ 2:
            case /* CustomAction */ 3:
                tmp = false;
                break;
        }
        else tmp = false;
        var swap = tmp || $7bjme.equal($2whNH.map(ctaConfig.primary, $4952b1f0ebd807e0$var$getActionLabel), $2whNH.map(ctaConfig.secondary, $4952b1f0ebd807e0$var$getActionLabel));
        return {
            primary: ctaConfig.primary,
            secondary: swap ? ctaConfig.tertiary : ctaConfig.secondary,
            tertiary: ctaConfig.tertiary
        };
    };
    var moveUpTertiary = function moveUpTertiary(ctaConfig) {
        var match = ctaConfig.tertiary;
        var tmp;
        if (match !== undefined) switch(match.TAG | 0){
            case /* AddToCart */ 0:
                tmp = hideAddToCartButton;
                break;
            case /* OpenLink */ 1:
                tmp = hideOpenLinkButton$1;
                break;
            case /* Custom */ 2:
            case /* CustomAction */ 3:
                tmp = false;
                break;
        }
        else tmp = false;
        var swap = tmp || $7bjme.equal($2whNH.map(ctaConfig.secondary, $4952b1f0ebd807e0$var$getActionLabel), $2whNH.map(ctaConfig.tertiary, $4952b1f0ebd807e0$var$getActionLabel));
        return {
            primary: ctaConfig.primary,
            secondary: ctaConfig.secondary,
            tertiary: swap ? undefined : ctaConfig.tertiary
        };
    };
    var setOverrideAddToCartLabelMaybe = function setOverrideAddToCartLabelMaybe(ctaConfig, overrideLabel) {
        var match = ctaConfig.primary;
        var match$1 = ctaConfig.secondary;
        var match$2 = ctaConfig.tertiary;
        var exit = 0;
        if (match !== undefined) {
            if (match.TAG === /* AddToCart */ 0) {
                var addToCartProps = match._0;
                return {
                    primary: {
                        TAG: /* AddToCart */ 0,
                        _0: {
                            textColor: addToCartProps.textColor,
                            bgColor: addToCartProps.bgColor,
                            label: addToCartProps.label,
                            overrideLabel: overrideLabel,
                            confirmationMessage: addToCartProps.confirmationMessage
                        }
                    },
                    secondary: ctaConfig.secondary,
                    tertiary: ctaConfig.tertiary
                };
            }
            exit = 2;
        } else exit = 2;
        if (exit === 2 && match$1 !== undefined && match$1.TAG === /* AddToCart */ 0) {
            var addToCartProps$1 = match$1._0;
            return {
                primary: ctaConfig.primary,
                secondary: {
                    TAG: /* AddToCart */ 0,
                    _0: {
                        textColor: addToCartProps$1.textColor,
                        bgColor: addToCartProps$1.bgColor,
                        label: addToCartProps$1.label,
                        overrideLabel: overrideLabel,
                        confirmationMessage: addToCartProps$1.confirmationMessage
                    }
                },
                tertiary: ctaConfig.tertiary
            };
        }
        if (match$2 === undefined) return ctaConfig;
        if (match$2.TAG !== /* AddToCart */ 0) return ctaConfig;
        var addToCartProps$2 = match$2._0;
        return {
            primary: ctaConfig.primary,
            secondary: ctaConfig.secondary,
            tertiary: {
                TAG: /* AddToCart */ 0,
                _0: {
                    textColor: addToCartProps$2.textColor,
                    bgColor: addToCartProps$2.bgColor,
                    label: addToCartProps$2.label,
                    overrideLabel: overrideLabel,
                    confirmationMessage: addToCartProps$2.confirmationMessage
                }
            }
        };
    };
    var ctaConfig$1 = setOverrideAddToCartLabelMaybe(moveUpTertiary(moveUpSecondary(moveUpPrimary(ctaConfig))), overrideAddToCartLabel$1);
    var match$8 = ctaConfig$1.primary;
    var primaryButton;
    if (primary && match$8 !== undefined) {
        var tmp = {
            product: product,
            variant: variant,
            cta: match$8,
            disableWhenOutOfStock: disableWhenOutOfStock,
            isPrimary: true,
            key: $7KlbQ.getKey(variant, product)
        };
        if (isMobile !== undefined) tmp.isMobile = isMobile;
        if (size !== undefined) tmp.size = $loT9g.valFromOption(size);
        if (tabIndex !== undefined) tmp.tabIndex = $loT9g.valFromOption(tabIndex);
        primaryButton = $loT9g.some(/*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement($4952b1f0ebd807e0$var$CTABar$CTAButtonWrapper, tmp), $2whNH.getWithDefault(extraButton, null)));
    } else primaryButton = undefined;
    var match$9 = ctaConfig$1.secondary;
    var secondaryButton;
    if (secondary && match$9 !== undefined) {
        var tmp$1 = {
            product: product,
            variant: variant,
            cta: match$9,
            key: $7KlbQ.getKey(variant, product)
        };
        if (isMobile !== undefined) tmp$1.isMobile = isMobile;
        if (size !== undefined) tmp$1.size = $loT9g.valFromOption(size);
        if (tabIndex !== undefined) tmp$1.tabIndex = $loT9g.valFromOption(tabIndex);
        secondaryButton = $loT9g.some(/*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement($4952b1f0ebd807e0$var$CTABar$CTAButtonWrapper, tmp$1)));
    } else secondaryButton = undefined;
    var match$10 = ctaConfig$1.tertiary;
    var tertiaryButton;
    if (tertiary && match$10 !== undefined && $4952b1f0ebd807e0$var$buttonExists(match$10, product, variant)) {
        var tmp$2 = {
            product: product,
            variant: variant,
            cta: match$10,
            key: $7KlbQ.getKey(variant, product)
        };
        if (isMobile !== undefined) tmp$2.isMobile = isMobile;
        if (size !== undefined) tmp$2.size = $loT9g.valFromOption(size);
        if (tabIndex !== undefined) tmp$2.tabIndex = $loT9g.valFromOption(tabIndex);
        tertiaryButton = $loT9g.some(/*#__PURE__*/ $g85JO.createElement($4952b1f0ebd807e0$var$CTABar$CTAButtonWrapper, tmp$2));
    } else tertiaryButton = undefined;
    var wrapButton = function wrapButton(className, button) {
        return $2whNH.mapWithDefault(button, null, function(btn) {
            return /*#__PURE__*/ $g85JO.createElement("div", {
                className: $1TRFX.make([
                    className,
                    $ezf3v.prefix("flex space-x-4")
                ])
            }, btn);
        });
    };
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("grid gap-4 grid-cols-12")
    }, secondaryButton !== undefined ? tertiaryButton !== undefined ? /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, wrapButton($ezf3v.prefix("col-span-12"), primaryButton), wrapButton($ezf3v.prefix("col-span-6"), secondaryButton), wrapButton($ezf3v.prefix("col-span-6"), tertiaryButton)) : /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, wrapButton($2whNH.isSome(extraButton) ? $ezf3v.prefix("col-span-5") : $ezf3v.prefix("col-span-6"), secondaryButton), wrapButton($2whNH.isSome(extraButton) ? $ezf3v.prefix("col-span-7") : $ezf3v.prefix("col-span-6"), primaryButton)) : tertiaryButton !== undefined ? /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, wrapButton($2whNH.isSome(extraButton) ? $ezf3v.prefix("col-span-5") : $ezf3v.prefix("col-span-6"), tertiaryButton), wrapButton($2whNH.isSome(extraButton) ? $ezf3v.prefix("col-span-7") : $ezf3v.prefix("col-span-6"), primaryButton)) : wrapButton($ezf3v.prefix("col-span-12"), primaryButton));
}
$4952b1f0ebd807e0$var$CTABar.displayName = "CTABar";
var $4952b1f0ebd807e0$export$dd44f18ab656f3bb = $4952b1f0ebd807e0$var$CTABar;
 /* context Not a pure module */ 
});

parcelRegister("j96aJ", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $df03a53e9cc9a507$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");
function $df03a53e9cc9a507$var$IconTimes(Props) {
    var className = Props.className;
    var strokeWidthOpt = Props.strokeWidth;
    var strokeWidth = strokeWidthOpt !== undefined ? strokeWidthOpt : "2";
    var tmp = {
        height: "13",
        width: "13",
        fill: "none",
        viewBox: "0 0 10 10",
        xmlns: "http://www.w3.org/2000/svg"
    };
    if (className !== undefined) tmp.className = $loT9g.valFromOption(className);
    return /*#__PURE__*/ $g85JO.createElement("svg", tmp, /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M9.53125 8.00391C9.77734 8.27734 9.77734 8.6875 9.53125 8.93359C9.25781 9.20703 8.84766 9.20703 8.60156 8.93359L5.375 5.67969L2.12109 8.93359C1.84766 9.20703 1.4375 9.20703 1.19141 8.93359C0.917969 8.6875 0.917969 8.27734 1.19141 8.00391L4.44531 4.75L1.19141 1.49609C0.917969 1.22266 0.917969 0.8125 1.19141 0.566406C1.4375 0.292969 1.84766 0.292969 2.09375 0.566406L5.375 3.84766L8.62891 0.59375C8.875 0.320312 9.28516 0.320312 9.53125 0.59375C9.80469 0.839844 9.80469 1.25 9.53125 1.52344L6.27734 4.75L9.53125 8.00391Z",
        fill: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: strokeWidth
    }));
}
$df03a53e9cc9a507$var$IconTimes.displayName = "IconTimes";
var $df03a53e9cc9a507$export$dd44f18ab656f3bb = $df03a53e9cc9a507$var$IconTimes;
 /* react Not a pure module */ 
});

parcelRegister("b0WLQ", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $804d486b642b7b54$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");
function $804d486b642b7b54$var$IconArrival(Props) {
    var className = Props.className;
    var strokeWidthOpt = Props.strokeWidth;
    var strokeWidth = strokeWidthOpt !== undefined ? strokeWidthOpt : "2";
    return /*#__PURE__*/ $g85JO.createElement("svg", {
        className: className,
        height: "15",
        width: "11",
        fill: "none",
        viewBox: "0 0 11 15",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M5.25 0.75C2.32422 0.75 0 3.10156 0 6C0 8.13281 0.710938 8.73438 4.70312 14.4766C4.83984 14.668 5.03125 14.75 5.25 14.75C5.44141 14.75 5.63281 14.668 5.76953 14.4766C9.76172 8.70703 10.5 8.13281 10.5 6C10.5 3.10156 8.14844 0.75 5.25 0.75ZM5.25 13.7109C1.39453 8.1875 0.875 7.75 0.875 6C0.875 3.59375 2.81641 1.625 5.25 1.625C7.65625 1.625 9.625 3.59375 9.625 6C9.625 7.75 9.07812 8.16016 5.25 13.7109ZM5.25 3.8125C4.01953 3.8125 3.0625 4.76953 3.0625 6C3.0625 7.20312 4.01953 8.1875 5.25 8.1875C6.45312 8.1875 7.4375 7.20312 7.4375 6C7.4375 4.76953 6.45312 3.8125 5.25 3.8125ZM5.25 7.3125C4.51172 7.3125 3.9375 6.71094 3.9375 6C3.9375 5.26172 4.51172 4.6875 5.25 4.6875C5.96094 4.6875 6.5625 5.26172 6.5625 6C6.5625 6.71094 5.96094 7.3125 5.25 7.3125Z",
        fill: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: strokeWidth
    }));
}
$804d486b642b7b54$var$IconArrival.displayName = "IconArrival";
var $804d486b642b7b54$export$dd44f18ab656f3bb = $804d486b642b7b54$var$IconArrival;
 /* react Not a pure module */ 
});

parcelRegister("l8eKb", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $f625c826fabe2b2c$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");
function $f625c826fabe2b2c$var$IconShipping(Props) {
    var className = Props.className;
    var strokeWidthOpt = Props.strokeWidth;
    var strokeWidth = strokeWidthOpt !== undefined ? strokeWidthOpt : "2";
    return /*#__PURE__*/ $g85JO.createElement("svg", {
        className: className,
        height: "15",
        width: "18",
        fill: "none",
        viewBox: "0 0 18 15",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M16.8438 10.8125H16.625V7.64062C16.625 7.12109 16.4062 6.62891 16.0234 6.27344L13.7539 3.97656C13.3711 3.59375 12.8789 3.375 12.332 3.375H11.375V2.28125C11.375 1.46094 10.6641 0.75 9.84375 0.75H1.53125C0.683594 0.75 0 1.46094 0 2.28125V10.5938C0 11.4414 0.683594 12.125 1.53125 12.125H1.75C1.75 13.5742 2.92578 14.75 4.375 14.75C5.82422 14.75 7 13.5742 7 12.125H10.5C10.5 13.5742 11.6758 14.75 13.125 14.75C14.5742 14.75 15.75 13.5742 15.75 12.125H16.8438C17.1992 12.125 17.5 11.8516 17.5 11.4961C17.5 11.168 17.1992 10.8125 16.8438 10.8125ZM4.375 13.4375C3.63672 13.4375 3.0625 12.8633 3.0625 12.125C3.0625 11.4141 3.63672 10.8125 4.375 10.8125C5.08594 10.8125 5.6875 11.4141 5.6875 12.125C5.6875 12.8633 5.08594 13.4375 4.375 13.4375ZM10.0625 10.8125H6.61719C6.17969 10.0469 5.33203 9.5 4.375 9.5C3.39062 9.5 2.54297 10.0469 2.10547 10.8125H1.53125C1.39453 10.8125 1.3125 10.7305 1.3125 10.5938V2.28125C1.3125 2.17188 1.39453 2.0625 1.53125 2.0625H9.84375C9.95312 2.0625 10.0625 2.17188 10.0625 2.28125V10.8125ZM11.375 4.6875H12.3594C12.5234 4.6875 12.6875 4.76953 12.8242 4.87891L14.8203 6.875H11.375V4.6875ZM13.125 13.4375C12.3867 13.4375 11.8125 12.8633 11.8125 12.125C11.8125 11.4141 12.3867 10.8125 13.125 10.8125C13.8359 10.8125 14.4375 11.4141 14.4375 12.125C14.4375 12.8633 13.8359 13.4375 13.125 13.4375ZM15.3125 10.7031C14.8203 9.99219 14.0273 9.5 13.125 9.5C12.4414 9.5 11.8398 9.77344 11.375 10.1836V8.1875H15.3125V10.7031Z",
        fill: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: strokeWidth
    }));
}
$f625c826fabe2b2c$var$IconShipping.displayName = "IconShipping";
var $f625c826fabe2b2c$export$dd44f18ab656f3bb = $f625c826fabe2b2c$var$IconShipping;
 /* react Not a pure module */ 
});

parcelRegister("1JV3u", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $1446406156ac16b5$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $gCzsf = parcelRequire("gCzsf");

var $5bEXW = parcelRequire("5bEXW");

var $fsiJD = parcelRequire("fsiJD");
function $1446406156ac16b5$var$PDPCTAWrapper(Props) {
    var style = Props.style;
    var className = Props.className;
    var initial = Props.initial;
    var onChangeVisibility = Props.onChangeVisibility;
    var children = Props.children;
    var match = $g85JO.useState(function() {
        return initial === /* Visible */ 3;
    });
    var setVisible = match[1];
    var visible = match[0];
    var ref = $g85JO.useRef(null);
    var getY = function getY(param) {
        return $2whNH.map($loT9g.nullable_to_opt(ref.current), function(el) {
            return el.getBoundingClientRect().y;
        });
    };
    var getVisibility = function getVisibility(visible) {
        var currentY = getY(undefined);
        if (visible) return /* Visible */ 3;
        else if (currentY !== undefined) {
            if (currentY > 0) return /* HiddenTop */ 0;
            else if (currentY < 0) return /* HiddenBottom */ 1;
            else return /* Hidden */ 2;
        } else return /* Hidden */ 2;
    };
    $g85JO.useEffect(function() {
        $2whNH.forEach(onChangeVisibility, function(cb) {
            $iv6Yc._1(cb, getVisibility(visible));
        });
    }, []);
    var tmp = {
        ref: $5bEXW.Ref.domRef(ref)
    };
    if (className !== undefined) tmp.className = $loT9g.valFromOption(className);
    if (style !== undefined) tmp.style = $loT9g.valFromOption(style);
    return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
        dataTestId: "pdp-cta-wrapper",
        children: /*#__PURE__*/ $g85JO.createElement("div", tmp, children, /*#__PURE__*/ $g85JO.createElement((0, (/*@__PURE__*/$parcel$interopDefault($fsiJD))), {
            partialVisibility: false,
            onChange: function onChange(visible) {
                var fn = function fn(param) {
                    return visible;
                };
                $iv6Yc._1(setVisible, function(previous) {
                    var next = $iv6Yc._1(fn, previous);
                    $2whNH.forEach(onChangeVisibility, function(cb) {
                        $iv6Yc._1(cb, getVisibility(next));
                    });
                    return next;
                });
            },
            children: /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("absolute top-0 left-0 w-full h-full pointer-events-none")
            })
        }))
    });
}
$1446406156ac16b5$var$PDPCTAWrapper.displayName = "PDPCTAWrapper";
var $1446406156ac16b5$export$dd44f18ab656f3bb = $1446406156ac16b5$var$PDPCTAWrapper;
 /* react Not a pure module */ 
});

parcelRegister("2DUkv", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $1ecaeb3a4c69753f$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $81N94 = parcelRequire("81N94");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $d3YYW = parcelRequire("d3YYW");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $tUpyX = parcelRequire("tUpyX");

var $1xf0g = parcelRequire("1xf0g");

var $55MCT = parcelRequire("55MCT");

var $9tGYJ = parcelRequire("9tGYJ");

var $dzlIC = parcelRequire("dzlIC");

var $5iu1A = parcelRequire("5iu1A");

var $aSJcu = parcelRequire("aSJcu");

var $lSYOv = parcelRequire("lSYOv");

var $8E2YL = parcelRequire("8E2YL");
function $1ecaeb3a4c69753f$export$8dcf39a7a23517d9(t) {
    var disable = $2whNH.isNone(t.image) && $2whNH.isNone(t.smallImage) && $2whNH.isNone(t.link);
    return {
        disable: disable,
        image: t.image,
        smallImage: t.smallImage,
        link: t.link,
        customScript: t.customScript,
        customAction: t.customAction
    };
}
function $1ecaeb3a4c69753f$var$SizeGuideModal$Modal(Props) {
    var isOpen = Props.isOpen;
    var data = Props.data;
    var label = Props.label;
    var onClose = Props.onClose;
    var match = $aSJcu.use(undefined);
    var viewportWidth = match.windowSize.width;
    var breakpoint = match.breakpoint;
    var match$1 = data.image;
    var match$2 = data.smallImage;
    var src = match$1 !== undefined ? match$2 !== undefined && breakpoint < 2 ? match$2 : match$1 : match$2 !== undefined ? match$2 : undefined;
    var match$3 = $9tGYJ.useImageSize($2whNH.getWithDefault(src, ""));
    var maxWidth = $81N94.int_min(match$3[0], 1366);
    var tmp = {
        children: src !== undefined ? /*#__PURE__*/ $g85JO.createElement($55MCT.Sized.make, {
            src: src,
            containerWidth: breakpoint >= 2 && maxWidth < viewportWidth ? maxWidth : viewportWidth,
            fit: /* ScaleDown */ 0,
            priority: 0,
            alt: label
        }) : null,
        isOpen: isOpen,
        onClose: onClose,
        label: label
    };
    if (data.link !== undefined) tmp.learnMoreLink = $loT9g.valFromOption(data.link);
    return /*#__PURE__*/ $g85JO.createElement($5iu1A.make, tmp);
}
$1ecaeb3a4c69753f$var$SizeGuideModal$Modal.displayName = "SizeGuideModal.Modal";
var $1ecaeb3a4c69753f$export$2b77a92f1a5ad772 = {
    make: $1ecaeb3a4c69753f$var$SizeGuideModal$Modal
};
function $1ecaeb3a4c69753f$export$444829f04e5dbdbc(sizeGuide, categories, activeCategoryId) {
    var match = sizeGuide.overrides;
    var override;
    if (activeCategoryId !== undefined && match !== undefined) {
        var overrides = $loT9g.valFromOption(match);
        var path = $1xf0g.getCategoryPathById(categories, activeCategoryId);
        var reversedPath = $i7mYY.reverse(path);
        override = $i7mYY.get($i7mYY.keepMap($i7mYY.map(reversedPath, function(item) {
            return $d3YYW.get(overrides, item.id);
        }), function(a) {
            return a;
        }), 0);
    } else override = undefined;
    return $2whNH.getWithDefault(override, $1ecaeb3a4c69753f$export$8dcf39a7a23517d9(sizeGuide));
}
function $1ecaeb3a4c69753f$var$SizeGuideModal(Props) {
    var sizeGuide = Props.sizeGuide;
    var activeCategoryId = Props.activeCategoryId;
    var product = Props.product;
    var variant = Props.variant;
    var match = $8E2YL.use(undefined);
    var match$1 = match.config;
    var transitiveAccount = match$1.transitiveAccount;
    var categories = match$1.categories;
    var subset = $g85JO.useMemo(function() {
        return $1ecaeb3a4c69753f$export$444829f04e5dbdbc(sizeGuide, categories, activeCategoryId);
    }, [
        activeCategoryId,
        match$1.lastModifiedAt
    ]);
    var match$2 = $g85JO.useState(function() {
        return false;
    });
    var setModalOpen = match$2[1];
    var modalOpen = match$2[0];
    var handleCustomScriptClick = function handleCustomScriptClick(code, e) {
        $2whNH.forEach(code, function(code) {
            $dzlIC.triggerCustomFunction(code, product, variant, undefined, "size guide", undefined, undefined);
        });
    };
    var customScript = $2whNH.keep(subset.customScript, function(code) {
        return code !== "";
    });
    var customAction = $2whNH.flatMap(subset.customAction, function(customActionId) {
        return $2whNH.flatMap(transitiveAccount, function(account) {
            return $i7mYY.getBy(account.customActions, function(a) {
                return $7bjme.equal(a.id, customActionId);
            });
        });
    });
    var renderButton = function renderButton(subset) {
        var className = $ezf3v.prefix("text-secondary text-lg font-normal underline cursor-pointer whitespace-nowrap");
        var match = subset.link;
        var match$1 = subset.image;
        var match$2 = subset.smallImage;
        var exit = 0;
        if (customAction !== undefined) {
            var partial_arg = customAction.onClickFn;
            return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement($lSYOv.make, {
                product: product,
                variant: variant,
                customAction: customAction,
                renderDefault: /*#__PURE__*/ $g85JO.createElement($tUpyX.make, {
                    children: sizeGuide.label,
                    unstyled: true,
                    className: className
                }),
                onClick: function onClick(param) {
                    return handleCustomScriptClick(partial_arg, param);
                }
            }));
        }
        if (customScript !== undefined) {
            var partial_arg$1 = customScript;
            return /*#__PURE__*/ $g85JO.createElement($tUpyX.make, {
                children: sizeGuide.label,
                unstyled: true,
                className: className,
                onClick: function onClick(param) {
                    return handleCustomScriptClick(partial_arg$1, param);
                }
            });
        }
        if (match !== undefined && match$1 === undefined) {
            if (match$2 === undefined) return /*#__PURE__*/ $g85JO.createElement($tUpyX.make, {
                children: sizeGuide.label,
                href: match,
                unstyled: true,
                className: className,
                openLinkInNewTab: true
            });
            if (match$2 === undefined) return null;
        } else exit = 2;
        if (exit === 2 && match$1 === undefined && match$2 === undefined) return null;
        return /*#__PURE__*/ $g85JO.createElement($tUpyX.make, {
            children: sizeGuide.label,
            unstyled: true,
            className: className,
            onClick: function onClick(param) {
                $iv6Yc._1(setModalOpen, function(param) {
                    return true;
                });
            }
        });
    };
    var renderModal = function renderModal(subset) {
        return /*#__PURE__*/ $g85JO.createElement($1ecaeb3a4c69753f$var$SizeGuideModal$Modal, {
            isOpen: modalOpen,
            data: subset,
            label: sizeGuide.label,
            onClose: function onClose(param) {
                $iv6Yc._1(setModalOpen, function(param) {
                    return false;
                });
            }
        });
    };
    return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, renderButton(subset), renderModal(subset));
}
$1ecaeb3a4c69753f$var$SizeGuideModal.displayName = "SizeGuideModal";
var $1ecaeb3a4c69753f$export$dd44f18ab656f3bb = $1ecaeb3a4c69753f$var$SizeGuideModal;
 /* react Not a pure module */ 
});
parcelRegister("lSYOv", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $feedd0731d3eedb7$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $dzlIC = parcelRequire("dzlIC");
function $feedd0731d3eedb7$var$CustomActionButton(Props) {
    var product = Props.product;
    var variant = Props.variant;
    var customAction = Props.customAction;
    var renderDefault = Props.renderDefault;
    var onClick = Props.onClick;
    var html = $2whNH.keep($2whNH.flatMap(customAction.renderFn, function(code) {
        return $dzlIC.triggerCustomFunctionReturningString(code, product, variant, "Size guide custom action", undefined, undefined);
    }), function(html) {
        return html.trim() !== "";
    });
    if (html !== undefined) return /*#__PURE__*/ $g85JO.createElement("span", {
        onClick: onClick,
        dangerouslySetInnerHTML: {
            __html: html
        }
    });
    else return /*#__PURE__*/ $g85JO.createElement("span", {
        onClick: onClick
    }, renderDefault);
}
$feedd0731d3eedb7$var$CustomActionButton.displayName = "CustomActionButton";
var $feedd0731d3eedb7$export$dd44f18ab656f3bb = $feedd0731d3eedb7$var$CustomActionButton;
 /* react Not a pure module */ 
});


parcelRegister("9KgIa", function(module, exports) {

$parcel$export(module.exports, "ColorPicker", function () { return $71855f7a7ca3f0f6$export$9feb1bc2e5f1ccb3; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $d3YYW = parcelRequire("d3YYW");

var $1ArWc = parcelRequire("1ArWc");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $7KlbQ = parcelRequire("7KlbQ");

var $1Ij4x = parcelRequire("1Ij4x");

var $9hKIs = parcelRequire("9hKIs");

var $4QUX0 = parcelRequire("4QUX0");

var $hBcYV = parcelRequire("hBcYV");

var $9pMGg = parcelRequire("9pMGg");

var $8E2YL = parcelRequire("8E2YL");
function $71855f7a7ca3f0f6$export$84137bb44359aed5(str) {
    try {
        return $loT9g.some(JSON.parse(str));
    } catch (e) {
        return;
    }
}
function $71855f7a7ca3f0f6$export$7ae2d2a8b28a8cb8(json) {
    return $i7mYY.map($2whNH.getWithDefault($2whNH.flatMap($2whNH.flatMap($1ArWc.decodeString(json), $71855f7a7ca3f0f6$export$84137bb44359aed5), $1ArWc.decodeArray), []), function(json) {
        return $i7mYY.reduce($d3YYW.entries($2whNH.getWithDefault($1ArWc.decodeObject(json), {})), {
            color: "",
            link: ""
        }, function(acc, param) {
            var value = param[1];
            switch(param[0]){
                case "color":
                    return {
                        color: $2whNH.getWithDefault($1ArWc.decodeString(value), ""),
                        link: acc.link
                    };
                case "link":
                    return {
                        color: acc.color,
                        link: $2whNH.getWithDefault($1ArWc.decodeString(value), "")
                    };
                default:
                    return acc;
            }
        });
    });
}
function $71855f7a7ca3f0f6$var$CustomerTheaterXyz$ColorPicker(Props) {
    var inline = Props.inline;
    var product = Props.product;
    $9pMGg.use(undefined);
    $8E2YL.use(undefined);
    $hBcYV.useRouter(undefined);
    var match = $9pMGg.use(undefined);
    var redirectToLink = match.redirectToLink;
    var isMatch = $2whNH.mapWithDefault(product.link, false, function(link) {
        return link.includes("theater.xyz");
    }) && !product.productType.toLowerCase().includes("perfume");
    var match$1 = $d3YYW.get(product.metadata, "custom::swatch_multiple_variants");
    var swatches = match$1 !== undefined ? typeof match$1 === "number" ? [] : match$1.TAG === /* Json */ 9 ? isMatch ? $71855f7a7ca3f0f6$export$7ae2d2a8b28a8cb8(match$1._0) : [] : [] : [];
    if (swatches.length <= 1) return null;
    var tmp = {
        options: $i7mYY.map(swatches, function(swatch) {
            return $4QUX0.makeOption("", "metafield-driven-color", swatch.color.startsWith("#") ? {
                TAG: /* ColorSwatch */ 1,
                _0: swatch.color
            } : {
                TAG: /* ImageSwatch */ 0,
                _0: "https://theater.xyz/cdn/shop/files/" + swatch.color
            }, !$7KlbQ.isInStock(product), false, swatch.color, "Color: " + swatch.color, swatch.link);
        }),
        kind: /* SwatchButton */ 1,
        circular: true,
        value: $2whNH.getWithDefault(product.link, ""),
        onChange: function onChange(value) {
            $2whNH.forEach(value, function(eta) {
                $iv6Yc._5(redirectToLink, undefined, undefined, undefined, undefined, eta);
            });
        }
    };
    var tmp$1 = inline ? 1 : undefined;
    if (tmp$1 !== undefined) tmp.truncateAt = tmp$1;
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            inline ? "mr-6" : "mt-6 mb-6"
        ]))
    }, /*#__PURE__*/ $g85JO.createElement($1Ij4x.Header.make, {
        active: product.id,
        id: product.id,
        className: $ezf3v.prefix("pb-2"),
        children: "Color"
    }), /*#__PURE__*/ $g85JO.createElement($9hKIs.make, tmp));
}
$71855f7a7ca3f0f6$var$CustomerTheaterXyz$ColorPicker.displayName = "CustomerTheaterXyz.ColorPicker";
var $71855f7a7ca3f0f6$export$9feb1bc2e5f1ccb3 = {
    make: $71855f7a7ca3f0f6$var$CustomerTheaterXyz$ColorPicker
};
 /* react Not a pure module */ 
});

parcelRegister("9FsAc", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $709e1d60cd74de86$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $d3YYW = parcelRequire("d3YYW");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $ezf3v = parcelRequire("ezf3v");

var $58Tj9 = parcelRequire("58Tj9");

var $c6E1z = parcelRequire("c6E1z");

var $7KlbQ = parcelRequire("7KlbQ");

var $hG39s = parcelRequire("hG39s");

var $1Ij4x = parcelRequire("1Ij4x");

var $9hKIs = parcelRequire("9hKIs");

var $4QUX0 = parcelRequire("4QUX0");

var $hBcYV = parcelRequire("hBcYV");

var $9pMGg = parcelRequire("9pMGg");

var $8E2YL = parcelRequire("8E2YL");
function $709e1d60cd74de86$var$MetafieldDrivenColorPicker$Picker(Props) {
    var matchHost = Props.matchHost;
    var productsMetafieldKey = Props.productsMetafieldKey;
    var getCustomSwatch = Props.getCustomSwatch;
    var getLabel = Props.getLabel;
    var labelPrefixOpt = Props.labelPrefix;
    var inline = Props.inline;
    var product = Props.product;
    var labelPrefix = labelPrefixOpt !== undefined ? labelPrefixOpt : "";
    var match = $9pMGg.use(undefined);
    var match$1 = $8E2YL.use(undefined);
    var match$2 = match$1.config;
    var match$3 = $hBcYV.useRouter(undefined);
    var goTo = match$3.goTo;
    var route = match$3.route;
    var isMatch = $2whNH.mapWithDefault(product.link, false, function(link) {
        return link.includes(matchHost);
    });
    var match$4 = $d3YYW.get(product.metadata, productsMetafieldKey);
    var productIds = match$4 !== undefined ? typeof match$4 === "number" ? [] : match$4.TAG === /* ListProductReference */ 27 ? isMatch ? $58Tj9.stableSortBy($i7mYY.map(match$4._0, $hG39s.ProductId.toString), function(a, b) {
        return a.localeCompare(b) | 0;
    }) : [] : [] : [];
    var label = $2whNH.flatMap(getLabel, function(fn) {
        return $iv6Yc._1(fn, product);
    });
    var match$5 = $c6E1z.useProductsById(match$2.transitiveStoreId, productIds, match$2.settings.hideOutOfStock, isMatch, "", match.smartnavApiHost, match.market, undefined);
    var products = match$5.products;
    if (products === undefined) return null;
    if (products.length === 0) return null;
    var tmp = {
        options: $i7mYY.map(products, function(product) {
            var swatch = $2whNH.flatMap(getCustomSwatch, function(fn) {
                return $iv6Yc._1(fn, product);
            });
            return $4QUX0.makeOption($2whNH.getWithDefault($2whNH.flatMap(getLabel, function(fn) {
                return $iv6Yc._1(fn, product);
            }), product.name), "metafield-driven-color", swatch !== undefined ? {
                TAG: /* ColorSwatch */ 1,
                _0: swatch
            } : {
                TAG: /* ImageSwatch */ 0,
                _0: $7KlbQ.getDisplaySwatchImage(product, product.firstVariant)
            }, !$7KlbQ.isInStock(product), false, product.id, product.name, product.id);
        }),
        kind: /* SwatchButton */ 1,
        value: product.id,
        onChange: function onChange(value) {
            if (typeof route === "number") return;
            switch(route.TAG | 0){
                case /* PDP */ 2:
                    var rest = route._0;
                    return $iv6Yc._3(goTo, undefined, undefined, {
                        TAG: /* PDP */ 2,
                        _0: {
                            categoryId: rest.categoryId,
                            productCategoryId: rest.productCategoryId,
                            productId: $2whNH.getWithDefault(value, rest.productId),
                            variantId: undefined,
                            zoomedPhotoIndex: rest.zoomedPhotoIndex
                        }
                    });
                case /* QuickView */ 3:
                    var rest$1 = route._0;
                    return $iv6Yc._3(goTo, undefined, undefined, {
                        TAG: /* QuickView */ 3,
                        _0: {
                            mediaId: rest$1.mediaId,
                            mediaParentId: rest$1.mediaParentId,
                            albumId: rest$1.albumId,
                            productId: value,
                            relatedMediaProductIds: rest$1.relatedMediaProductIds,
                            relatedMediaCategoryId: rest$1.relatedMediaCategoryId,
                            variantId: undefined,
                            panelClosed: rest$1.panelClosed,
                            zoomedPhotoIndex: rest$1.zoomedPhotoIndex,
                            time: rest$1.time
                        }
                    });
                default:
                    return;
            }
        }
    };
    var tmp$1 = inline ? 1 : undefined;
    if (tmp$1 !== undefined) tmp.truncateAt = tmp$1;
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            inline ? "mr-6" : "mt-6 mb-6"
        ]))
    }, /*#__PURE__*/ $g85JO.createElement($1Ij4x.Header.make, {
        active: product.id,
        id: product.id,
        className: $ezf3v.prefix("pb-2"),
        children: null
    }, labelPrefix, label !== undefined ? /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, ": ", /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("inline text-secondary font-bold")
    }, label)) : null), /*#__PURE__*/ $g85JO.createElement($9hKIs.make, tmp));
}
$709e1d60cd74de86$var$MetafieldDrivenColorPicker$Picker.displayName = "MetafieldDrivenColorPicker.Picker";
var $709e1d60cd74de86$export$ba25329847403e11 = {
    make: $709e1d60cd74de86$var$MetafieldDrivenColorPicker$Picker
};
function $709e1d60cd74de86$var$MetafieldDrivenColorPicker(Props) {
    var product = Props.product;
    var inlineOpt = Props.inline;
    var inline = inlineOpt !== undefined ? inlineOpt : false;
    return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement($709e1d60cd74de86$var$MetafieldDrivenColorPicker$Picker, {
        matchHost: "hyperiontiles.co.uk",
        productsMetafieldKey: "custom::sibling_products",
        getLabel: function getLabel(product) {
            return product.name;
        },
        labelPrefix: "Options Available",
        inline: inline,
        product: product
    }), /*#__PURE__*/ $g85JO.createElement($709e1d60cd74de86$var$MetafieldDrivenColorPicker$Picker, {
        matchHost: "pratapsons",
        productsMetafieldKey: "custom::variation_products",
        getLabel: function getLabel(product) {
            return $2whNH.map($d3YYW.get(product.metadata, "custom::variation_value"), function(metafield) {
                if (typeof metafield === "number" || metafield.TAG !== /* SingleLineTextField */ 1) return "";
                else return metafield._0;
            });
        },
        labelPrefix: "Color",
        inline: inline,
        product: product
    }), /*#__PURE__*/ $g85JO.createElement($709e1d60cd74de86$var$MetafieldDrivenColorPicker$Picker, {
        matchHost: "saadaa.in",
        productsMetafieldKey: "custom::product_variants",
        getCustomSwatch: function getCustomSwatch(product) {
            return $2whNH.map($d3YYW.get(product.metadata, "custom::product_variant_value"), function(metafield) {
                if (typeof metafield === "number" || metafield.TAG !== /* SingleLineTextField */ 1) return "";
                else return metafield._0;
            });
        },
        getLabel: function getLabel(product) {
            return $2whNH.map($d3YYW.get(product.metadata, "custom::product_variant_name"), function(metafield) {
                if (typeof metafield === "number" || metafield.TAG !== /* SingleLineTextField */ 1) return "";
                else return metafield._0;
            });
        },
        labelPrefix: "Color",
        inline: inline,
        product: product
    }), /*#__PURE__*/ $g85JO.createElement($709e1d60cd74de86$var$MetafieldDrivenColorPicker$Picker, {
        matchHost: "pantproject.com",
        productsMetafieldKey: "custom::color_variants",
        getCustomSwatch: function getCustomSwatch(product) {
            return $2whNH.map($d3YYW.get(product.metadata, "custom::color_hex_code"), function(metafield) {
                if (typeof metafield === "number" || metafield.TAG !== /* SingleLineTextField */ 1) return "";
                else return metafield._0;
            });
        },
        getLabel: function getLabel(product) {
            return product.name;
        },
        labelPrefix: "Color",
        inline: inline,
        product: product
    }));
}
$709e1d60cd74de86$var$MetafieldDrivenColorPicker.displayName = "MetafieldDrivenColorPicker";
var $709e1d60cd74de86$export$dd44f18ab656f3bb = $709e1d60cd74de86$var$MetafieldDrivenColorPicker;
 /* react Not a pure module */ 
});


parcelRegister("bmEf1", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $8460f6e3ddb8e3bd$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $55MCT = parcelRequire("55MCT");

var $2ZaET = parcelRequire("2ZaET");
function $8460f6e3ddb8e3bd$var$ProductCardHoverImage(Props) {
    var src = Props.src;
    var fit = Props.fit;
    var alt = Props.alt;
    var priority = Props.priority;
    var onImageRendered = Props.onImageRendered;
    var enabled = Props.enabled;
    var match = $g85JO.useState(function() {
        return false;
    });
    var setIsLoaded = match[1];
    $g85JO.useEffect(function() {
        $iv6Yc._1(setIsLoaded, function(param) {
            return false;
        });
    }, [
        src
    ]);
    var handleOnLoad = function handleOnLoad($$event) {
        $iv6Yc._1(setIsLoaded, function(param) {
            if ($$event.imageSize.width >= $$event.width) return $$event.imageSize.height >= $$event.height;
            else return false;
        });
    };
    var backgroundCn = match[0] ? "bg-placeholder" : "";
    var tmp = {
        src: src,
        fit: fit,
        alt: alt,
        priority: priority,
        onLoad: handleOnLoad
    };
    if (onImageRendered !== undefined) tmp.onRender = $loT9g.valFromOption(onImageRendered);
    return /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: enabled,
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix($1TRFX.make([
                "transition-opacity duration-300 absolute inset-0 flex items-center justify-center",
                "group-2-hover:opacity-100 opacity-0",
                backgroundCn
            ]))
        }, /*#__PURE__*/ $g85JO.createElement($55MCT.make, tmp))
    });
}
$8460f6e3ddb8e3bd$var$ProductCardHoverImage.displayName = "ProductCardHoverImage";
var $8460f6e3ddb8e3bd$export$dd44f18ab656f3bb = $8460f6e3ddb8e3bd$var$ProductCardHoverImage;
 /* react Not a pure module */ 
});


})();
//# sourceMappingURL=QuickViewOverlay.bs.322bcffb.js.map
